(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireddfb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireddfb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Cb2l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7000395ebed418fa$export$2e2bcd8739ae039; });
// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

var $86RGX = parcelRequire("86RGX");
var $7000395ebed418fa$export$2e2bcd8739ae039 = (0, $86RGX.createConsumer)();

});
parcelRegister("86RGX", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var adapters = {
        logger: self.console,
        WebSocket: self.WebSocket
    };
    var logger = {
        log: function log() {
            if (this.enabled) {
                var _adapters$logger;
                for(var _len = arguments.length, messages = Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
                messages.push(Date.now());
                (_adapters$logger = adapters.logger).log.apply(_adapters$logger, [
                    "[ActionCable]"
                ].concat(messages));
            }
        }
    };
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var now = function now() {
        return new Date().getTime();
    };
    var secondsSince = function secondsSince(time) {
        return (now() - time) / 1e3;
    };
    var clamp = function clamp(number, min, max) {
        return Math.max(min, Math.min(max, number));
    };
    var ConnectionMonitor = function() {
        function ConnectionMonitor(connection) {
            classCallCheck(this, ConnectionMonitor);
            this.visibilityDidChange = this.visibilityDidChange.bind(this);
            this.connection = connection;
            this.reconnectAttempts = 0;
        }
        ConnectionMonitor.prototype.start = function start() {
            if (!this.isRunning()) {
                this.startedAt = now();
                delete this.stoppedAt;
                this.startPolling();
                addEventListener("visibilitychange", this.visibilityDidChange);
                logger.log("ConnectionMonitor started. pollInterval = " + this.getPollInterval() + " ms");
            }
        };
        ConnectionMonitor.prototype.stop = function stop() {
            if (this.isRunning()) {
                this.stoppedAt = now();
                this.stopPolling();
                removeEventListener("visibilitychange", this.visibilityDidChange);
                logger.log("ConnectionMonitor stopped");
            }
        };
        ConnectionMonitor.prototype.isRunning = function isRunning() {
            return this.startedAt && !this.stoppedAt;
        };
        ConnectionMonitor.prototype.recordPing = function recordPing() {
            this.pingedAt = now();
        };
        ConnectionMonitor.prototype.recordConnect = function recordConnect() {
            this.reconnectAttempts = 0;
            this.recordPing();
            delete this.disconnectedAt;
            logger.log("ConnectionMonitor recorded connect");
        };
        ConnectionMonitor.prototype.recordDisconnect = function recordDisconnect() {
            this.disconnectedAt = now();
            logger.log("ConnectionMonitor recorded disconnect");
        };
        ConnectionMonitor.prototype.startPolling = function startPolling() {
            this.stopPolling();
            this.poll();
        };
        ConnectionMonitor.prototype.stopPolling = function stopPolling() {
            clearTimeout(this.pollTimeout);
        };
        ConnectionMonitor.prototype.poll = function poll() {
            var _this = this;
            this.pollTimeout = setTimeout(function() {
                _this.reconnectIfStale();
                _this.poll();
            }, this.getPollInterval());
        };
        ConnectionMonitor.prototype.getPollInterval = function getPollInterval() {
            var _constructor$pollInte = this.constructor.pollInterval, min = _constructor$pollInte.min, max = _constructor$pollInte.max, multiplier = _constructor$pollInte.multiplier;
            var interval = multiplier * Math.log(this.reconnectAttempts + 1);
            return Math.round(clamp(interval, min, max) * 1e3);
        };
        ConnectionMonitor.prototype.reconnectIfStale = function reconnectIfStale() {
            if (this.connectionIsStale()) {
                logger.log("ConnectionMonitor detected stale connection. reconnectAttempts = " + this.reconnectAttempts + ", pollInterval = " + this.getPollInterval() + " ms, time disconnected = " + secondsSince(this.disconnectedAt) + " s, stale threshold = " + this.constructor.staleThreshold + " s");
                this.reconnectAttempts++;
                if (this.disconnectedRecently()) logger.log("ConnectionMonitor skipping reopening recent disconnect");
                else {
                    logger.log("ConnectionMonitor reopening");
                    this.connection.reopen();
                }
            }
        };
        ConnectionMonitor.prototype.connectionIsStale = function connectionIsStale() {
            return secondsSince(this.pingedAt ? this.pingedAt : this.startedAt) > this.constructor.staleThreshold;
        };
        ConnectionMonitor.prototype.disconnectedRecently = function disconnectedRecently() {
            return this.disconnectedAt && secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
        };
        ConnectionMonitor.prototype.visibilityDidChange = function visibilityDidChange() {
            var _this2 = this;
            if (document.visibilityState === "visible") setTimeout(function() {
                if (_this2.connectionIsStale() || !_this2.connection.isOpen()) {
                    logger.log("ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = " + document.visibilityState);
                    _this2.connection.reopen();
                }
            }, 200);
        };
        return ConnectionMonitor;
    }();
    ConnectionMonitor.pollInterval = {
        min: 3,
        max: 30,
        multiplier: 5
    };
    ConnectionMonitor.staleThreshold = 6;
    var INTERNAL = {
        message_types: {
            welcome: "welcome",
            disconnect: "disconnect",
            ping: "ping",
            confirmation: "confirm_subscription",
            rejection: "reject_subscription"
        },
        disconnect_reasons: {
            unauthorized: "unauthorized",
            invalid_request: "invalid_request",
            server_restart: "server_restart"
        },
        default_mount_path: "/cable",
        protocols: [
            "actioncable-v1-json",
            "actioncable-unsupported"
        ]
    };
    var message_types = INTERNAL.message_types, protocols = INTERNAL.protocols;
    var supportedProtocols = protocols.slice(0, protocols.length - 1);
    var indexOf = [].indexOf;
    var Connection = function() {
        function Connection(consumer) {
            classCallCheck(this, Connection);
            this.open = this.open.bind(this);
            this.consumer = consumer;
            this.subscriptions = this.consumer.subscriptions;
            this.monitor = new ConnectionMonitor(this);
            this.disconnected = true;
        }
        Connection.prototype.send = function send(data) {
            if (this.isOpen()) {
                this.webSocket.send(JSON.stringify(data));
                return true;
            } else return false;
        };
        Connection.prototype.open = function open() {
            if (this.isActive()) {
                logger.log("Attempted to open WebSocket, but existing socket is " + this.getState());
                return false;
            } else {
                logger.log("Opening WebSocket, current state is " + this.getState() + ", subprotocols: " + protocols);
                if (this.webSocket) this.uninstallEventHandlers();
                this.webSocket = new adapters.WebSocket(this.consumer.url, protocols);
                this.installEventHandlers();
                this.monitor.start();
                return true;
            }
        };
        Connection.prototype.close = function close() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                allowReconnect: true
            }, allowReconnect = _ref.allowReconnect;
            if (!allowReconnect) this.monitor.stop();
            if (this.isActive()) return this.webSocket.close();
        };
        Connection.prototype.reopen = function reopen() {
            logger.log("Reopening WebSocket, current state is " + this.getState());
            if (this.isActive()) try {
                return this.close();
            } catch (error) {
                logger.log("Failed to reopen WebSocket", error);
            } finally{
                logger.log("Reopening WebSocket in " + this.constructor.reopenDelay + "ms");
                setTimeout(this.open, this.constructor.reopenDelay);
            }
            else return this.open();
        };
        Connection.prototype.getProtocol = function getProtocol() {
            if (this.webSocket) return this.webSocket.protocol;
        };
        Connection.prototype.isOpen = function isOpen() {
            return this.isState("open");
        };
        Connection.prototype.isActive = function isActive() {
            return this.isState("open", "connecting");
        };
        Connection.prototype.isProtocolSupported = function isProtocolSupported() {
            return indexOf.call(supportedProtocols, this.getProtocol()) >= 0;
        };
        Connection.prototype.isState = function isState() {
            for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
            return indexOf.call(states, this.getState()) >= 0;
        };
        Connection.prototype.getState = function getState() {
            if (this.webSocket) for(var state in adapters.WebSocket){
                if (adapters.WebSocket[state] === this.webSocket.readyState) return state.toLowerCase();
            }
            return null;
        };
        Connection.prototype.installEventHandlers = function installEventHandlers() {
            for(var eventName in this.events){
                var handler = this.events[eventName].bind(this);
                this.webSocket["on" + eventName] = handler;
            }
        };
        Connection.prototype.uninstallEventHandlers = function uninstallEventHandlers() {
            for(var eventName in this.events)this.webSocket["on" + eventName] = function() {};
        };
        return Connection;
    }();
    Connection.reopenDelay = 500;
    Connection.prototype.events = {
        message: function message(event) {
            if (!this.isProtocolSupported()) return;
            var _JSON$parse = JSON.parse(event.data), identifier = _JSON$parse.identifier, message = _JSON$parse.message, reason = _JSON$parse.reason, reconnect = _JSON$parse.reconnect, type = _JSON$parse.type;
            switch(type){
                case message_types.welcome:
                    this.monitor.recordConnect();
                    return this.subscriptions.reload();
                case message_types.disconnect:
                    logger.log("Disconnecting. Reason: " + reason);
                    return this.close({
                        allowReconnect: reconnect
                    });
                case message_types.ping:
                    return this.monitor.recordPing();
                case message_types.confirmation:
                    this.subscriptions.confirmSubscription(identifier);
                    return this.subscriptions.notify(identifier, "connected");
                case message_types.rejection:
                    return this.subscriptions.reject(identifier);
                default:
                    return this.subscriptions.notify(identifier, "received", message);
            }
        },
        open: function open() {
            logger.log("WebSocket onopen event, using '" + this.getProtocol() + "' subprotocol");
            this.disconnected = false;
            if (!this.isProtocolSupported()) {
                logger.log("Protocol is unsupported. Stopping monitor and disconnecting.");
                return this.close({
                    allowReconnect: false
                });
            }
        },
        close: function close(event) {
            logger.log("WebSocket onclose event");
            if (this.disconnected) return;
            this.disconnected = true;
            this.monitor.recordDisconnect();
            return this.subscriptions.notifyAll("disconnected", {
                willAttemptReconnect: this.monitor.isRunning()
            });
        },
        error: function error() {
            logger.log("WebSocket onerror event");
        }
    };
    var extend = function extend(object, properties) {
        if (properties != null) for(var key in properties){
            var value = properties[key];
            object[key] = value;
        }
        return object;
    };
    var Subscription = function() {
        function Subscription(consumer) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var mixin = arguments[2];
            classCallCheck(this, Subscription);
            this.consumer = consumer;
            this.identifier = JSON.stringify(params);
            extend(this, mixin);
        }
        Subscription.prototype.perform = function perform(action) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            data.action = action;
            return this.send(data);
        };
        Subscription.prototype.send = function send(data) {
            return this.consumer.send({
                command: "message",
                identifier: this.identifier,
                data: JSON.stringify(data)
            });
        };
        Subscription.prototype.unsubscribe = function unsubscribe() {
            return this.consumer.subscriptions.remove(this);
        };
        return Subscription;
    }();
    var SubscriptionGuarantor = function() {
        function SubscriptionGuarantor(subscriptions) {
            classCallCheck(this, SubscriptionGuarantor);
            this.subscriptions = subscriptions;
            this.pendingSubscriptions = [];
        }
        SubscriptionGuarantor.prototype.guarantee = function guarantee(subscription) {
            if (this.pendingSubscriptions.indexOf(subscription) == -1) {
                logger.log("SubscriptionGuarantor guaranteeing " + subscription.identifier);
                this.pendingSubscriptions.push(subscription);
            } else logger.log("SubscriptionGuarantor already guaranteeing " + subscription.identifier);
            this.startGuaranteeing();
        };
        SubscriptionGuarantor.prototype.forget = function forget(subscription) {
            logger.log("SubscriptionGuarantor forgetting " + subscription.identifier);
            this.pendingSubscriptions = this.pendingSubscriptions.filter(function(s) {
                return s !== subscription;
            });
        };
        SubscriptionGuarantor.prototype.startGuaranteeing = function startGuaranteeing() {
            this.stopGuaranteeing();
            this.retrySubscribing();
        };
        SubscriptionGuarantor.prototype.stopGuaranteeing = function stopGuaranteeing() {
            clearTimeout(this.retryTimeout);
        };
        SubscriptionGuarantor.prototype.retrySubscribing = function retrySubscribing() {
            var _this = this;
            this.retryTimeout = setTimeout(function() {
                if (_this.subscriptions && typeof _this.subscriptions.subscribe === "function") _this.pendingSubscriptions.map(function(subscription) {
                    logger.log("SubscriptionGuarantor resubscribing " + subscription.identifier);
                    _this.subscriptions.subscribe(subscription);
                });
            }, 500);
        };
        return SubscriptionGuarantor;
    }();
    var Subscriptions = function() {
        function Subscriptions(consumer) {
            classCallCheck(this, Subscriptions);
            this.consumer = consumer;
            this.guarantor = new SubscriptionGuarantor(this);
            this.subscriptions = [];
        }
        Subscriptions.prototype.create = function create(channelName, mixin) {
            var channel = channelName;
            var params = (typeof channel === "undefined" ? "undefined" : _typeof(channel)) === "object" ? channel : {
                channel: channel
            };
            var subscription = new Subscription(this.consumer, params, mixin);
            return this.add(subscription);
        };
        Subscriptions.prototype.add = function add(subscription) {
            this.subscriptions.push(subscription);
            this.consumer.ensureActiveConnection();
            this.notify(subscription, "initialized");
            this.subscribe(subscription);
            return subscription;
        };
        Subscriptions.prototype.remove = function remove(subscription) {
            this.forget(subscription);
            if (!this.findAll(subscription.identifier).length) this.sendCommand(subscription, "unsubscribe");
            return subscription;
        };
        Subscriptions.prototype.reject = function reject(identifier) {
            var _this = this;
            return this.findAll(identifier).map(function(subscription) {
                _this.forget(subscription);
                _this.notify(subscription, "rejected");
                return subscription;
            });
        };
        Subscriptions.prototype.forget = function forget(subscription) {
            this.guarantor.forget(subscription);
            this.subscriptions = this.subscriptions.filter(function(s) {
                return s !== subscription;
            });
            return subscription;
        };
        Subscriptions.prototype.findAll = function findAll(identifier) {
            return this.subscriptions.filter(function(s) {
                return s.identifier === identifier;
            });
        };
        Subscriptions.prototype.reload = function reload() {
            var _this2 = this;
            return this.subscriptions.map(function(subscription) {
                return _this2.subscribe(subscription);
            });
        };
        Subscriptions.prototype.notifyAll = function notifyAll(callbackName) {
            var _this3 = this;
            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return this.subscriptions.map(function(subscription) {
                return _this3.notify.apply(_this3, [
                    subscription,
                    callbackName
                ].concat(args));
            });
        };
        Subscriptions.prototype.notify = function notify(subscription, callbackName) {
            for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
            var subscriptions = void 0;
            if (typeof subscription === "string") subscriptions = this.findAll(subscription);
            else subscriptions = [
                subscription
            ];
            return subscriptions.map(function(subscription) {
                return typeof subscription[callbackName] === "function" ? subscription[callbackName].apply(subscription, args) : undefined;
            });
        };
        Subscriptions.prototype.subscribe = function subscribe(subscription) {
            if (this.sendCommand(subscription, "subscribe")) this.guarantor.guarantee(subscription);
        };
        Subscriptions.prototype.confirmSubscription = function confirmSubscription(identifier) {
            var _this4 = this;
            logger.log("Subscription confirmed " + identifier);
            this.findAll(identifier).map(function(subscription) {
                return _this4.guarantor.forget(subscription);
            });
        };
        Subscriptions.prototype.sendCommand = function sendCommand(subscription, command) {
            var identifier = subscription.identifier;
            return this.consumer.send({
                command: command,
                identifier: identifier
            });
        };
        return Subscriptions;
    }();
    var Consumer = function() {
        function Consumer(url) {
            classCallCheck(this, Consumer);
            this._url = url;
            this.subscriptions = new Subscriptions(this);
            this.connection = new Connection(this);
        }
        Consumer.prototype.send = function send(data) {
            return this.connection.send(data);
        };
        Consumer.prototype.connect = function connect() {
            return this.connection.open();
        };
        Consumer.prototype.disconnect = function disconnect() {
            return this.connection.close({
                allowReconnect: false
            });
        };
        Consumer.prototype.ensureActiveConnection = function ensureActiveConnection() {
            if (!this.connection.isActive()) return this.connection.open();
        };
        createClass(Consumer, [
            {
                key: "url",
                get: function get$$1() {
                    return createWebSocketURL(this._url);
                }
            }
        ]);
        return Consumer;
    }();
    function createWebSocketURL(url) {
        if (typeof url === "function") url = url();
        if (url && !/^wss?:/i.test(url)) {
            var a = document.createElement("a");
            a.href = url;
            a.href = a.href;
            a.protocol = a.protocol.replace("http", "ws");
            return a.href;
        } else return url;
    }
    function createConsumer() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getConfig("url") || INTERNAL.default_mount_path;
        return new Consumer(url);
    }
    function getConfig(name) {
        var element = document.head.querySelector("meta[name='action-cable-" + name + "']");
        if (element) return element.getAttribute("content");
    }
    exports1.Connection = Connection;
    exports1.ConnectionMonitor = ConnectionMonitor;
    exports1.Consumer = Consumer;
    exports1.INTERNAL = INTERNAL;
    exports1.Subscription = Subscription;
    exports1.Subscriptions = Subscriptions;
    exports1.SubscriptionGuarantor = SubscriptionGuarantor;
    exports1.adapters = adapters;
    exports1.createWebSocketURL = createWebSocketURL;
    exports1.logger = logger;
    exports1.createConsumer = createConsumer;
    exports1.getConfig = getConfig;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});


parcelRegister("oT77L", function(module, exports) {

var $9Cb2l = parcelRequire("9Cb2l");
let $04acfe7ab113d0f5$var$ice;
let $04acfe7ab113d0f5$var$pc;
const $04acfe7ab113d0f5$var$startPeerConnect = ()=>{
    let video = document.querySelector("video");
    $04acfe7ab113d0f5$var$ice = {
        iceServers: ICE_SERVERS
    };
    $04acfe7ab113d0f5$var$pc = new RTCPeerConnection($04acfe7ab113d0f5$var$ice);
    $04acfe7ab113d0f5$var$pc.ontrack = (e)=>{
        video.srcObject = e.streams[0];
    };
    $04acfe7ab113d0f5$var$pc.onicecandidate = (event)=>{
        $04acfe7ab113d0f5$var$sendData({
            candidate: JSON.stringify(event.candidate),
            message_type: 8
        });
    };
};
const $04acfe7ab113d0f5$var$addIceCandidate = (data)=>{
    try {
        $04acfe7ab113d0f5$var$pc.addIceCandidate(new RTCIceCandidate(JSON.parse(data.candidate)));
    } catch (error) {
        $04acfe7ab113d0f5$var$logError(error);
    }
};
const $04acfe7ab113d0f5$var$setRemoteDescription = (data)=>{
    const sdp = JSON.parse(data.sdp);
    $04acfe7ab113d0f5$var$pc.setRemoteDescription(new RTCSessionDescription(sdp)).then(()=>{
        if (sdp.type === "offer") $04acfe7ab113d0f5$var$pc.createAnswer().then((answer)=>{
            return $04acfe7ab113d0f5$var$pc.setLocalDescription(answer);
        }).then(()=>{
            $04acfe7ab113d0f5$var$sendData({
                sdp: JSON.stringify($04acfe7ab113d0f5$var$pc.localDescription),
                message_type: 7
            });
        });
    }).catch($04acfe7ab113d0f5$var$logError);
};
window.readStream = (session_token)=>{
    window.socket_channel = (0, $9Cb2l.default).subscriptions.create({
        channel: "RepeaterChannel",
        session_token: session_token
    }, {
        connected: ()=>{
            console.log("ready to accept stream: " + session_token);
            $04acfe7ab113d0f5$var$sendData({
                init: true,
                message_type: 6
            });
            $04acfe7ab113d0f5$var$startPeerConnect();
        },
        received: (data)=>{
            console.log(data);
            if (data.sdp) $04acfe7ab113d0f5$var$setRemoteDescription(data);
            if (data.candidate) $04acfe7ab113d0f5$var$addIceCandidate(data);
            if (data.session_ended) {
                clearInterval(window.intervalId);
                if (live) alert("Player has left the game session.");
            }
        }
    });
};
const $04acfe7ab113d0f5$var$sendData = (data)=>{
    data.action = "rtc_subscribe";
    console.log(data);
    window.socket_channel.send(data);
};
const $04acfe7ab113d0f5$var$logError = (error)=>{
    console.warn("Whoops! Error:", error);
    $04acfe7ab113d0f5$var$sendData({
        error: error
    });
};

});

parcelRegister("716RA", function(module, exports) {

var $9Cb2l = parcelRequire("9Cb2l");
let $51bdf34abd78bedd$var$ice;
let $51bdf34abd78bedd$var$pc;
const $51bdf34abd78bedd$var$startPeerConnect = ()=>{
    let canvas = document.querySelector("#unityContainer canvas");
    $51bdf34abd78bedd$var$ice = {
        iceServers: ICE_SERVERS
    };
    $51bdf34abd78bedd$var$pc = new RTCPeerConnection($51bdf34abd78bedd$var$ice);
    let stream = canvas.captureStream();
    stream.getTracks().forEach((track)=>{
        $51bdf34abd78bedd$var$pc.addTrack(track, stream);
    });
    $51bdf34abd78bedd$var$pc.onicecandidate = (event)=>{
        $51bdf34abd78bedd$var$sendData({
            candidate: JSON.stringify(event.candidate)
        });
    };
    $51bdf34abd78bedd$var$pc.createOffer().then((offer)=>{
        return $51bdf34abd78bedd$var$pc.setLocalDescription(offer);
    }).then(()=>{
        $51bdf34abd78bedd$var$sendData({
            sdp: JSON.stringify($51bdf34abd78bedd$var$pc.localDescription)
        });
    }).catch($51bdf34abd78bedd$var$logError);
};
const $51bdf34abd78bedd$var$addIceCandidate = (data)=>{
    try {
        $51bdf34abd78bedd$var$pc.addIceCandidate(new RTCIceCandidate(JSON.parse(data.candidate)));
    } catch (error) {
        $51bdf34abd78bedd$var$logError(error);
    }
};
const $51bdf34abd78bedd$var$setRemoteDescription = (data)=>{
    try {
        $51bdf34abd78bedd$var$pc.setRemoteDescription(new RTCSessionDescription(JSON.parse(data.sdp)));
    } catch (error) {
        $51bdf34abd78bedd$var$logError(error);
    }
};
window.createSubscription = (session_token, student_code)=>{
    try {
        ahoy.track("Session Started", {
            session_token: session_token
        });
    } catch (error) {}
    window.socket_channel = (0, $9Cb2l.default).subscriptions.create({
        channel: "StreamChannel",
        session_token: session_token,
        student_code: student_code
    }, {
        connected: ()=>{
            console.log("starting stream: " + session_token);
        },
        received: (data)=>{
            console.log(data);
            if (data.init) $51bdf34abd78bedd$var$startPeerConnect();
            if (data.sdp) $51bdf34abd78bedd$var$setRemoteDescription(data);
            if (data.candidate) $51bdf34abd78bedd$var$addIceCandidate(data);
            if (data.session_end) {
                window.onbeforeunload = null;
                window.location.replace("/session_complete?session_id=" + session_token);
            }
        }
    });
    var url = document.querySelector("#root-url").dataset["url"];
    return url;
};
const $51bdf34abd78bedd$var$sendData = (data)=>{
    data.action = "rtc_subscribe";
    console.log(data);
    window.socket_channel.send(data);
};
const $51bdf34abd78bedd$var$logError = (error)=>{
    console.warn("Whoops! Error:", error);
    $51bdf34abd78bedd$var$sendData({
        error: error
    });
};

});

parcelRegister("6p2TQ", function(module, exports) {
/*! For license information please see rollbar.umd.min.js.LICENSE.txt */ !function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function() {
        "use strict";
        var t = {
            d: function(e, r) {
                for(var n in r)t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, {
                    enumerable: !0,
                    get: r[n]
                });
            },
            o: function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            },
            r: function(t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            }
        }, e = {};
        t.d(e, {
            default: function() {
                return eo;
            }
        });
        var r = {};
        function n(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return o(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, i = function() {};
                    return {
                        s: i,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: i
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var a, s = !0, u = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return s = t.done, t;
                },
                e: function(t) {
                    u = !0, a = t;
                },
                f: function() {
                    try {
                        s || null == r.return || r.return();
                    } finally{
                        if (u) throw a;
                    }
                }
            };
        }
        function o(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function i(t) {
            return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, i(t);
        }
        function a(t, e) {
            return e === s(t);
        }
        function s(t) {
            var e = i(t);
            return "object" !== e ? e : t ? t instanceof Error ? "error" : ({}).toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
        }
        function u(t) {
            return a(t, "function");
        }
        function l(t) {
            return null != t && ("object" == i(t) || "function" == typeof t);
        }
        function c(t, e) {
            return null != t && (Object.hasOwn ? Object.hasOwn(t, e) : Object.prototype.hasOwnProperty.call(t, e));
        }
        function f(t) {
            return Number.isFinite(t);
        }
        function p(t) {
            return a(t, "error") || a(t, "exception");
        }
        function d() {
            return "********";
        }
        t.r(r), t.d(r, {
            parse: function() {
                return hn;
            }
        });
        var h = {
            debug: 0,
            info: 1,
            warning: 2,
            error: 3,
            critical: 4
        };
        function y(t) {
            var e = function(t) {
                if (!a(t, "string")) return;
                for(var e = v, r = e.parser[e.strictMode ? "strict" : "loose"].exec(t), n = {}, o = 0, i = e.key.length; o < i; ++o)n[e.key[o]] = r[o] || "";
                return n[e.q.name] = {}, n[e.key[12]].replace(e.q.parser, function(t, r, o) {
                    r && (n[e.q.name][r] = o);
                }), n;
            }(t);
            return e ? ("" === e.anchor && (e.source = e.source.replace("#", "")), t = e.source.replace("?" + e.query, "")) : "(unknown)";
        }
        var v = {
            strictMode: !1,
            key: [
                "source",
                "protocol",
                "authority",
                "userInfo",
                "user",
                "password",
                "host",
                "port",
                "relative",
                "path",
                "directory",
                "file",
                "query",
                "anchor"
            ],
            q: {
                name: "queryKey",
                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
            },
            parser: {
                strict: /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose: /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
            }
        };
        function m(t, e) {
            if (!(e = e || t.protocol) && t.port && (80 === t.port ? e = "http:" : 443 === t.port && (e = "https:")), e = e || "https:", !t.hostname) return null;
            var r = e + "//" + t.hostname;
            return t.port && (r = r + ":" + t.port), t.path && (r += t.path), r;
        }
        function b(t, e) {
            var r, n;
            try {
                r = JSON.stringify(t);
            } catch (o) {
                if (e && u(e)) try {
                    r = e(t);
                } catch (t) {
                    n = t;
                }
                else n = o;
            }
            return {
                error: n,
                value: r
            };
        }
        function g(t) {
            var e, r;
            try {
                e = JSON.parse(t);
            } catch (t) {
                r = t;
            }
            return {
                error: r,
                value: e
            };
        }
        function w(t, e, r, n, o, i, a, s) {
            var u = {
                url: e || "",
                line: r,
                column: n
            };
            u.func = s.guessFunctionName(u.url, u.line), u.context = s.gatherContext(u.url, u.line);
            var l = "undefined" != typeof document && document && document.location && document.location.href, c = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
            return {
                mode: i,
                message: o ? String(o) : t || a,
                url: l,
                stack: [
                    u
                ],
                useragent: c
            };
        }
        function k(t, e) {
            return function(r, n) {
                try {
                    e(r, n);
                } catch (e) {
                    t.error(e);
                }
            };
        }
        function S(t) {
            return function t(e, r) {
                var n, o, i, u = {};
                try {
                    for(o in e)(n = e[o]) && (a(n, "object") || a(n, "array")) ? r.includes(n) ? u[o] = "Removed circular reference: " + s(n) : ((i = r.slice()).push(n), u[o] = t(n, i)) : u[o] = n;
                } catch (t) {
                    u = "Failed cloning custom data: " + t.message;
                }
                return u;
            }(t, [
                t
            ]);
        }
        function _(t, e, r, n, o) {
            for(var i, a, u, l, c, f, p = [], d = [], h = 0, y = t.length; h < y; ++h){
                var v = s(f = t[h]);
                switch(d.push(v), v){
                    case "undefined":
                        break;
                    case "string":
                        i ? p.push(f) : i = f;
                        break;
                    case "function":
                        l = k(e, f);
                        break;
                    case "date":
                        p.push(f);
                        break;
                    case "error":
                    case "domexception":
                    case "exception":
                        a ? p.push(f) : a = f;
                        break;
                    case "object":
                    case "array":
                        if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                            a ? p.push(f) : a = f;
                            break;
                        }
                        if (n && "object" === v && !c) {
                            for(var m = 0, b = n.length; m < b; ++m)if (void 0 !== f[n[m]]) {
                                c = f;
                                break;
                            }
                            if (c) break;
                        }
                        u ? p.push(f) : u = f;
                        break;
                    default:
                        if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                            a ? p.push(f) : a = f;
                            break;
                        }
                        p.push(f);
                }
            }
            u && (u = S(u)), p.length > 0 && (u || (u = S({})), u.extraArgs = S(p));
            var g, w = {
                message: i,
                err: a,
                custom: u,
                timestamp: P(),
                callback: l,
                notifier: r,
                diagnostic: {},
                uuid: (g = P(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                    var e = (g + 16 * Math.random()) % 16 | 0;
                    return g = Math.floor(g / 16), ("x" === t ? e : 7 & e | 8).toString(16);
                }))
            };
            return w.data = w.data || {}, function(t, e) {
                e && void 0 !== e.level && (t.level = e.level, delete e.level);
                e && void 0 !== e.skipFrames && (t.skipFrames = e.skipFrames, delete e.skipFrames);
            }(w, u), n && c && (w.request = c), o && (w.lambdaContext = o), w._originalArgs = t, w.diagnostic.original_arg_types = d, w;
        }
        var O = [
            "log",
            "network",
            "dom",
            "navigation",
            "error",
            "manual"
        ], x = [
            "critical",
            "error",
            "warning",
            "info",
            "debug"
        ];
        function E(t, e) {
            var r, o = n(t);
            try {
                for(o.s(); !(r = o.n()).done;){
                    if (r.value === e) return !0;
                }
            } catch (t) {
                o.e(t);
            } finally{
                o.f();
            }
            return !1;
        }
        function j(t, e) {
            t.attributes = t.attributes || [];
            var r, o = n(e);
            try {
                for(o.s(); !(r = o.n()).done;){
                    var i = r.value;
                    void 0 !== i.value && t.attributes.push(i);
                }
            } catch (t) {
                o.e(t);
            } finally{
                o.f();
            }
        }
        function I(t, e) {
            if (t) {
                var r = e.split("."), n = t;
                try {
                    for(var o = 0, i = r.length; o < i; ++o)n = n[r[o]];
                } catch (t) {
                    n = void 0;
                }
                return n;
            }
        }
        function T(t, e, r) {
            if (t) {
                Object.setPrototypeOf(t, null);
                var n = e.split("."), o = n.length;
                if (!(o < 1)) {
                    if (1 !== o) try {
                        for(var i = t[n[0]] || {}, a = i, s = 1; s < o - 1; ++s)i[n[s]] = i[n[s]] || {}, i = i[n[s]];
                        i[n[o - 1]] = r, t[n[0]] = a;
                    } catch (t) {
                        return;
                    }
                    else t[n[0]] = r;
                }
            }
        }
        function P() {
            return Date.now ? Date.now() : Number(new Date);
        }
        function A(t, e, r, n) {
            var o = R(t, e, r);
            return o = function(t, e) {
                t.hostWhiteList && !t.hostSafeList && (t.hostSafeList = t.hostWhiteList, t.hostWhiteList = void 0, e && e.log("hostWhiteList is deprecated. Use hostSafeList."));
                t.hostBlackList && !t.hostBlockList && (t.hostBlockList = t.hostBlackList, t.hostBlackList = void 0, e && e.log("hostBlackList is deprecated. Use hostBlockList."));
                return t;
            }(o, n), !e || e.overwriteScrubFields || e.scrubFields && (o.scrubFields = (t.scrubFields || []).concat(e.scrubFields)), o;
        }
        function R() {
            function t(t) {
                if (!t || "[object Object]" !== Object.prototype.toString.call(t)) return !1;
                var e, r = c(t, "constructor"), n = t.constructor && t.constructor.prototype && c(t.constructor.prototype, "isPrototypeOf");
                if (t.constructor && !r && !n) return !1;
                for(e in t);
                return void 0 === e || c(t, e);
            }
            var e, r, n, o, i, a = Object.create(null), s = null, u = arguments.length;
            for(e = 0; e < u; e++)if (null != (s = arguments[e])) for(i in s)r = a[i], a !== (n = s[i]) && (n && t(n) ? (o = r && t(r) ? r : {}, a[i] = R(o, n)) : void 0 !== n && (a[i] = n));
            return a;
        }
        function C(t, e, r) {
            var n;
            if (null == e || !e.sessionId || !r) return !1;
            var o = null == t || null === (n = t.tracing) || void 0 === n ? void 0 : n.propagation, i = null == o ? void 0 : o.enabledHeaders;
            if (!Array.isArray(i) || !i.includes("baggage")) return !1;
            var s = null == o ? void 0 : o.enabledCorsUrls;
            return !(!Array.isArray(s) || 0 === s.length) && s.some(function(t) {
                return a(t, "string") ? r === t : !!a(t, "regexp") && t.test(r);
            });
        }
        function L(t, e) {
            var r, n, o = t[1], i = null === (r = o) || void 0 === r ? void 0 : r.headers, a = (n = t[0], "undefined" != typeof Request && n instanceof Request && t[0].headers), s = i || a;
            if (s || (o || (t[1] = o = {}), s = o.headers = {}), s instanceof Headers) for(var u = 0, c = Object.keys(e); u < c.length; u++){
                var f = c[u];
                s.append(f, e[f]);
            }
            else if (l(s)) for(var p = 0, d = Object.keys(e); p < d.length; p++){
                var h = d[p];
                s[h] = e[h];
            }
        }
        var q = function(t, e, r) {
            var n, o, i, s, u = a(t, "object"), l = a(t, "array"), f = [];
            if (r = r || {
                obj: [],
                mapped: []
            }, u) {
                if (s = r.obj.indexOf(t), u && -1 !== s) return r.mapped[s] || r.obj[s];
                r.obj.push(t), s = r.obj.length - 1;
            }
            if (u) for(n in t)c(t, n) && f.push(n);
            else if (l) for(i = 0; i < t.length; ++i)f.push(i);
            var p = u ? {} : [], d = !0;
            for(i = 0; i < f.length; ++i)o = t[n = f[i]], p[n] = e(n, o, r), d = d && p[n] === t[n];
            return u && !d && (r.mapped[s] = p), d ? t : p;
        };
        function N(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || M(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function D(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = M(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function M(t, e) {
            if (t) {
                if ("string" == typeof t) return U(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? U(t, e) : void 0;
            }
        }
        function U(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function H(t, e) {
            var r = e.split("."), n = r.length - 1;
            try {
                var o, i = D(r.entries());
                try {
                    for(i.s(); !(o = i.n()).done;){
                        var a = N(o.value, 2), s = a[0], u = a[1];
                        s < n ? t = t[u] : t[u] = d();
                    }
                } catch (t) {
                    i.e(t);
                } finally{
                    i.f();
                }
            } catch (t) {}
        }
        var F = function(t, e, r) {
            if (e = e || [], r) {
                var n, o = D(r);
                try {
                    for(o.s(); !(n = o.n()).done;)H(t, n.value);
                } catch (t) {
                    o.e(t);
                } finally{
                    o.f();
                }
            }
            var i = function(t) {
                var e, r = [], n = D(t);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var o = "^\\[?(%5[bB])?" + e.value + "\\[?(%5[bB])?\\]?(%5[dD])?$";
                        r.push(new RegExp(o, "i"));
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
                return r;
            }(e), s = function(t) {
                var e, r = [], n = D(t);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var o = "\\[?(%5[bB])?" + e.value + "\\[?(%5[bB])?\\]?(%5[dD])?";
                        r.push(new RegExp("(" + o + "=)([^&\\n]+)", "igm"));
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
                return r;
            }(e);
            function u(t, e) {
                return e + "********";
            }
            return q(t, function t(e, r, n) {
                var o = function(t, e) {
                    var r, n = D(i);
                    try {
                        for(n.s(); !(r = n.n()).done;)if (r.value.test(t)) {
                            e = d();
                            break;
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                    return e;
                }(e, r);
                return o === r ? a(r, "object") || a(r, "array") ? q(r, t, n) : function(t) {
                    if (a(t, "string")) {
                        var e, r = D(s);
                        try {
                            for(r.s(); !(e = r.n()).done;){
                                var n = e.value;
                                t = t.replace(n, u);
                            }
                        } catch (t) {
                            r.e(t);
                        } finally{
                            r.f();
                        }
                    }
                    return t;
                }(o) : o;
            });
        }, J = [
            "otelAttributes"
        ];
        function V(t) {
            return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, V(t);
        }
        function B(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function W(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? B(Object(r), !0).forEach(function(e) {
                    $(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : B(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function $(t, e, r) {
            return (e = z(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function G(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, z(n.key), n);
            }
        }
        function z(t) {
            var e = function(t, e) {
                if ("object" != V(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != V(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == V(e) ? e : e + "";
        }
        var X = 100;
        function Z(t) {
            return [
                Math.trunc(t / 1e3),
                Math.round(t % 1e3 * 1e6)
            ];
        }
        var Q = function() {
            var t, e, r;
            return t = function t(e, r) {
                var n;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.queue = [], this.options = R(e);
                var o = this.options.maxTelemetryEvents || X;
                this.maxQueueSize = Math.max(0, Math.min(o, X)), this.tracing = r, this.telemetrySpan = null === (n = this.tracing) || void 0 === n ? void 0 : n.startSpan("rollbar-telemetry", {});
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        var e = this.options;
                        this.options = R(e, t);
                        var r = this.options.maxTelemetryEvents || X, n = Math.max(0, Math.min(r, X)), o = 0;
                        this.queue.length > n && (o = this.queue.length - n), this.maxQueueSize = n, this.queue.splice(0, o);
                    }
                },
                {
                    key: "copyEvents",
                    value: function() {
                        var t = Array.prototype.slice.call(this.queue, 0);
                        if (u(this.options.filterTelemetry)) try {
                            for(var e = t.length; e--;)this.options.filterTelemetry(t[e]) && t.splice(e, 1);
                        } catch (t) {
                            this.options.filterTelemetry = null;
                        }
                        return t = (t = t.filter(function(t) {
                            return "connectivity" !== t.type;
                        })).map(function(t) {
                            t.otelAttributes;
                            var e = function(t, e) {
                                if (null == t) return {};
                                var r, n, o = function(t, e) {
                                    if (null == t) return {};
                                    var r = {};
                                    for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
                                        if (-1 !== e.indexOf(n)) continue;
                                        r[n] = t[n];
                                    }
                                    return r;
                                }(t, e);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(t);
                                    for(n = 0; n < i.length; n++)r = i[n], -1 === e.indexOf(r) && ({}).propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
                                }
                                return o;
                            }(t, J);
                            return e;
                        }), t;
                    }
                },
                {
                    key: "exportTelemetrySpan",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        this.telemetrySpan && (this.telemetrySpan.end(t), this.telemetrySpan = this.tracing.startSpan("rollbar-telemetry", {}));
                    }
                },
                {
                    key: "capture",
                    value: function(t, e, r, n) {
                        var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null, i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, a = {
                            level: K(t, r),
                            type: t,
                            timestamp_ms: o || P(),
                            body: e,
                            source: "client"
                        };
                        n && (a.uuid = n), i && (a.otelAttributes = i);
                        try {
                            if (u(this.options.filterTelemetry) && this.options.filterTelemetry(a)) return !1;
                        } catch (t) {
                            this.options.filterTelemetry = null;
                        }
                        return this.push(a), a;
                    }
                },
                {
                    key: "captureEvent",
                    value: function(t, e, r, n) {
                        return this.capture(t, e, r, n);
                    }
                },
                {
                    key: "captureError",
                    value: function(t, e, r, n) {
                        var o, i = t.message || String(t), a = {
                            message: i
                        };
                        t.stack && (a.stack = t.stack);
                        var s = {
                            message: i,
                            level: e,
                            type: "error",
                            uuid: r
                        };
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent("rollbar-occurrence-event", s, Z(n)), this.capture("error", a, e, r, n, s);
                    }
                },
                {
                    key: "captureLog",
                    value: function(t, e, r, n) {
                        var o, i = r ? "rollbar-occurrence-event" : "rollbar-log-event", a = W({
                            message: t,
                            level: e
                        }, r ? {
                            type: "message",
                            uuid: r
                        } : {});
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent(i, a, Z(n)), this.capture("log", {
                            message: t
                        }, e, r, n, a);
                    }
                },
                {
                    key: "captureNetwork",
                    value: function(t, e, r, n) {
                        var o, i, a;
                        e = e || "xhr", t.subtype = t.subtype || e, n && (t.request = n);
                        var s = this.levelFromStatus(t.status_code), u = 1e6 * (t.end_time_ms || 0), l = {
                            type: t.subtype,
                            method: t.method,
                            url: t.url,
                            statusCode: t.status_code,
                            "request.headers": JSON.stringify(t.request_headers || {}),
                            "response.headers": JSON.stringify((null === (o = t.response) || void 0 === o ? void 0 : o.headers) || {}),
                            "response.timeUnixNano": u.toString()
                        }, c = t.request, f = null === (i = t.response) || void 0 === i ? void 0 : i.body;
                        return c && (l["request.body"] = JSON.stringify(c)), f && (l["response.body"] = JSON.stringify(f)), null === (a = this.telemetrySpan) || void 0 === a || a.addEvent("rollbar-network-event", l, Z(t.start_time_ms)), this.capture("network", t, s, r, t.start_time_ms, l);
                    }
                },
                {
                    key: "levelFromStatus",
                    value: function(t) {
                        return t >= 200 && t < 400 ? "info" : 0 === t || t >= 400 ? "error" : "info";
                    }
                },
                {
                    key: "captureDom",
                    value: function(t, e, r, n, o) {
                        var i = {
                            subtype: t,
                            element: e
                        };
                        return void 0 !== r && (i.value = r), void 0 !== n && (i.checked = n), this.capture("dom", i, "info", o);
                    }
                },
                {
                    key: "captureInput",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.value, a = t.timestamp, s = "rollbar-input-event", u = {
                            type: s,
                            subtype: r,
                            element: o,
                            value: i
                        }, l = {
                            type: r,
                            isSynthetic: n,
                            element: o,
                            value: i,
                            endTimeUnixNano: Z(a)
                        }, c = this._getRepeatedEvent(s, l);
                        return c ? this._updateRepeatedEvent(c, l, a) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(s, l, Z(a)), this.capture("dom", u, "info", null, a, l));
                    }
                },
                {
                    key: "captureClick",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.timestamp, a = "rollbar-click-event", s = {
                            type: a,
                            subtype: r,
                            element: o
                        }, u = {
                            type: r,
                            isSynthetic: n,
                            element: o,
                            endTimeUnixNano: Z(i)
                        }, l = this._getRepeatedEvent(a, u);
                        return l ? this._updateRepeatedEvent(l, u, i) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(a, u, Z(i)), this.capture("dom", s, "info", null, i, u));
                    }
                },
                {
                    key: "_getRepeatedEvent",
                    value: function(t, e) {
                        var r = this._lastEvent(this.queue);
                        if (r && r.body.type === t && r.otelAttributes.target === e.target) return r;
                    }
                },
                {
                    key: "_updateRepeatedEvent",
                    value: function(t, e, r) {
                        var n = Math.max(r - t.timestamp_ms, 1);
                        t.body.value = e.value, t.otelAttributes.value = e.value, t.otelAttributes.height = e.height, t.otelAttributes.width = e.width, t.otelAttributes.textZoomRatio = e.textZoomRatio, t.otelAttributes.endTimeUnixNano = Z(r), t.otelAttributes.durationUnixNano = Z(n), t.otelAttributes.count = (t.otelAttributes.count || 1) + 1, t.otelAttributes.rate = t.otelAttributes.count / (n / 1e3);
                    }
                },
                {
                    key: "_lastEvent",
                    value: function(t) {
                        return t.length > 0 ? t[t.length - 1] : null;
                    }
                },
                {
                    key: "captureFocus",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.timestamp, a = "rollbar-focus-event", s = {
                            type: a,
                            subtype: r,
                            element: o
                        }, u = {
                            type: r,
                            isSynthetic: n,
                            element: o
                        };
                        return null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(a, u, Z(i)), this.capture("dom", s, "info", null, i, u);
                    }
                },
                {
                    key: "captureResize",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.width, i = t.height, a = t.textZoomRatio, s = t.timestamp, u = "rollbar-resize-event", l = {
                            type: u,
                            subtype: r,
                            width: o,
                            height: i,
                            textZoomRatio: a
                        }, c = {
                            type: r,
                            isSynthetic: n,
                            width: o,
                            height: i,
                            textZoomRatio: a
                        }, f = this._getRepeatedEvent(u, c);
                        return f ? this._updateRepeatedEvent(f, c, s) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(u, c, Z(s)), this.capture("dom", l, "info", null, s, c));
                    }
                },
                {
                    key: "captureDragDrop",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.dropEffect, a = t.effectAllowed, s = t.kinds, u = t.mediaTypes, l = t.timestamp, c = "rollbar-dragdrop-event", f = {
                            type: c,
                            subtype: r,
                            isSynthetic: n
                        }, p = {
                            type: r,
                            isSynthetic: n
                        };
                        return "dragstart" === r && (f = W(W({}, f), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a
                        }), p = W(W({}, p), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a
                        })), "drop" === r && (f = W(W({}, f), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a,
                            kinds: s,
                            mediaTypes: u
                        }), p = W(W({}, p), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a,
                            kinds: s,
                            mediaTypes: u
                        })), null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(c, p, Z(l)), this.capture("dom", f, "info", null, l, p);
                    }
                },
                {
                    key: "captureNavigation",
                    value: function(t, e, r, n) {
                        var o;
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent("rollbar-navigation-event", {
                            "previous.url.full": t,
                            "url.full": e
                        }, Z(n)), this.capture("navigation", {
                            from: t,
                            to: e
                        }, "info", r, n);
                    }
                },
                {
                    key: "captureDomContentLoaded",
                    value: function(t) {
                        return this.capture("navigation", {
                            subtype: "DOMContentLoaded"
                        }, "info", void 0, t && t.getTime());
                    }
                },
                {
                    key: "captureLoad",
                    value: function(t) {
                        return this.capture("navigation", {
                            subtype: "load"
                        }, "info", void 0, t && t.getTime());
                    }
                },
                {
                    key: "captureConnectivityChange",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.timestamp, i = "rollbar-connectivity-event", a = {
                            type: i,
                            subtype: r
                        }, s = {
                            type: r,
                            isSynthetic: n
                        };
                        return null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(i, s, Z(o)), this.capture("connectivity", a, "info", null, o, s);
                    }
                },
                {
                    key: "_captureRollbarItem",
                    value: function(t) {
                        if (this.options.includeItemsInTelemetry) return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture("log", t.custom, t.level, t.uuid, t.timestamp) : void 0;
                    }
                },
                {
                    key: "push",
                    value: function(t) {
                        this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
                    }
                }
            ], e && G(t.prototype, e), r && G(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function K(t, e) {
            if (e) return e;
            return ({
                error: "error",
                manual: "info"
            })[t] || "info";
        }
        var Y = Q;
        function tt(t) {
            return tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, tt(t);
        }
        function et(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, rt(n.key), n);
            }
        }
        function rt(t) {
            var e = function(t, e) {
                if ("object" != tt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != tt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == tt(e) ? e : e + "";
        }
        var nt = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this._currentContext = e ? new Map(e) : new Map;
            }
            var e, r, n;
            return e = t, r = [
                {
                    key: "getValue",
                    value: function(t) {
                        return this._currentContext.get(t);
                    }
                },
                {
                    key: "setValue",
                    value: function(e, r) {
                        var n = new t(this._currentContext);
                        return n._currentContext.set(e, r), n;
                    }
                },
                {
                    key: "deleteValue",
                    value: function(e) {
                        var r = new t(self._currentContext);
                        return r._currentContext.delete(e), r;
                    }
                }
            ], et(e.prototype, r), n && et(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }(), ot = new nt;
        function it(t) {
            return it = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, it(t);
        }
        function at(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, st(n.key), n);
            }
        }
        function st(t) {
            var e = function(t, e) {
                if ("object" != it(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != it(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == it(e) ? e : e + "";
        }
        var ut = function() {
            var t, e, r;
            return t = function t() {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.currentContext = ot;
            }, e = [
                {
                    key: "active",
                    value: function() {
                        return this.currentContext;
                    }
                },
                {
                    key: "enterContext",
                    value: function(t) {
                        var e = this.currentContext;
                        return this.currentContext = t || ot, e;
                    }
                },
                {
                    key: "exitContext",
                    value: function(t) {
                        return this.currentContext = t, this.currentContext;
                    }
                },
                {
                    key: "with",
                    value: function(t, e, r) {
                        var n = this.enterContext(t);
                        try {
                            for(var o = arguments.length, i = new Array(o > 3 ? o - 3 : 0), a = 3; a < o; a++)i[a - 3] = arguments[a];
                            return e.call.apply(e, [
                                r
                            ].concat(i));
                        } finally{
                            this.exitContext(n);
                        }
                    }
                }
            ], e && at(t.prototype, e), r && at(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function lt(t) {
            return [
                Math.trunc(t / 1e3),
                Math.round(t % 1e3 * 1e6)
            ];
        }
        function ct(t, e) {
            return [
                t[0] + e[0] + Math.trunc((t[1] + e[1]) / 1e9),
                (t[1] + e[1]) % 1e9
            ];
        }
        var ft = {
            fromMillis: lt,
            toMillis: function(t) {
                return 1e3 * t[0] + Math.round(t[1] / 1e6);
            },
            toNanos: function(t) {
                return 1e9 * t[0] + t[1];
            },
            add: ct,
            now: function() {
                return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? ct(lt(performance.timeOrigin), lt(performance.now())) : lt(Date.now());
            },
            isHrTime: function(t) {
                return Array.isArray(t) && 2 === t.length && "number" == typeof t[0] && "number" == typeof t[1];
            }
        };
        function pt(t) {
            return pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, pt(t);
        }
        function dt(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || yt(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function ht(t) {
            return function(t) {
                if (Array.isArray(t)) return vt(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || yt(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function yt(t, e) {
            if (t) {
                if ("string" == typeof t) return vt(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? vt(t, e) : void 0;
            }
        }
        function vt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function mt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, bt(n.key), n);
            }
        }
        function bt(t) {
            var e = function(t, e) {
                if ("object" != pt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != pt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == pt(e) ? e : e + "";
        }
        var gt = function() {
            var t, e, r;
            return t = function t(e) {
                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.api = e, this.options = r;
            }, e = [
                {
                    key: "export",
                    value: function(t, e) {
                        wt.push.apply(wt, ht(t));
                    }
                },
                {
                    key: "toPayload",
                    value: function() {
                        var t = this, e = wt.slice();
                        if (wt.length = 0, !e || !e.length) return {
                            resourceSpans: []
                        };
                        var r, n = e[0] && e[0].resource || {}, o = new Map, i = function(t, e) {
                            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                            if (!r) {
                                if (Array.isArray(t) || (r = yt(t)) || e && t && "number" == typeof t.length) {
                                    r && (t = r);
                                    var n = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return n >= t.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: t[n++]
                                            };
                                        },
                                        e: function(t) {
                                            throw t;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, s = !1;
                            return {
                                s: function() {
                                    r = r.call(t);
                                },
                                n: function() {
                                    var t = r.next();
                                    return a = t.done, t;
                                },
                                e: function(t) {
                                    s = !0, i = t;
                                },
                                f: function() {
                                    try {
                                        a || null == r.return || r.return();
                                    } finally{
                                        if (s) throw i;
                                    }
                                }
                            };
                        }(e);
                        try {
                            for(i.s(); !(r = i.n()).done;){
                                var a = r.value, s = a.instrumentationScope ? "".concat(a.instrumentationScope.name, ":").concat(a.instrumentationScope.version) : "default:1.0.0";
                                o.has(s) || o.set(s, {
                                    scope: a.instrumentationScope || {
                                        name: "default",
                                        version: "1.0.0",
                                        attributes: []
                                    },
                                    spans: []
                                }), o.get(s).spans.push(this._transformSpan(a));
                            }
                        } catch (t) {
                            i.e(t);
                        } finally{
                            i.f();
                        }
                        return {
                            resourceSpans: [
                                {
                                    resource: this._transformResource(n),
                                    scopeSpans: Array.from(o.values()).map(function(e) {
                                        return {
                                            scope: t._transformInstrumentationScope(e.scope),
                                            spans: e.spans
                                        };
                                    })
                                }
                            ]
                        };
                    }
                },
                {
                    key: "post",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return this.api.postSpans(t, e);
                    }
                },
                {
                    key: "_transformSpan",
                    value: function(t) {
                        var e, r = this, n = function(t) {
                            return Object.entries(t || {}).map(function(t) {
                                var e = dt(t, 2), n = e[0], o = e[1];
                                return {
                                    key: n,
                                    value: r._transformAnyValue(o)
                                };
                            });
                        };
                        return {
                            traceId: t.spanContext.traceId,
                            spanId: t.spanContext.spanId,
                            parentSpanId: t.parentSpanId || "",
                            name: t.name,
                            kind: t.kind || 1,
                            startTimeUnixNano: ft.toNanos(t.startTime),
                            endTimeUnixNano: ft.toNanos(t.endTime),
                            attributes: n(t.attributes),
                            events: (e = t.events, (e || []).map(function(t) {
                                return {
                                    timeUnixNano: ft.toNanos(t.time),
                                    name: t.name,
                                    attributes: n(t.attributes)
                                };
                            }))
                        };
                    }
                },
                {
                    key: "_transformResource",
                    value: function(t) {
                        var e = this, r = t.attributes || {};
                        return {
                            attributes: Object.entries(r).map(function(t) {
                                var r = dt(t, 2), n = r[0], o = r[1];
                                return {
                                    key: n,
                                    value: e._transformAnyValue(o)
                                };
                            })
                        };
                    }
                },
                {
                    key: "_transformInstrumentationScope",
                    value: function(t) {
                        var e = this;
                        return {
                            name: t.name || "",
                            version: t.version || "",
                            attributes: (t.attributes || []).map(function(t) {
                                return {
                                    key: t.key,
                                    value: e._transformAnyValue(t.value)
                                };
                            })
                        };
                    }
                },
                {
                    key: "_transformAnyValue",
                    value: function(t) {
                        var e = this;
                        if (null == t) return {
                            stringValue: ""
                        };
                        var r = pt(t);
                        return "string" === r ? {
                            stringValue: t
                        } : "number" === r ? Number.isInteger(t) ? {
                            intValue: t.toString()
                        } : {
                            doubleValue: t
                        } : "boolean" === r ? {
                            boolValue: t
                        } : Array.isArray(t) ? {
                            arrayValue: {
                                values: t.map(function(t) {
                                    return e._transformAnyValue(t);
                                })
                            }
                        } : "object" === r ? {
                            kvlistValue: {
                                values: Object.entries(t).map(function(t) {
                                    var r = dt(t, 2), n = r[0], o = r[1];
                                    return {
                                        key: n,
                                        value: e._transformAnyValue(o)
                                    };
                                })
                            }
                        } : {
                            stringValue: String(t)
                        };
                    }
                }
            ], e && mt(t.prototype, e), r && mt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), wt = [];
        var kt = {
            gen: function() {
                var t = new Uint8Array(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 16);
                return crypto.getRandomValues(t), Array.from(t, function(t) {
                    return t.toString(16).padStart(2, "0");
                }).join("");
            }
        };
        function St(t) {
            return St = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, St(t);
        }
        function _t(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function Ot(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? _t(Object(r), !0).forEach(function(e) {
                    Et(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _t(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function xt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, jt(n.key), n);
            }
        }
        function Et(t, e, r) {
            return (e = jt(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function jt(t) {
            var e = function(t, e) {
                if ("object" != St(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != St(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == St(e) ? e : e + "";
        }
        var It = "RollbarSession", Tt = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Et(this, "_attributes", void 0), this.options = r, this.tracing = e, this.window = e.window, this.session = null, this._attributes = {};
            }, e = [
                {
                    key: "init",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return this.session || (this.getSession() || this.createSession(), this.initSessionAttributes(t)), this;
                    }
                },
                {
                    key: "getSession",
                    value: function() {
                        try {
                            var t = this.window.sessionStorage.getItem(It);
                            if (!t) return null;
                            this.session = JSON.parse(t);
                        } catch (t) {
                            return null;
                        }
                        return this;
                    }
                },
                {
                    key: "createSession",
                    value: function() {
                        return this.session = {
                            id: kt.gen(),
                            createdAt: Date.now()
                        }, this.setSession(this.session);
                    }
                },
                {
                    key: "setSession",
                    value: function(t) {
                        var e = JSON.stringify(t);
                        try {
                            this.window.sessionStorage.setItem(It, e);
                        } catch (t) {
                            return null;
                        }
                        return this;
                    }
                },
                {
                    key: "attributes",
                    get: function() {
                        return this._attributes;
                    }
                },
                {
                    key: "setAttributes",
                    value: function(t) {
                        return this._attributes = Ot(Ot({}, this._attributes), t), this;
                    }
                },
                {
                    key: "setUser",
                    value: function(t) {
                        return this.setAttributes({
                            "user.id": null == t ? void 0 : t.id,
                            "user.email": null == t ? void 0 : t.email,
                            "user.name": (null == t ? void 0 : t.name) || (null == t ? void 0 : t.username)
                        }), this;
                    }
                },
                {
                    key: "initSessionAttributes",
                    value: function(t) {
                        var e, r, n;
                        return this.setAttributes(Ot({
                            "session.id": this.session.id,
                            "browser.brands": null === (e = navigator.userAgentData) || void 0 === e ? void 0 : e.brands,
                            "browser.language": navigator.language,
                            "browser.mobile": null === (r = navigator.userAgentData) || void 0 === r ? void 0 : r.mobile,
                            "browser.platform": null === (n = navigator.userAgentData) || void 0 === n ? void 0 : n.platform,
                            "client.address": "$remote_ip",
                            "rollbar.notifier.framework": "browser-js",
                            "user_agent.original": navigator.userAgent
                        }, t)), this;
                    }
                }
            ], e && xt(t.prototype, e), r && xt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), Pt = function() {}, At = {
            debug: 0,
            info: 1,
            warn: 2,
            error: 3,
            disable: 4
        }, Rt = {
            error: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("error", e);
            },
            warn: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("warn", e);
            },
            info: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("info", e);
            },
            debug: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("debug", e);
            },
            log: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("info", e);
            },
            init: function(t) {
                var e = t.logLevel;
                Pt = function(t, r) {
                    At[t] < At[e] || (r.unshift("Rollbar:"), console[t].apply(console, r));
                };
            }
        }, Ct = Rt;
        function Lt(t) {
            return Lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Lt(t);
        }
        function qt(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return Nt(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Nt(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function Nt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Dt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Mt(n.key), n);
            }
        }
        function Mt(t) {
            var e = function(t, e) {
                if ("object" != Lt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Lt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Lt(e) ? e : e + "";
        }
        var Ut = function() {
            var t, e, r;
            return t = function t(e) {
                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.exporter = e, this.options = r, this.pendingSpans = new Map, this.transforms = [
                    this.userTransform.bind(this)
                ];
            }, e = [
                {
                    key: "addTransform",
                    value: function(t) {
                        this.transforms.unshift(t);
                    }
                },
                {
                    key: "userTransform",
                    value: function(t) {
                        this.options.transformSpan && this.options.transformSpan({
                            span: t
                        });
                    }
                },
                {
                    key: "applyTransforms",
                    value: function(t) {
                        var e, r = qt(this.transforms);
                        try {
                            for(r.s(); !(e = r.n()).done;){
                                var n = e.value;
                                try {
                                    n(t);
                                } catch (t) {
                                    Ct.error("Error running span transform callback", t);
                                }
                            }
                        } catch (t) {
                            r.e(t);
                        } finally{
                            r.f();
                        }
                    }
                },
                {
                    key: "onStart",
                    value: function(t, e) {
                        this.pendingSpans.set(t.span.spanContext.spanId, t);
                    }
                },
                {
                    key: "onEnd",
                    value: function(t) {
                        this.applyTransforms(t.span), this.exporter.export([
                            t.export()
                        ]), this.pendingSpans.delete(t.span.spanContext.spanId);
                    }
                }
            ], e && Dt(t.prototype, e), r && Dt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Ht(t) {
            return Ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Ht(t);
        }
        function Ft(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return Jt(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Jt(t, e) : void 0;
                }
            }(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Jt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Vt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Bt(n.key), n);
            }
        }
        function Bt(t) {
            var e = function(t, e) {
                if ("object" != Ht(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Ht(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Ht(e) ? e : e + "";
        }
        var Wt = function() {
            var t, e, r;
            return t = function t(e) {
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.usePerformance = e.usePerformance, this.initReadableSpan(e), this.spanProcessor = e.spanProcessor, this.spanProcessor.onStart(this, e.context), e.attributes && this.setAttributes(e.attributes), this;
            }, e = [
                {
                    key: "initReadableSpan",
                    value: function(t) {
                        var e;
                        this.span = {
                            name: t.name,
                            kind: t.kind,
                            spanContext: t.spanContext,
                            parentSpanId: t.parentSpanId,
                            startTime: t.startTime || ft.now(t.usePerformance),
                            endTime: [
                                0,
                                0
                            ],
                            status: {
                                code: 0,
                                message: ""
                            },
                            attributes: {
                                "session.id": null === (e = t.session) || void 0 === e ? void 0 : e.id
                            },
                            links: [],
                            events: [],
                            duration: 0,
                            ended: !1,
                            resource: t.resource,
                            instrumentationScope: t.scope,
                            droppedAttributesCount: 0,
                            droppedEventsCount: 0,
                            droppedLinksCount: 0
                        };
                    }
                },
                {
                    key: "spanContext",
                    value: function() {
                        return this.span.spanContext;
                    }
                },
                {
                    key: "spanId",
                    get: function() {
                        return this.span.spanContext.spanId;
                    }
                },
                {
                    key: "traceId",
                    get: function() {
                        return this.span.spanContext.traceId;
                    }
                },
                {
                    key: "setAttribute",
                    value: function(t, e) {
                        return null == e || this.span.ended || 0 === t.length || (this.span.attributes[t] = e), this;
                    }
                },
                {
                    key: "setAttributes",
                    value: function(t) {
                        for(var e = 0, r = Object.entries(t); e < r.length; e++){
                            var n = Ft(r[e], 2), o = n[0], i = n[1];
                            this.setAttribute(o, i);
                        }
                        return this;
                    }
                },
                {
                    key: "addEvent",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
                        return this.span.ended || this.span.events.push({
                            name: t,
                            attributes: e,
                            time: r || ft.now(),
                            droppedAttributesCount: 0
                        }), this;
                    }
                },
                {
                    key: "isRecording",
                    value: function() {
                        return !1 === this.span.ended;
                    }
                },
                {
                    key: "end",
                    value: function(t, e) {
                        t && this.setAttributes(t), this.span.endTime = e || ft.now(this.usePerformance), this.span.ended = !0, this.spanProcessor.onEnd(this);
                    }
                },
                {
                    key: "export",
                    value: function() {
                        return this.span;
                    }
                }
            ], e && Vt(t.prototype, e), r && Vt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function $t(t) {
            return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, $t(t);
        }
        function Gt(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function zt(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? Gt(Object(r), !0).forEach(function(e) {
                    Xt(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Gt(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function Xt(t, e, r) {
            return (e = Qt(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function Zt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Qt(n.key), n);
            }
        }
        function Qt(t) {
            var e = function(t, e) {
                if ("object" != $t(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != $t(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == $t(e) ? e : e + "";
        }
        var Kt = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.spanProcessor = r, this.tracing = e;
            }, e = [
                {
                    key: "startSpan",
                    value: function(t) {
                        var e, r, n, o, i, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.tracing.contextManager.active(), u = this.tracing.getSpan(s), l = null == u ? void 0 : u.spanContext(), c = kt.gen(8), f = null;
                        l ? (o = l.traceId, f = l.traceState, i = l.spanId) : o = kt.gen(16);
                        var p = {
                            traceId: o,
                            spanId: c,
                            traceFlags: 0,
                            traceState: f
                        }, d = {
                            attributes: zt(zt({}, (null === (e = this.tracing.resource) || void 0 === e ? void 0 : e.attributes) || {}), (null === (r = a.resource) || void 0 === r ? void 0 : r.attributes) || {})
                        };
                        return new Wt({
                            resource: d,
                            scope: this.tracing.scope,
                            session: null === (n = this.tracing.session) || void 0 === n ? void 0 : n.session,
                            context: s,
                            spanContext: p,
                            name: t,
                            kind: 0,
                            parentSpanId: i,
                            spanProcessor: this.spanProcessor,
                            startTime: a.startTime,
                            usePerformance: a.usePerformance
                        });
                    }
                }
            ], e && Zt(t.prototype, e), r && Zt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Yt(t) {
            return Yt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Yt(t);
        }
        function te(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function ee(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? te(Object(r), !0).forEach(function(e) {
                    re(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : te(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function re(t, e, r) {
            return (e = oe(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function ne(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oe(n.key), n);
            }
        }
        function oe(t) {
            var e = function(t, e) {
                if ("object" != Yt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Yt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Yt(e) ? e : e + "";
        }
        var ie, ae = (ie = "Rollbar Context Key SPAN", Symbol.for(ie)), se = function() {
            var t, e, r;
            return t = function t(e, r, n) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.api = r, this.options = n, this.window = e, this.window.sessionStorage && (this.session = new Tt(this, n)), this.createTracer();
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        this.options = t;
                    }
                },
                {
                    key: "initSession",
                    value: function() {
                        this.session && this.session.init();
                    }
                },
                {
                    key: "sessionId",
                    get: function() {
                        return this.session ? this.session.session.id : null;
                    }
                },
                {
                    key: "resource",
                    get: function() {
                        var t, e;
                        return {
                            attributes: ee(ee({}, this.options.resource || {}), {}, {
                                "rollbar.environment": null !== (t = null === (e = this.options.payload) || void 0 === e ? void 0 : e.environment) && void 0 !== t ? t : this.options.environment
                            })
                        };
                    }
                },
                {
                    key: "scope",
                    get: function() {
                        return {
                            name: "rollbar-browser-js",
                            version: this.options.version
                        };
                    }
                },
                {
                    key: "idGen",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 16;
                        return kt.gen(t);
                    }
                },
                {
                    key: "createTracer",
                    value: function() {
                        this.contextManager = new ut, this.exporter = new gt(this.api, this.options), this.spanProcessor = new Ut(this.exporter, this.options.tracing), this.tracer = new Kt(this, this.spanProcessor);
                    }
                },
                {
                    key: "getTracer",
                    value: function() {
                        return this.tracer;
                    }
                },
                {
                    key: "addSpanTransform",
                    value: function(t) {
                        this.spanProcessor.addTransform(t);
                    }
                },
                {
                    key: "getSpan",
                    value: function() {
                        return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.contextManager.active()).getValue(ae);
                    }
                },
                {
                    key: "setSpan",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.contextManager.active(), e = arguments.length > 1 ? arguments[1] : void 0;
                        return t.setValue(ae, e);
                    }
                },
                {
                    key: "startSpan",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.contextManager.active();
                        return this.tracer.startSpan(t, e, r);
                    }
                },
                {
                    key: "with",
                    value: function(t, e, r) {
                        for(var n, o = arguments.length, i = new Array(o > 3 ? o - 3 : 0), a = 3; a < o; a++)i[a - 3] = arguments[a];
                        return (n = this.contextManager).with.apply(n, [
                            t,
                            e,
                            r
                        ].concat(i));
                    }
                },
                {
                    key: "withSpan",
                    value: function(t, e, r, n) {
                        var o = this.startSpan(t, e);
                        return this.with(this.setSpan(this.contextManager.active(), o), r, n, o);
                    }
                }
            ], e && ne(t.prototype, e), r && ne(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function ue(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || ce(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function le(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = ce(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function ce(t, e) {
            if (t) {
                if ("string" == typeof t) return fe(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fe(t, e) : void 0;
            }
        }
        function fe(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function pe(t, e) {
            return [
                t,
                b(t, e)
            ];
        }
        function de(t, e) {
            var r = t.length;
            return r > 2 * e ? t.slice(0, e).concat(t.slice(r - e)) : t;
        }
        function he(t, e, r) {
            r = void 0 === r ? 30 : r;
            var n, o = t.data.body;
            if (o.trace_chain) {
                var i, a = le(o.trace_chain);
                try {
                    for(a.s(); !(i = a.n()).done;){
                        var s = i.value;
                        n = de(n = s.frames, r), s.frames = n;
                    }
                } catch (t) {
                    a.e(t);
                } finally{
                    a.f();
                }
            } else o.trace && (n = de(n = o.trace.frames, r), o.trace.frames = n);
            return [
                t,
                b(t, e)
            ];
        }
        function ye(t, e) {
            return e && e.length > t ? e.slice(0, t - 3).concat("...") : e;
        }
        function ve(t, e, r) {
            return e = q(e, function e(r, n, o) {
                switch(s(n)){
                    case "string":
                        return ye(t, n);
                    case "object":
                    case "array":
                        return q(n, e, o);
                    default:
                        return n;
                }
            }), [
                e,
                b(e, r)
            ];
        }
        function me(t) {
            return t.exception && (delete t.exception.description, t.exception.message = ye(255, t.exception.message)), t.frames = de(t.frames, 1), t;
        }
        function be(t, e) {
            var r = t.data.body;
            if (r.trace_chain) {
                var n, o = r.trace_chain, i = le(o.entries());
                try {
                    for(i.s(); !(n = i.n()).done;){
                        var a = ue(n.value, 2), s = a[0], u = a[1];
                        o[s] = me(u);
                    }
                } catch (t) {
                    i.e(t);
                } finally{
                    i.f();
                }
            } else r.trace && (r.trace = me(r.trace));
            return [
                t,
                b(t, e)
            ];
        }
        function ge(t, e) {
            return function(t) {
                for(var e = 0, r = t.length, n = 0; n < r; n++){
                    var o = t.charCodeAt(n);
                    o < 128 ? e += 1 : o < 2048 ? e += 2 : o < 65536 && (e += 3);
                }
                return e;
            }(t) > e;
        }
        var we = {
            truncate: function(t, e, r) {
                r = void 0 === r ? 524288 : r;
                for(var n, o, i, a = [
                    pe,
                    he,
                    ve.bind(null, 1024),
                    ve.bind(null, 512),
                    ve.bind(null, 256),
                    be
                ]; n = a.shift();)if (t = (o = n(t, e))[0], (i = o[1]).error || !ge(i.value, r)) return i;
                return i;
            },
            raw: pe,
            truncateFrames: he,
            truncateStrings: ve,
            maybeTruncateValue: ye
        };
        function ke(t) {
            if (!a(t.context, "string")) {
                var e = b(t.context);
                e.error ? t.context = "Error: could not serialize 'context'" : t.context = e.value || "", t.context.length > 255 && (t.context = t.context.substr(0, 255));
            }
            return {
                data: t
            };
        }
        function Se(t, e, r) {
            var n = e.hostname, o = e.protocol, i = e.port, a = e.path, s = e.search, u = t.timeout, l = function(t) {
                var e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = t.defaultTransport || "xhr";
                void 0 === e.fetch && (r = "xhr");
                void 0 === e.XMLHttpRequest && (r = "fetch");
                return r;
            }(t), c = t.proxy;
            if (t.endpoint) {
                var f = r.parse(t.endpoint);
                n = f.hostname, o = f.protocol, i = f.port, a = f.pathname, s = f.search;
            }
            return {
                timeout: u,
                hostname: n,
                protocol: o,
                port: i,
                path: a,
                search: s,
                proxy: c,
                transport: l
            };
        }
        function _e(t, e) {
            var r = t.protocol || "https:", n = t.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), o = t.hostname, i = t.path, a = t.timeout, s = t.transport;
            return t.search && (i += t.search), t.proxy && (i = r + "//" + o + i, o = t.proxy.host || t.proxy.hostname, n = t.proxy.port, r = t.proxy.protocol || r), {
                timeout: a,
                protocol: r,
                hostname: o,
                path: i,
                port: n,
                method: e,
                transport: s
            };
        }
        function Oe(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function xe(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? Oe(Object(r), !0).forEach(function(e) {
                    Ee(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Oe(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function Ee(t, e, r) {
            return (e = Re(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function je(t) {
            return je = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, je(t);
        }
        function Ie() {
            var t, e, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
            function i(r, n, o, i) {
                var u = n && n.prototype instanceof s ? n : s, l = Object.create(u.prototype);
                return Te(l, "_invoke", function(r, n, o) {
                    var i, s, u, l = 0, c = o || [], f = !1, p = {
                        p: 0,
                        n: 0,
                        v: t,
                        a: d,
                        f: d.bind(t, 4),
                        d: function(e, r) {
                            return i = e, s = 0, u = t, p.n = r, a;
                        }
                    };
                    function d(r, n) {
                        for(s = r, u = n, e = 0; !f && l && !o && e < c.length; e++){
                            var o, i = c[e], d = p.p, h = i[2];
                            r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = t) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                        }
                        if (o || r > 1) return a;
                        throw f = !0, n;
                    }
                    return function(o, c, h) {
                        if (l > 1) throw TypeError("Generator is already running");
                        for(f && 1 === c && d(c, h), s = c, u = h; (e = s < 2 ? t : u) || !f;){
                            i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                            try {
                                if (l = 2, i) {
                                    if (s || (o = "next"), e = i[o]) {
                                        if (!(e = e.call(i, u))) throw TypeError("iterator result is not an object");
                                        if (!e.done) return e;
                                        u = e.value, s < 2 && (s = 0);
                                    } else 1 === s && (e = i.return) && e.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                    i = t;
                                } else if ((e = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                            } catch (e) {
                                i = t, s = 1, u = e;
                            } finally{
                                l = 1;
                            }
                        }
                        return {
                            value: e,
                            done: f
                        };
                    };
                }(r, o, i), !0), l;
            }
            var a = {};
            function s() {}
            function u() {}
            function l() {}
            e = Object.getPrototypeOf;
            var c = [][n] ? e(e([][n]())) : (Te(e = {}, n, function() {
                return this;
            }), e), f = l.prototype = s.prototype = Object.create(c);
            function p(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, l) : (t.__proto__ = l, Te(t, o, "GeneratorFunction")), t.prototype = Object.create(f), t;
            }
            return u.prototype = l, Te(f, "constructor", l), Te(l, "constructor", u), u.displayName = "GeneratorFunction", Te(l, o, "GeneratorFunction"), Te(f), Te(f, o, "Generator"), Te(f, n, function() {
                return this;
            }), Te(f, "toString", function() {
                return "[object Generator]";
            }), (Ie = function() {
                return {
                    w: i,
                    m: p
                };
            })();
        }
        function Te(t, e, r, n) {
            var o = Object.defineProperty;
            try {
                o({}, "", {});
            } catch (t) {
                o = 0;
            }
            Te = function(t, e, r, n) {
                function i(e, r) {
                    Te(t, e, function(t) {
                        return this._invoke(e, r, t);
                    });
                }
                e ? o ? o(t, e, {
                    value: r,
                    enumerable: !n,
                    configurable: !n,
                    writable: !n
                }) : t[e] = r : (i("next", 0), i("throw", 1), i("return", 2));
            }, Te(t, e, r, n);
        }
        function Pe(t, e, r, n, o, i, a) {
            try {
                var s = t[i](a), u = s.value;
            } catch (t) {
                return void r(t);
            }
            s.done ? e(u) : Promise.resolve(u).then(n, o);
        }
        function Ae(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Re(n.key), n);
            }
        }
        function Re(t) {
            var e = function(t, e) {
                if ("object" != je(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != je(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == je(e) ? e : e + "";
        }
        var Ce = {
            hostname: "api.rollbar.com",
            path: "/api/1/item/",
            search: null,
            version: "1",
            protocol: "https:",
            port: 443
        }, Le = {
            hostname: "api.rollbar.com",
            path: "/api/1/session/",
            search: null,
            version: "1",
            protocol: "https:",
            port: 443
        }, qe = function() {
            var t, e, r, n, o;
            return t = function t(e, r, n, o) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.options = e, this.transport = r, this.url = n, this.truncation = o, this.accessToken = e.accessToken, this.transportOptions = Ne(e, n), this.OTLPTransportOptions = De(e, n);
            }, e = [
                {
                    key: "_postPromise",
                    value: function(t) {
                        var e = this, r = t.accessToken, n = t.options, o = t.payload, i = t.headers;
                        return new Promise(function(t, a) {
                            e.transport.post({
                                accessToken: r,
                                options: n,
                                payload: o,
                                headers: i,
                                callback: function(e, r) {
                                    return e ? a(e) : t(r);
                                }
                            });
                        });
                    }
                },
                {
                    key: "postItem",
                    value: function(t, e) {
                        var r = this, n = _e(this.transportOptions, "POST"), o = ke(t);
                        setTimeout(function() {
                            r.transport.post({
                                accessToken: r.accessToken,
                                options: n,
                                payload: o,
                                callback: e
                            });
                        }, 0);
                    }
                },
                {
                    key: "postSpans",
                    value: (n = Ie().m(function t(e) {
                        var r, n, o = arguments;
                        return Ie().w(function(t) {
                            for(;;)if (0 === t.n) return r = o.length > 1 && void 0 !== o[1] ? o[1] : {}, n = _e(this.OTLPTransportOptions, "POST"), t.a(2, this._postPromise({
                                accessToken: this.accessToken,
                                options: n,
                                payload: e,
                                headers: r
                            }));
                        }, t, this);
                    }), o = function() {
                        var t = this, e = arguments;
                        return new Promise(function(r, o) {
                            var i = n.apply(t, e);
                            function a(t) {
                                Pe(i, r, o, a, s, "next", t);
                            }
                            function s(t) {
                                Pe(i, r, o, a, s, "throw", t);
                            }
                            a(void 0);
                        });
                    }, function(t) {
                        return o.apply(this, arguments);
                    })
                },
                {
                    key: "buildJsonPayload",
                    value: function(t, e) {
                        var r, n = ke(t);
                        return (r = this.truncation ? this.truncation.truncate(n) : b(n)).error ? (e && e(r.error), null) : r.value;
                    }
                },
                {
                    key: "postJsonPayload",
                    value: function(t, e) {
                        var r = _e(this.transportOptions, "POST");
                        this.transport.postJsonPayload(this.accessToken, r, t, e);
                    }
                },
                {
                    key: "configure",
                    value: function(t) {
                        var e = this.options;
                        return this.options = R(e, t), this.transportOptions = Ne(this.options, this.url), this.OTLPTransportOptions = De(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
                    }
                }
            ], e && Ae(t.prototype, e), r && Ae(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Ne(t, e) {
            return Se(t, Ce, e);
        }
        function De(t, e) {
            var r;
            return Se(t = xe(xe({}, t), {}, {
                endpoint: null === (r = t.tracing) || void 0 === r ? void 0 : r.endpoint
            }), Le, e);
        }
        var Me = qe, Ue = "3.1.0", He = "api.rollbar.com/api/1/item/", Fe = "debug", Je = "debug", Ve = "error", Be = /(^|@)\S+:\d+/, We = /^\s*at .*(\S+:\d+|\(native\))/m, $e = /^(eval@)?(\[native code\])?$/;
        function Ge(t, e) {
            if (void 0 !== t.stacktrace || void 0 !== t["opera#sourceloc"]) return function(t, e) {
                return !t.stacktrace || t.message.includes("\n") && t.message.split("\n").length > t.stacktrace.split("\n").length ? function(t, e) {
                    for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = t.message.split("\n"), o = [], i = 2, a = n.length; i < a; i += 2){
                        var s = r.exec(n[i]);
                        s && o.push({
                            file: s[2],
                            line: +s[1],
                            raw: n[i]
                        });
                    }
                    return Xe(o, e);
                }(t) : t.stack ? function(t, e) {
                    var r = Xe(t.stack.split("\n").filter(function(t) {
                        return !!t.match(Be) && !t.match(/^Error created at/);
                    }), e);
                    return r.map(function(t) {
                        var e, r = t.split("@"), n = ze(r.pop()), o = r.shift() || "", i = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                        return o.match(/\(([^)]*)\)/) && (e = o.replace(/^[^(]+\(([^)]*)\)$/, "$1")), {
                            function: i,
                            args: void 0 === e || "[arguments not available]" === e ? void 0 : e.split(","),
                            file: n[0],
                            line: n[1] ? +n[1] : void 0,
                            col: n[2] ? +n[2] : void 0,
                            raw: t
                        };
                    });
                }(t, e) : function(t, e) {
                    for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = t.stacktrace.split("\n"), o = [], i = 0, a = n.length; i < a; i += 2){
                        var s = r.exec(n[i]);
                        s && o.push({
                            function: s[3] || void 0,
                            file: s[2],
                            line: s[1] ? +s[1] : void 0,
                            raw: n[i]
                        });
                    }
                    return Xe(o, e);
                }(t);
            }(t, e);
            if (t.stack && t.stack.match(We)) return function(t, e) {
                return Ze(t.stack, e);
            }(t, e);
            if (t.stack) return function(t, e) {
                return Qe(t.stack, e);
            }(t, e);
            if (null != e && e.allowEmpty) return [];
            throw new Error("Cannot parse given Error object");
        }
        function ze(t) {
            if (!t.includes(":")) return [
                t,
                void 0,
                void 0
            ];
            var e = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(t.replace(/[()]/g, ""));
            return [
                e[1],
                e[2] || void 0,
                e[3] || void 0
            ];
        }
        function Xe(t, e) {
            return e && null != e.slice ? Array.isArray(e.slice) ? t.slice(e.slice[0], e.slice[1]) : t.slice(0, e.slice) : t;
        }
        function Ze(t, e) {
            return Xe(t.split("\n").filter(function(t) {
                return !!t.match(We);
            }), e).map(function(t) {
                t.includes("(eval ") && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                var e = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), r = e.match(/ (\(.+\)$)/);
                e = r ? e.replace(r[0], "") : e;
                var n = ze(r ? r[1] : e);
                return {
                    function: r && e || void 0,
                    file: [
                        "eval",
                        "<anonymous>"
                    ].includes(n[0]) ? void 0 : n[0],
                    line: n[1] ? +n[1] : void 0,
                    col: n[2] ? +n[2] : void 0,
                    raw: t
                };
            });
        }
        function Qe(t, e) {
            return Xe(t.split("\n").filter(function(t) {
                return !t.match($e);
            }), e).map(function(t) {
                if (t.includes(" > eval") && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), t.includes("@") || t.includes(":")) {
                    var e = /(([^\n\r"\u2028\u2029]*".[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*(?:@[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*)*(?:[\n\r\u2028\u2029][^@]*)?)?[^@]*)@/, r = t.match(e), n = r && r[1] ? r[1] : void 0, o = ze(t.replace(e, ""));
                    return {
                        function: n,
                        file: o[0],
                        line: o[1] ? +o[1] : void 0,
                        col: o[2] ? +o[2] : void 0,
                        raw: t
                    };
                }
                return {
                    function: t
                };
            });
        }
        function Ke(t) {
            return t.map(function(t) {
                return {
                    functionName: t.function,
                    args: t.args,
                    fileName: t.file,
                    lineNumber: t.line,
                    columnNumber: t.col,
                    source: t.raw
                };
            });
        }
        var Ye = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
        function tr() {
            return null;
        }
        function er(t) {
            var e = {};
            return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = null, e;
        }
        function rr(t, e) {
            return {
                stack: function() {
                    var r = [];
                    e = e || 0;
                    try {
                        r = function(t, e) {
                            return Ke(Ge(t, e));
                        }(t);
                    } catch (t) {
                        r = [];
                    }
                    for(var n = [], o = e; o < r.length; o++)n.push(new er(r[o]));
                    return n;
                }(),
                message: t.message,
                name: nr(t),
                rawStack: t.stack,
                rawException: t
            };
        }
        function nr(t) {
            var e = t.name && t.name.length && t.name, r = t.constructor.name && t.constructor.name.length && t.constructor.name;
            return e && r ? "Error" === e ? r : e : e || r;
        }
        var or = {
            guessFunctionName: function() {
                return "?";
            },
            guessErrorClass: function(t) {
                if (!t || !t.match) return [
                    "Unknown error. There was no error message to display.",
                    ""
                ];
                var e = t.match(Ye), r = "(unknown)";
                return e && (r = e[e.length - 1], t = (t = t.replace((e[e.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                    r,
                    t
                ];
            },
            gatherContext: tr,
            parse: function(t, e) {
                var r = t;
                if (r.nested || r.cause) {
                    for(var n = []; r;)n.push(new rr(r, e)), r = r.nested || r.cause, e = 0;
                    return n[0].traceChain = n, n[0];
                }
                return new rr(r, e);
            },
            Stack: rr,
            Frame: er
        };
        function ir(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return ar(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ar(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function ar(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function sr(t, e) {
            var r = t.level, n = h[r] || 0, o = e.reportLevel;
            return !(n < (h[o] || 0));
        }
        function ur(t, e, r) {
            if (!t) return !r;
            var n, o, i = t.frames;
            if (!i || 0 === i.length) return !r;
            for(var s = e.length, u = i.length, l = 0; l < u; l++){
                if (!a(n = i[l].filename, "string")) return !r;
                for(var c = 0; c < s; c++)if (o = e[c], new RegExp(o).test(n)) return !0;
            }
            return !1;
        }
        function lr(t, e, r, n) {
            var o, i, a = !1;
            "blocklist" === r && (a = !0);
            try {
                if (o = a ? e.hostBlockList : e.hostSafeList, i = I(t, "body.trace_chain") || [
                    I(t, "body.trace")
                ], !o || 0 === o.length) return !a;
                if (0 === i.length || !i[0]) return !a;
                for(var s = i.length, u = 0; u < s; u++)if (ur(i[u], o, a)) return !0;
            } catch (t) {
                a ? e.hostBlockList = null : e.hostSafeList = null;
                var l = a ? "hostBlockList" : "hostSafeList";
                return n.error("Error while reading your configuration's " + l + " option. Removing custom " + l + ".", t), !a;
            }
            return !1;
        }
        function cr(t) {
            return function(e, r) {
                var n, o, i, a, s, u;
                try {
                    if (!(i = r.ignoredMessages) || 0 === i.length) return !0;
                    if (u = function(t) {
                        var e = t.body, r = [];
                        if (e.trace_chain) {
                            var n, o = ir(e.trace_chain);
                            try {
                                for(o.s(); !(n = o.n()).done;){
                                    var i = n.value;
                                    r.push(I(i, "exception.message"));
                                }
                            } catch (t) {
                                o.e(t);
                            } finally{
                                o.f();
                            }
                        }
                        e.trace && r.push(I(e, "trace.exception.message"));
                        e.message && r.push(I(e, "message.body"));
                        return r;
                    }(e), 0 === u.length) return !0;
                    for(a = i.length, n = 0; n < a; n++)for(s = new RegExp(i[n], "gi"), o = 0; o < u.length; o++)if (s.test(u[o])) return !1;
                } catch (e) {
                    r.ignoredMessages = null, t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                }
                return !0;
            };
        }
        function fr(t) {
            return fr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, fr(t);
        }
        function pr(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, dr(n.key), n);
            }
        }
        function dr(t) {
            var e = function(t, e) {
                if ("object" != fr(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != fr(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == fr(e) ? e : e + "";
        }
        var hr = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.queue = e, this.options = r, this.transforms = [], this.diagnostic = {};
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        var e;
                        null === (e = this.queue) || void 0 === e || e.configure(t);
                        var r = this.options;
                        return this.options = R(r, t), this;
                    }
                },
                {
                    key: "addTransform",
                    value: function(t) {
                        return u(t) && this.transforms.push(t), this;
                    }
                },
                {
                    key: "log",
                    value: function(t, e) {
                        var r = this;
                        if (e = u(e) ? e : function() {}, !this.options.enabled) return e(new Error("Rollbar is not enabled"), null);
                        this.queue.addPendingItem(t);
                        var n = t.err;
                        this._applyTransforms(t, function(o, i) {
                            if (o) return r.queue.removePendingItem(t), e(o, null);
                            r.queue.addItem(i, e, n, t);
                        });
                    }
                },
                {
                    key: "_applyTransforms",
                    value: function(t, e) {
                        var r = -1, n = this.transforms.length, o = this.transforms, i = this.options, a = function(t, s) {
                            t ? e(t, null) : ++r !== n ? o[r](s, i, a) : e(null, s);
                        };
                        a(null, t);
                    }
                }
            ], e && pr(t.prototype, e), r && pr(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function yr(t) {
            return yr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, yr(t);
        }
        function vr(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, mr(n.key), n);
            }
        }
        function mr(t) {
            var e = function(t, e) {
                if ("object" != yr(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != yr(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == yr(e) ? e : e + "";
        }
        var br, gr, wr, kr = function() {
            function t(e, r, n, o, i) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.rateLimiter = e, this.api = r, this.logger = n, this.options = o, this.replay = i, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
            }
            var e, r, n;
            return e = t, r = [
                {
                    key: "configure",
                    value: function(t) {
                        var e;
                        null === (e = this.api) || void 0 === e || e.configure(t);
                        var r = this.options;
                        return this.options = R(r, t), this;
                    }
                },
                {
                    key: "addPredicate",
                    value: function(t) {
                        return u(t) && this.predicates.push(t), this;
                    }
                },
                {
                    key: "addPendingItem",
                    value: function(t) {
                        this.pendingItems.push(t);
                    }
                },
                {
                    key: "removePendingItem",
                    value: function(t) {
                        var e = this.pendingItems.indexOf(t);
                        -1 !== e && this.pendingItems.splice(e, 1);
                    }
                },
                {
                    key: "addItem",
                    value: function(t, e, r, n) {
                        var o = this;
                        e && u(e) || (e = function() {});
                        var i = t.data, a = this._applyPredicates(i);
                        if (a.stop) return this.removePendingItem(n), void e(a.err);
                        if (this._maybeLog(i, r), this.removePendingItem(n), this.options.transmit) {
                            this.replay && i.body && (t.replayId = this.replay.capture(null, i.uuid, {
                                type: "occurrence",
                                level: t.level
                            }), t.replayId && j(t.data, [
                                {
                                    key: "replay_id",
                                    value: t.replayId
                                }
                            ])), this.pendingRequests.push(i);
                            try {
                                this._makeApiRequest(i, function(r, n, a) {
                                    o._dequeuePendingRequest(i), t.replayId && o.replay.sendOrDiscardReplay(t.replayId, r, n, a), e(r, n);
                                });
                            } catch (r) {
                                var s;
                                this._dequeuePendingRequest(i), t.replayId && (null === (s = this.replay) || void 0 === s || s.discard(t.replayId)), e(r);
                            }
                        } else e(new Error("Transmit disabled"));
                    }
                },
                {
                    key: "wait",
                    value: function(t) {
                        var e = this;
                        u(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval(function() {
                            e._maybeCallWait();
                        }, 500)));
                    }
                },
                {
                    key: "_applyPredicates",
                    value: function(t) {
                        for(var e = null, r = 0, n = this.predicates.length; r < n; r++)if (!(e = this.predicates[r](t, this.options)) || void 0 !== e.err) return {
                            stop: !0,
                            err: e.err
                        };
                        return {
                            stop: !1,
                            err: null
                        };
                    }
                },
                {
                    key: "_makeApiRequest",
                    value: function(t, e) {
                        var r = this, n = this.rateLimiter.shouldSend(t);
                        n.shouldSend ? this.api.postItem(t, function(n, o, i) {
                            n ? r._maybeRetry(n, t, e) : e(n, o, i);
                        }) : n.error ? e(n.error) : this.api.postItem(n.payload, e);
                    }
                },
                {
                    key: "_maybeRetry",
                    value: function(e, r, n) {
                        var o = !1;
                        if (this.options.retryInterval) {
                            for(var i = 0, a = t.RETRIABLE_ERRORS.length; i < a; i++)if (e.code === t.RETRIABLE_ERRORS[i]) {
                                o = !0;
                                break;
                            }
                            o && f(this.options.maxRetries) && (r.retries = r.retries ? r.retries + 1 : 1, r.retries > this.options.maxRetries && (o = !1));
                        }
                        o ? this._retryApiRequest(r, n) : n(e);
                    }
                },
                {
                    key: "_retryApiRequest",
                    value: function(t, e) {
                        var r = this;
                        this.retryQueue.push({
                            item: t,
                            callback: e
                        }), this.retryHandle || (this.retryHandle = setInterval(function() {
                            for(; r.retryQueue.length;){
                                var t = r.retryQueue.shift();
                                r._makeApiRequest(t.item, t.callback);
                            }
                        }, this.options.retryInterval));
                    }
                },
                {
                    key: "_dequeuePendingRequest",
                    value: function(t) {
                        var e = this.pendingRequests.indexOf(t);
                        -1 !== e && (this.pendingRequests.splice(e, 1), this._maybeCallWait());
                    }
                },
                {
                    key: "_maybeLog",
                    value: function(t, e) {
                        if (this.logger && this.options.verbose) {
                            var r = e || I(t, "body.trace.exception.message") || I(t, "body.trace_chain.0.exception.message");
                            if (r) return void this.logger.error(r);
                            (r = I(t, "body.message.body")) && this.logger.log(r);
                        }
                    }
                },
                {
                    key: "_maybeCallWait",
                    value: function() {
                        return !(!u(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
                    }
                }
            ], r && vr(e.prototype, r), n && vr(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }();
        br = kr, wr = [
            "ECONNRESET",
            "ENOTFOUND",
            "ESOCKETTIMEDOUT",
            "ETIMEDOUT",
            "ECONNREFUSED",
            "EHOSTUNREACH",
            "EPIPE",
            "EAI_AGAIN"
        ], (gr = mr(gr = "RETRIABLE_ERRORS")) in br ? Object.defineProperty(br, gr, {
            value: wr,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : br[gr] = wr;
        var Sr = kr;
        function _r(t) {
            return _r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _r(t);
        }
        function Or(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, xr(n.key), n);
            }
        }
        function xr(t) {
            var e = function(t, e) {
                if ("object" != _r(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != _r(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == _r(e) ? e : e + "";
        }
        var Er = function() {
            function t() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.startTime = Date.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(e);
            }
            return function(t, e, r) {
                return e && Or(t.prototype, e), r && Or(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(t, [
                {
                    key: "configureGlobal",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.startTime, n = e.maxItems, o = e.itemsPerMinute;
                        void 0 !== r && (t.globalSettings.startTime = r), void 0 !== n && (t.globalSettings.maxItems = n), void 0 !== o && (t.globalSettings.itemsPerMinute = o);
                    }
                },
                {
                    key: "shouldSend",
                    value: function(e) {
                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Date.now(), n = r - this.startTime;
                        (n < 0 || n >= 6e4) && (this.startTime = r, this.perMinCounter = 0);
                        var o = t.globalSettings.maxItems, i = t.globalSettings.itemsPerMinute;
                        if (jr(e, o, this.counter)) return Ir(this.platform, this.platformOptions, "".concat(o, " max items reached"), !1);
                        if (jr(e, i, this.perMinCounter)) return Ir(this.platform, this.platformOptions, "".concat(i, " items per minute reached"), !1);
                        this.counter += 1, this.perMinCounter += 1;
                        var a = !jr(e, o, this.counter), s = a, u = a && !jr(e, i, this.perMinCounter);
                        return Ir(this.platform, this.platformOptions, null, u, o, i, s);
                    }
                },
                {
                    key: "setPlatformOptions",
                    value: function(t, e) {
                        this.platform = t, this.platformOptions = e;
                    }
                }
            ]);
        }();
        function jr(t, e, r) {
            return !t.ignoreRateLimit && e >= 1 && r > e;
        }
        function Ir(t, e, r, n, o, i, a) {
            var s = null, u = r ? new Error(r) : null;
            return u || n || (s = function(t, e, r, n, o) {
                var i = e.environment || e.payload && e.payload.environment, a = o ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.", s = {
                    body: {
                        message: {
                            body: a,
                            extra: {
                                maxItems: r,
                                itemsPerMinute: n
                            }
                        }
                    },
                    language: "javascript",
                    environment: i,
                    notifier: {
                        version: e.notifier && e.notifier.version || e.version
                    }
                };
                "browser" === t ? (s.platform = "browser", s.framework = "browser-js", s.notifier.name = "rollbar-browser-js") : "server" === t ? (s.framework = e.framework || "node-js", s.notifier.name = e.notifier.name) : "react-native" === t && (s.framework = e.framework || "react-native", s.notifier.name = e.notifier.name);
                return s;
            }(t, e, o, i, a)), {
                error: u,
                shouldSend: n,
                payload: s
            };
        }
        !function(t, e, r) {
            (e = xr(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r;
        }(Er, "globalSettings", {
            startTime: Date.now(),
            maxItems: void 0,
            itemsPerMinute: void 0
        });
        var Tr = Er;
        function Pr(t, e, r, n, o, i, a) {
            this.options = R(t), this.logger = r, Pr.rateLimiter.configureGlobal(this.options), Pr.rateLimiter.setPlatformOptions(a, this.options), this.api = e, this.queue = new Sr(Pr.rateLimiter, e, r, this.options, i), this.tracing = o;
            var s = this.options.tracer || null;
            Rr(s) ? (this.tracer = s, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new hr(this.queue, this.options), this.telemeter = n, Ar(t), this.lastError = null, this.lastErrorHash = "none";
        }
        function Ar(t) {
            t.stackTraceLimit && (Error.stackTraceLimit = t.stackTraceLimit);
        }
        function Rr(t) {
            if (!t) return !1;
            if (!t.scope || "function" != typeof t.scope) return !1;
            var e = t.scope();
            return !(!e || !e.active || "function" != typeof e.active);
        }
        Pr.rateLimiter = new Tr({
            maxItems: 0,
            itemsPerMinute: 60
        }), Pr.prototype.global = function(t) {
            return Pr.rateLimiter.configureGlobal(t), this;
        }, Pr.prototype.configure = function(t, e) {
            var r = this.options, n = {};
            e && (n = {
                payload: e
            }), this.options = R(r, t, n);
            var o = this.options.tracer || null;
            return Rr(o) ? (this.tracer = o, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), Ar(t), this.global(this.options), Rr(t.tracer) && (this.tracer = t.tracer), this;
        }, Pr.prototype.log = function(t) {
            var e = this._defaultLogLevel();
            return this._log(e, t);
        }, Pr.prototype.debug = function(t) {
            this._log("debug", t);
        }, Pr.prototype.info = function(t) {
            this._log("info", t);
        }, Pr.prototype.warn = function(t) {
            this._log("warning", t);
        }, Pr.prototype.warning = function(t) {
            this._log("warning", t);
        }, Pr.prototype.error = function(t) {
            this._log("error", t);
        }, Pr.prototype.critical = function(t) {
            this._log("critical", t);
        }, Pr.prototype.wait = function(t) {
            this.queue.wait(t);
        }, Pr.prototype.captureEvent = function(t, e, r) {
            return this.telemeter && this.telemeter.captureEvent(t, e, r);
        }, Pr.prototype.captureDomContentLoaded = function(t) {
            return this.telemeter && this.telemeter.captureDomContentLoaded(t);
        }, Pr.prototype.captureLoad = function(t) {
            return this.telemeter && this.telemeter.captureLoad(t);
        }, Pr.prototype.buildJsonPayload = function(t) {
            return this.api.buildJsonPayload(t);
        }, Pr.prototype.sendJsonPayload = function(t) {
            this.api.postJsonPayload(t);
        }, Pr.prototype._log = function(t, e) {
            var r;
            if (e.callback && (r = e.callback, delete e.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(e)) {
                if (r) {
                    var n = new Error("ignored identical item");
                    n.item = e, r(n);
                }
            } else try {
                e.level = e.level || t, this._addItemAttributes(e), this._addTracingInfo(e);
                var o = this.telemeter;
                o && (o._captureRollbarItem(e), e.telemetryEvents = o.copyEvents() || []), this.notifier.log(e, r);
            } catch (t) {
                r && r(t), this.logger.error(t);
            }
        }, Pr.prototype._addItemAttributes = function(t) {
            var e, r, n = null === (e = this.tracing) || void 0 === e ? void 0 : e.getSpan(), o = [
                {
                    key: "session_id",
                    value: function(t) {
                        var e = t.asyncLocalStorage;
                        if (!e || "function" != typeof e.getStore) return null;
                        var r = e.getStore();
                        return (null == r ? void 0 : r.sessionId) || null;
                    }(this) || (null === (r = this.tracing) || void 0 === r ? void 0 : r.sessionId)
                },
                {
                    key: "span_id",
                    value: null == n ? void 0 : n.spanId
                },
                {
                    key: "trace_id",
                    value: null == n ? void 0 : n.traceId
                }
            ];
            t._isUncaught && o.push({
                key: "is_uncaught",
                value: "true"
            }), j(t.data, o), null == n || n.addEvent("rollbar.occurrence", [
                {
                    key: "rollbar.occurrence.uuid",
                    value: t.uuid
                }
            ]);
        }, Pr.prototype._defaultLogLevel = function() {
            return this.options.logLevel || "debug";
        }, Pr.prototype._sameAsLastError = function(t) {
            if (!t._isUncaught) return !1;
            var e = function(t) {
                var e = t.message || "", r = (t.err || {}).stack || String(t.err);
                return e + "::" + r;
            }(t);
            return this.lastErrorHash === e || (this.lastError = t.err, this.lastErrorHash = e, !1);
        }, Pr.prototype._addTracingInfo = function(t) {
            if (this.tracer) {
                var e = this.tracer.scope().active();
                if (function(t) {
                    if (!t || !t.context || "function" != typeof t.context) return !1;
                    var e = t.context();
                    if (!e || !e.toSpanId || !e.toTraceId || "function" != typeof e.toSpanId || "function" != typeof e.toTraceId) return !1;
                    return !0;
                }(e)) {
                    e.setTag("rollbar.error_uuid", t.uuid), e.setTag("rollbar.has_error", !0), e.setTag("error", !0), e.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=".concat(t.uuid)), e.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=".concat(t.uuid));
                    var r = e.context().toSpanId(), n = e.context().toTraceId();
                    t.custom ? (t.custom.opentracing_span_id = r, t.custom.opentracing_trace_id = n) : t.custom = {
                        opentracing_span_id: r,
                        opentracing_trace_id: n
                    };
                }
            }
        };
        var Cr = Pr;
        function Lr(t, e, r) {
            t._isUncaught && (t.data._isUncaught = !0), t._originalArgs && (t.data._originalArgs = t._originalArgs), r(null, t);
        }
        function qr(t, e, r) {
            var n = e.payload || {};
            n.body && delete n.body, t.data = R(t.data, n), r(null, t);
        }
        function Nr(t, e, r) {
            t.telemetryEvents && T(t, "data.body.telemetry", t.telemetryEvents), r(null, t);
        }
        function Dr(t, e, r) {
            if (t.message) {
                var n = "data.body.trace_chain.0", o = I(t, n);
                if (o || (o = I(t, n = "data.body.trace")), o) {
                    if (!o.exception || !o.exception.description) return T(t, n + ".exception.description", t.message), void r(null, t);
                    T(t, n + ".extra", R(I(t, n + ".extra") || {}, {
                        message: t.message
                    }));
                }
                r(null, t);
            } else r(null, t);
        }
        function Mr(t) {
            return function(e, r, n) {
                var o, i = R(e), s = null;
                try {
                    u(r.transform) && (s = r.transform(i.data, e));
                } catch (o) {
                    return r.transform = null, t.error("Error while calling custom transform() function. Removing custom transform().", o), void n(null, e);
                }
                l(o = s) && a(o.then, "function") ? s.then(function(t) {
                    t && (i.data = t), n(null, i);
                }, function(t) {
                    n(t, e);
                }) : n(null, i);
            };
        }
        function Ur(t, e, r) {
            if (!e.sendConfig) return r(null, t);
            var n = I(t, "data.custom") || {};
            n._rollbarConfig = e, t.data.custom = n, r(null, t);
        }
        function Hr(t, e) {
            u(t[e]) && (t[e] = t[e].toString());
        }
        function Fr(t, e, r) {
            var n = e._configuredOptions;
            Hr(n, "transform"), Hr(n, "checkIgnore"), Hr(n, "onSendCallback"), delete n.accessToken, t.data.notifier.configured_options = n, r(null, t);
        }
        function Jr(t, e, r) {
            var n = R(t.notifier.client.notifier.diagnostic, t.diagnostic);
            if (I(t, "err._isAnonymous") && (n.is_anonymous = !0), t._isUncaught && (n.is_uncaught = t._isUncaught), t.err) try {
                n.raw_error = {
                    message: t.err.message,
                    name: t.err.name,
                    constructor_name: t.err.constructor && t.err.constructor.name,
                    filename: t.err.fileName,
                    line: t.err.lineNumber,
                    column: t.err.columnNumber,
                    stack: t.err.stack
                };
            } catch (t) {
                n.raw_error = {
                    failed: String(t)
                };
            }
            t.data.notifier.diagnostic = R(t.data.notifier.diagnostic, n), r(null, t);
        }
        function Vr(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        var Br = [].concat(function(t) {
            return function(t) {
                if (Array.isArray(t)) return Vr(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return Vr(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Vr(t, e) : void 0;
                }
            }(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }([
            "pw",
            "pass",
            "passwd",
            "password",
            "secret",
            "confirm_password",
            "confirmPassword",
            "password_confirmation",
            "passwordConfirmation",
            "access_token",
            "accessToken",
            "X-Rollbar-Access-Token",
            "secret_key",
            "secretKey",
            "secretToken"
        ]), [
            "cc-number",
            "card number",
            "cardnumber",
            "cardnum",
            "ccnum",
            "ccnumber",
            "cc num",
            "creditcardnumber",
            "credit card number",
            "newcreditcardnumber",
            "new credit card",
            "creditcardno",
            "credit card no",
            "card#",
            "card #",
            "cc-csc",
            "cvc",
            "cvc2",
            "cvv2",
            "ccv2",
            "security code",
            "card verification",
            "name on credit card",
            "name on card",
            "nameoncard",
            "cardholder",
            "card holder",
            "name des karteninhabers",
            "ccname",
            "card type",
            "cardtype",
            "cc type",
            "cctype",
            "payment type",
            "expiration date",
            "expirationdate",
            "expdate",
            "cc-exp",
            "ccmonth",
            "ccyear"
        ]), Wr = {
            scrubFields: Br
        };
        function $r(t, e) {
            return !I(e, "plugins.jquery.ignoreAjaxErrors") || !I(t, "body.message.extra.isAjax");
        }
        function Gr(t, e, r) {
            if (t.err && "DOMException" === or.Stack(t.err).name) {
                var n = new Error;
                n.name = t.err.name, n.message = t.err.message, n.stack = t.err.stack, n.nested = t.err, t.err = n;
            }
            r(null, t);
        }
        function zr(t, e, r) {
            if (t.data = t.data || {}, t.err) try {
                t.stackInfo = t.err._savedStackTrace || or.parse(t.err, t.skipFrames), e.addErrorContext && function(t) {
                    var e = [], r = t.err;
                    e.push(r);
                    for(; r.nested || r.cause;)r = r.nested || r.cause, e.push(r);
                    !function(t, e) {
                        var r = t.data.custom || {}, o = !1;
                        try {
                            var i, a = n(e);
                            try {
                                for(a.s(); !(i = a.n()).done;){
                                    var s = i.value;
                                    c(s, "rollbarContext") && (r = R(r, S(s.rollbarContext)), o = !0);
                                }
                            } catch (t) {
                                a.e(t);
                            } finally{
                                a.f();
                            }
                            o && (t.data.custom = r);
                        } catch (e) {
                            t.diagnostic.error_context = "Failed: " + e.message;
                        }
                    }(t, e);
                }(t);
            } catch (e) {
                Ct.error("Error while parsing the error object.", e);
                try {
                    t.message = t.err.message || t.err.description || t.message || String(t.err);
                } catch (e) {
                    t.message = String(t.err) || String(e);
                }
                delete t.err;
            }
            r(null, t);
        }
        function Xr(t, e, r) {
            t.message || t.stackInfo || t.custom || r(new Error("No message, stack info, or custom data"), null), r(null, t);
        }
        function Zr(t, e, r) {
            var n = e.payload && e.payload.environment || e.environment;
            t.data = R(t.data, {
                environment: n,
                level: t.level,
                endpoint: e.endpoint,
                platform: "browser",
                framework: "browser-js",
                language: "javascript",
                server: {},
                uuid: t.uuid,
                notifier: {
                    name: "rollbar-browser-js",
                    version: e.version
                },
                custom: t.custom
            }), r(null, t);
        }
        function Qr(t, e, r) {
            t.stackInfo ? t.stackInfo.traceChain ? function(t, e, r) {
                for(var n = t.stackInfo.traceChain, o = [], i = n.length, a = 0; a < i; a++){
                    var s = tn(t, n[a], e);
                    o.push(s);
                }
                T(t, "data.body", {
                    trace_chain: o
                }), r(null, t);
            }(t, e, r) : function(t, e, r) {
                var n = Yr(t);
                if (n) T(t, "data.body", {
                    trace: tn(t, t.stackInfo, e)
                }), r(null, t);
                else {
                    var o = t.stackInfo, i = or.guessErrorClass(o.message), a = en(o, i[0], e), s = i[1];
                    t.message = a + ": " + s, Kr(t, e, r);
                }
            }(t, e, r) : Kr(t, e, r);
        }
        function Kr(t, e, r) {
            var n = t.message, o = t.custom;
            n || (n = "Item sent with null or missing arguments.");
            var i = {
                body: n
            };
            o && (i.extra = R(o)), T(t, "data.body", {
                message: i
            }), r(null, t);
        }
        function Yr(t) {
            var e = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || t.stackInfo).stack;
            return e && 0 === e.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (e = t._unhandledStackInfo.stack), e;
        }
        function tn(t, e, r) {
            var n = t && t.data.description, o = t && t.custom, i = Yr(t, e), a = or.guessErrorClass(e.message), s = {
                exception: {
                    class: en(e, a[0], r),
                    message: a[1]
                }
            };
            if (n && (s.exception.description = n), i) {
                var u, l, c, f, p, d, h, v;
                for(0 === i.length && (s.exception.stack = e.rawStack, s.exception.raw = String(e.rawException)), s.frames = [], h = 0; h < i.length; ++h)l = {
                    filename: (u = i[h]).url ? y(u.url) : "(unknown)",
                    lineno: u.line || null,
                    method: u.func && "?" !== u.func ? u.func : "[anonymous]",
                    colno: u.column
                }, r.sendFrameUrl && (l.url = u.url), l.method && l.method.endsWith && l.method.endsWith("_rollbar_wrapped") || (c = f = p = null, (d = u.context ? u.context.length : 0) && (v = Math.floor(d / 2), f = u.context.slice(0, v), c = u.context[v], p = u.context.slice(v)), c && (l.code = c), (f || p) && (l.context = {}, f && f.length && (l.context.pre = f), p && p.length && (l.context.post = p)), u.args && (l.args = u.args), s.frames.push(l));
                s.frames.reverse(), o && (s.extra = R(o));
            }
            return s;
        }
        function en(t, e, r) {
            return t.name ? t.name : r.guessErrorClass ? e : "(unknown)";
        }
        function rn(t) {
            return rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, rn(t);
        }
        function nn(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function on(t, e, r) {
            return (e = function(t) {
                var e = function(t, e) {
                    if ("object" != rn(t) || !t) return t;
                    var r = t[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(t, e || "default");
                        if ("object" != rn(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === e ? String : Number)(t);
                }(t, "string");
                return "symbol" == rn(e) ? e : e + "";
            }(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        var an = function(t) {
            var e, r, n = t.accessToken, o = t.url, i = t.method, a = t.payload, s = t.headers, u = t.callback, l = t.timeout;
            f(l) && (e = new AbortController, r = setTimeout(function() {
                e.abort();
            }, l)), s = function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? nn(Object(r), !0).forEach(function(e) {
                        on(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : nn(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }({
                "Content-Type": "application/json",
                "X-Rollbar-Access-Token": n,
                signal: e && e.signal
            }, s), fetch(o, {
                method: i,
                headers: s,
                body: a
            }).then(function(t) {
                r && clearTimeout(r);
                var e = t.headers, n = o.endsWith("/api/1/item/") ? {
                    "Rollbar-Replay-Enabled": e.get("Rollbar-Replay-Enabled"),
                    "Rollbar-Replay-RateLimit-Remaining": e.get("Rollbar-Replay-RateLimit-Remaining"),
                    "Rollbar-Replay-RateLimit-Reset": e.get("Rollbar-Replay-RateLimit-Reset")
                } : {}, i = t.json();
                u(null, i, n);
            }).catch(function(t) {
                Ct.error(t.message), u(t);
            });
        };
        function sn(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return un(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? un(t, e) : void 0;
                }
            }(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function un(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function ln(t, e) {
            var r = new Error(t);
            return r.code = e || "ENOTFOUND", r;
        }
        var cn = function(t) {
            var e, r = t.accessToken, n = t.url, o = t.method, i = t.payload, s = t.headers, u = t.callback, l = t.requestFactory, c = t.timeout;
            if (!(e = l ? l() : function() {
                var t, e, r = [
                    function() {
                        return new XMLHttpRequest;
                    },
                    function() {
                        return new ActiveXObject("Msxml2.XMLHTTP");
                    },
                    function() {
                        return new ActiveXObject("Msxml3.XMLHTTP");
                    },
                    function() {
                        return new ActiveXObject("Microsoft.XMLHTTP");
                    }
                ], n = r.length;
                for(e = 0; e < n; e++)try {
                    t = r[e]();
                    break;
                } catch (t) {}
                return t;
            }())) return u(new Error("No way to send a request"));
            try {
                try {
                    var p = function() {
                        try {
                            if (p && 4 === e.readyState) {
                                p = void 0;
                                var t = g(e.responseText);
                                if (function(t) {
                                    return t && t.status && 200 === t.status;
                                }(e)) {
                                    var r = n.endsWith("/api/1/item/") ? {
                                        "Rollbar-Replay-Enabled": e.getResponseHeader("Rollbar-Replay-Enabled"),
                                        "Rollbar-Replay-RateLimit-Remaining": e.getResponseHeader("Rollbar-Replay-RateLimit-Remaining"),
                                        "Rollbar-Replay-RateLimit-Reset": e.getResponseHeader("Rollbar-Replay-RateLimit-Reset")
                                    } : {};
                                    return void u(t.error, t.value, r);
                                }
                                if (function(t) {
                                    return t && a(t.status, "number") && t.status >= 400 && t.status < 600;
                                }(e)) {
                                    if (403 === e.status) {
                                        var o = t.value && t.value.message;
                                        Ct.error(o);
                                    }
                                    u(new Error(String(e.status)));
                                } else u(ln("XHR response had no status code (likely connection failure)"));
                            }
                        } catch (t) {
                            var i;
                            i = t && t.stack ? t : new Error(t), u(i);
                        }
                    };
                    if (e.open(o, n, !0), e.setRequestHeader) {
                        e.setRequestHeader("Content-Type", "application/json"), e.setRequestHeader("X-Rollbar-Access-Token", r);
                        for(var d = 0, h = Object.entries(null != s ? s : {}); d < h.length; d++){
                            var y = sn(h[d], 2), v = y[0], m = y[1];
                            e.setRequestHeader(v, m);
                        }
                    }
                    f(c) && (e.timeout = c), e.onreadystatechange = p, e.send(i);
                } catch (t) {
                    if ("undefined" != typeof XDomainRequest) {
                        if (!window || !window.location) return u(new Error("No window available during request, unknown environment"));
                        "http:" === window.location.href.substring(0, 5) && "https" === n.substring(0, 5) && (n = "http" + n.substring(5));
                        var b = new XDomainRequest;
                        b.onprogress = function() {}, b.ontimeout = function() {
                            u(ln("Request timed out", "ETIMEDOUT"));
                        }, b.onerror = function() {
                            u(new Error("Error during request"));
                        }, b.onload = function() {
                            var t = g(b.responseText);
                            u(t.error, t.value);
                        }, b.open(o, n, !0), b.send(i);
                    } else u(new Error("Cannot find a method to transport a request"));
                }
            } catch (t) {
                u(t);
            }
        };
        function fn(t) {
            this.truncation = t;
        }
        fn.prototype.get = function(t, e, r, n, o) {
            n && u(n) || (n = function() {}), function(t, e, r) {
                (r = r || {}).access_token = t;
                var n, o = [];
                for(n in r)Object.prototype.hasOwnProperty.call(r, n) && o.push([
                    n,
                    r[n]
                ].join("="));
                var i = "?" + o.sort().join("&");
                (e = e || {}).path = e.path || "";
                var a, s = e.path.indexOf("?"), u = e.path.indexOf("#");
                -1 !== s && (-1 === u || u > s) ? (a = e.path, e.path = a.substring(0, s) + i + "&" + a.substring(s + 1)) : -1 !== u ? (a = e.path, e.path = a.substring(0, u) + i + a.substring(u)) : e.path = e.path + i;
            }(t, e, r);
            var i = m(e);
            this._makeZoneRequest({
                accessToken: t,
                url: i,
                method: "GET",
                callback: n,
                requestFactory: o,
                timeout: e.timeout,
                transport: e.transport
            });
        }, fn.prototype.post = function(t) {
            var e, r = t.accessToken, n = t.options, o = t.payload, i = t.headers, a = t.callback, s = t.requestFactory;
            if (a && u(a) || (a = function() {}), !o) return a(new Error("Cannot send empty request"));
            if ((e = this.truncation && o.body ? this.truncation.truncate(o) : b(o)).error) return a(e.error);
            var l = m(n);
            this._makeZoneRequest({
                accessToken: r,
                url: l,
                method: "POST",
                payload: e.value,
                headers: i,
                callback: a,
                requestFactory: s,
                timeout: n.timeout,
                transport: n.transport
            });
        }, fn.prototype.postJsonPayload = function(t, e, r, n, o) {
            n && u(n) || (n = function() {});
            var i = m(e);
            this._makeZoneRequest({
                accessToken: t,
                url: i,
                method: "POST",
                payload: r,
                callback: n,
                requestFactory: o,
                timeout: e.timeout,
                transport: e.transport
            });
        }, fn.prototype._makeZoneRequest = function() {
            var t = this, e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = e && e.Zone && e.Zone.root, n = Array.prototype.slice.call(arguments);
            r ? r.run(function() {
                t._makeRequest.apply(void 0, n);
            }) : this._makeRequest.apply(void 0, n);
        }, fn.prototype._makeRequest = function(t) {
            var e = t.payload, r = t.callback, n = t.transport;
            if ("undefined" != typeof RollbarProxy) return function(t, e) {
                (new RollbarProxy).sendJsonPayload(t, function(t) {}, function(t) {
                    e(new Error(t));
                });
            }(e, r);
            "fetch" === n ? an(t) : cn(t);
        };
        var pn, dn = fn;
        function hn(t) {
            var e, r, n = {
                protocol: null,
                auth: null,
                host: null,
                path: null,
                hash: null,
                href: t,
                hostname: null,
                port: null,
                pathname: null,
                search: null,
                query: null
            };
            if (-1 !== (e = t.indexOf("//")) ? (n.protocol = t.substring(0, e), r = e + 2) : r = 0, -1 !== (e = t.indexOf("@", r)) && (n.auth = t.substring(r, e), r = e + 1), -1 === (e = t.indexOf("/", r))) {
                if (-1 === (e = t.indexOf("?", r))) return -1 === (e = t.indexOf("#", r)) ? n.host = t.substring(r) : (n.host = t.substring(r, e), n.hash = t.substring(e)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
            } else n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
            if (-1 === (e = t.indexOf("#", r)) ? n.path = t.substring(r) : (n.path = t.substring(r, e), n.hash = t.substring(e)), n.path) {
                var o = n.path.split("?");
                n.pathname = o[0], n.query = o[1], n.search = n.query ? "?" + n.query : null;
            }
            return n;
        }
        function yn(t) {
            return yn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, yn(t);
        }
        function vn(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function mn(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? vn(Object(r), !0).forEach(function(e) {
                    gn(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vn(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function bn(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wn(n.key), n);
            }
        }
        function gn(t, e, r) {
            return (e = wn(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function wn(t) {
            var e = function(t, e) {
                if ("object" != yn(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != yn(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == yn(e) ? e : e + "";
        }
        var kn = null, Sn = function() {
            function t(e, n) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Ct.init({
                    logLevel: e.logLevel || "error"
                }), this.options = A(On, e, null, Ct), this.options._configuredOptions = e, this.components = this.components || {};
                var o = this.components.telemeter, i = this.components.instrumenter;
                this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                var a = this.components.truncation, s = this.components.tracing, l = this.components.replay, c = new dn(a), f = new Me(this.options, c, r, a);
                if (s && (this.tracing = new s(_n(), f, this.options), this.tracing.initSession()), o && (this.telemeter = new o(this.options, this.tracing)), l && "undefined" != typeof window) {
                    var p = this.options.replay;
                    this.replay = new l({
                        tracing: this.tracing,
                        telemeter: this.telemeter,
                        options: p
                    }), p.enabled && p.autoStart && this.replay.recorder.start();
                }
                this.client = n || new Cr(this.options, f, Ct, this.telemeter, this.tracing, this.replay, "browser");
                var d = _n(), h = "undefined" != typeof document && document;
                this.isChrome = d.chrome && d.chrome.runtime, this.anonymousErrorsPending = 0, function(t, e, r) {
                    t.addTransform(Gr).addTransform(zr).addTransform(Xr).addTransform(Zr).addTransform(function(t) {
                        return function(e, r, n) {
                            var o = {};
                            t && t.location && (o.url = t.location.href, o.query_string = t.location.search);
                            var i = "$remote_ip";
                            r.captureIp ? !0 !== r.captureIp && (i += "_anonymize") : i = null, i && (o.user_ip = i), Object.keys(o).length > 0 && T(e, "data.request", o), n(null, e);
                        };
                    }(r)).addTransform(function(t) {
                        return function(e, r, n) {
                            if (!t) return n(null, e);
                            var o = t.navigator || {}, i = t.screen || {};
                            T(e, "data.client", {
                                runtime_ms: e.timestamp - t._rollbarStartTime,
                                timestamp: Math.round(e.timestamp / 1e3),
                                javascript: {
                                    browser: o.userAgent,
                                    language: o.language,
                                    cookie_enabled: o.cookieEnabled,
                                    screen: {
                                        width: i.width,
                                        height: i.height
                                    }
                                }
                            }), n(null, e);
                        };
                    }(r)).addTransform(function(t) {
                        return function(e, r, n) {
                            if (!t || !t.navigator) return n(null, e);
                            for(var o, i = [], a = t.navigator.plugins || [], s = 0, u = a.length; s < u; ++s)o = a[s], i.push({
                                name: o.name,
                                description: o.description
                            });
                            T(e, "data.client.javascript.plugins", i), n(null, e);
                        };
                    }(r)).addTransform(Qr).addTransform(Dr).addTransform(Nr).addTransform(Ur).addTransform((n = e.scrub, function(t, e, r) {
                        if (n) {
                            var o = e.scrubFields || [], i = e.scrubPaths || [];
                            t.data = n(t.data, o, i);
                        }
                        r(null, t);
                    })).addTransform(qr).addTransform(Mr(Ct)).addTransform(Fr).addTransform(Jr).addTransform(Lr);
                    var n;
                }(this.client.notifier, this, d), function(t) {
                    t.addPredicate(sr).addPredicate($r).addPredicate(function(t) {
                        return function(e, r) {
                            var n = Boolean(e._isUncaught);
                            delete e._isUncaught;
                            var o = e._originalArgs;
                            delete e._originalArgs;
                            try {
                                u(r.onSendCallback) && r.onSendCallback(n, o, e);
                            } catch (e) {
                                r.onSendCallback = null, t.error("Error while calling onSendCallback, removing", e);
                            }
                            try {
                                if (u(r.checkIgnore) && r.checkIgnore(n, o, e)) return !1;
                            } catch (e) {
                                r.checkIgnore = null, t.error("Error while calling custom checkIgnore(), removing", e);
                            }
                            return !0;
                        };
                    }(Ct)).addPredicate(function(t) {
                        return function(e, r) {
                            return !lr(e, r, "blocklist", t);
                        };
                    }(Ct)).addPredicate(function(t) {
                        return function(e, r) {
                            return lr(e, r, "safelist", t);
                        };
                    }(Ct)).addPredicate(cr(Ct));
                }(this.client.queue), this.setupUnhandledCapture(), i && (this.instrumenter = new i(this.options, this.client.telemeter, this, d, h), this.instrumenter.instrument()), this.setSessionAttributesFromOptions(e), this.rollbar = this;
            }
            return function(t, e, r) {
                return e && bn(t.prototype, e), r && bn(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(t, [
                {
                    key: "global",
                    value: function(t) {
                        return this.client.global(t), this;
                    }
                },
                {
                    key: "configure",
                    value: function(t, e) {
                        var r, n, o;
                        t.logLevel && Ct.init({
                            logLevel: t.logLevel
                        }), this.setSessionAttributesFromOptions(t);
                        var i = this.options, a = {};
                        return e && (a = {
                            payload: e
                        }), this.options = A(i, t, a, Ct), this.options._configuredOptions = A(i._configuredOptions, t, a), null === (r = this.tracing) || void 0 === r || r.configure(this.options), null === (n = this.replay) || void 0 === n || n.configure(this.options.replay), this.client.configure(this.options, e), null === (o = this.instrumenter) || void 0 === o || o.configure(this.options), this.setupUnhandledCapture(), this;
                    }
                },
                {
                    key: "lastError",
                    value: function() {
                        return this.client.lastError;
                    }
                },
                {
                    key: "log",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.log(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "debug",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.debug(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "info",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.info(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "warn",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.warn(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "warning",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.warning(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "error",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.error(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "critical",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.critical(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "buildJsonPayload",
                    value: function(t) {
                        return this.client.buildJsonPayload(t);
                    }
                },
                {
                    key: "sendJsonPayload",
                    value: function(t) {
                        return this.client.sendJsonPayload(t);
                    }
                },
                {
                    key: "triggerDirectReplay",
                    value: function(t) {
                        return this.triggerReplay(mn({
                            type: "direct"
                        }, t));
                    }
                },
                {
                    key: "triggerReplay",
                    value: function(t) {
                        return this.replay ? this.replay.triggerReplay(t) : null;
                    }
                },
                {
                    key: "setupUnhandledCapture",
                    value: function() {
                        var t = _n();
                        this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (!function(t, e, r) {
                            if (t) {
                                var n;
                                if ("function" == typeof e._rollbarOldOnError) n = e._rollbarOldOnError;
                                else if (t.onerror) {
                                    for(n = t.onerror; n._rollbarOldOnError;)n = n._rollbarOldOnError;
                                    e._rollbarOldOnError = n;
                                }
                                e.handleAnonymousErrors();
                                var o = function() {
                                    var r = Array.prototype.slice.call(arguments, 0);
                                    !function(t, e, r, n) {
                                        t._rollbarWrappedError && (n[4] || (n[4] = t._rollbarWrappedError), n[5] || (n[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null);
                                        var o = e.handleUncaughtException.apply(e, n);
                                        r && r.apply(t, n), "anonymous" === o && (e.anonymousErrorsPending += 1);
                                    }(t, e, n, r);
                                };
                                r && (o._rollbarOldOnError = n), t.onerror = o;
                            }
                        }(t, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(t, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (!function(t, e, r) {
                            if (t) {
                                "function" == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener("unhandledrejection", t._rollbarURH);
                                var n = function(t) {
                                    var r, n, o;
                                    try {
                                        r = t.reason;
                                    } catch (t) {
                                        r = void 0;
                                    }
                                    try {
                                        n = t.promise;
                                    } catch (t) {
                                        n = "[unhandledrejection] error getting `promise` from event";
                                    }
                                    try {
                                        o = t.detail, !r && o && (r = o.reason, n = o.promise);
                                    } catch (t) {}
                                    r || (r = "[unhandledrejection] error getting `reason` from event"), e && e.handleUnhandledRejection && e.handleUnhandledRejection(r, n);
                                };
                                n.belongsToShim = r, t._rollbarURH = n, t.addEventListener("unhandledrejection", n);
                            }
                        }(t, this), this.unhandledRejectionsInitialized = !0);
                    }
                },
                {
                    key: "handleUncaughtException",
                    value: function(t, e, r, n, o, i) {
                        if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                            if (this.options.inspectAnonymousErrors && this.isChrome && null === o && "" === e) return "anonymous";
                            var a, s = w(t, e, r, n, o, "onerror", "uncaught exception", or);
                            p(o) ? (a = this._createItem([
                                t,
                                o,
                                i
                            ]))._unhandledStackInfo = s : p(e) ? (a = this._createItem([
                                t,
                                e,
                                i
                            ]))._unhandledStackInfo = s : (a = this._createItem([
                                t,
                                i
                            ])).stackInfo = s, a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
                        }
                    }
                },
                {
                    key: "handleAnonymousErrors",
                    value: function() {
                        var t = this;
                        if (this.options.inspectAnonymousErrors && this.isChrome) try {
                            Error.prepareStackTrace = function(e, r) {
                                if (t.options.inspectAnonymousErrors && t.anonymousErrorsPending) {
                                    if (t.anonymousErrorsPending -= 1, !e) return;
                                    e._isAnonymous = !0, t.handleUncaughtException(e.message, null, null, null, e);
                                }
                                return e.stack;
                            };
                        } catch (t) {
                            this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", t);
                        }
                    }
                },
                {
                    key: "handleUnhandledRejection",
                    value: function(t, e) {
                        if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                            var r = "unhandled rejection was null or undefined!";
                            if (t) {
                                if (t.message) r = t.message;
                                else {
                                    var n = b(t);
                                    n.value && (r = n.value);
                                }
                            }
                            var o, i = t && t._rollbarContext || e && e._rollbarContext;
                            p(t) ? o = this._createItem([
                                r,
                                t,
                                i
                            ]) : (o = this._createItem([
                                r,
                                t,
                                i
                            ])).stackInfo = w(r, "", 0, 0, null, "unhandledrejection", "", or), o.level = this.options.uncaughtErrorLevel, o._isUncaught = !0, o._originalArgs = o._originalArgs || [], o._originalArgs.push(e), this.client.log(o);
                        }
                    }
                },
                {
                    key: "wrap",
                    value: function(t, e, r) {
                        try {
                            var n;
                            if (n = u(e) ? e : function() {
                                return e || {};
                            }, !u(t)) return t;
                            if (t._isWrap) return t;
                            if (!t._rollbar_wrapped) for(var o in t._rollbar_wrapped = function() {
                                r && u(r) && r.apply(this, arguments);
                                try {
                                    return t.apply(this, arguments);
                                } catch (r) {
                                    var e = r;
                                    throw e && window._rollbarWrappedError !== e && (a(e, "string") && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e), e;
                                }
                            }, t._rollbar_wrapped._isWrap = !0, t)c(t, o) && "_rollbar_wrapped" !== o && (t._rollbar_wrapped[o] = t[o]);
                            return t._rollbar_wrapped;
                        } catch (e) {
                            return t;
                        }
                    }
                },
                {
                    key: "captureEvent",
                    value: function() {
                        var t = function(t) {
                            for(var e, r, n, o, i = 0, a = t.length; i < a; ++i)switch(s(o = t[i])){
                                case "string":
                                    !e && E(O, o) ? e = o : !n && E(x, o) && (n = o);
                                    break;
                                case "object":
                                    r = o;
                            }
                            return {
                                type: e || "manual",
                                metadata: r || {},
                                level: n
                            };
                        }(arguments);
                        return this.client.captureEvent(t.type, t.metadata, t.level);
                    }
                },
                {
                    key: "setSessionUser",
                    value: function(t) {
                        var e;
                        null !== (e = this.tracing) && void 0 !== e && e.session && this.tracing.session.setUser(t);
                    }
                },
                {
                    key: "setSessionAttributes",
                    value: function(t) {
                        var e;
                        null !== (e = this.tracing) && void 0 !== e && e.session && (t = mn({}, t), this.tracing.session.setAttributes(t));
                    }
                },
                {
                    key: "setSessionAttributesFromOptions",
                    value: function(t) {
                        var e, r, n, o, i, a = t.person || (null === (e = t.payload) || void 0 === e ? void 0 : e.person);
                        a && this.setSessionUser(a);
                        var s = (null === (r = t.client) || void 0 === r || null === (r = r.javascript) || void 0 === r ? void 0 : r.code_version) || t.codeVersion || t.code_version || (null === (n = t.payload) || void 0 === n || null === (n = n.client) || void 0 === n || null === (n = n.javascript) || void 0 === n ? void 0 : n.code_version) || (null === (o = t.payload) || void 0 === o ? void 0 : o.code_version) || (null === (i = t.payload) || void 0 === i ? void 0 : i.codeVersion);
                        this.setSessionAttributes({
                            "rollbar.codeVersion": s,
                            "rollbar.notifier.name": "rollbar-browser-js",
                            "rollbar.notifier.version": t.version
                        });
                    }
                },
                {
                    key: "captureDomContentLoaded",
                    value: function(t, e) {
                        return e || (e = new Date), this.client.captureDomContentLoaded(e);
                    }
                },
                {
                    key: "captureLoad",
                    value: function(t, e) {
                        return e || (e = new Date), this.client.captureLoad(e);
                    }
                },
                {
                    key: "loadFull",
                    value: function() {
                        Ct.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
                    }
                },
                {
                    key: "_createItem",
                    value: function(t) {
                        return _(t, Ct, this);
                    }
                }
            ], [
                {
                    key: "init",
                    value: function(e, r) {
                        return kn ? kn.global(e).configure(e) : kn = new t(e, r);
                    }
                },
                {
                    key: "setComponents",
                    value: function(e) {
                        t.prototype.components = e;
                    }
                },
                {
                    key: "callInstance",
                    value: function(t, e) {
                        if (kn) return kn[t].apply(kn, e);
                        var r = "Rollbar is not initialized";
                        Ct.error(r);
                        var n = function(t) {
                            for(var e = 0, r = t.length; e < r; ++e)if (u(t[e])) return t[e];
                            return;
                        }(e);
                        n && n(new Error(r));
                    }
                }
            ]);
        }();
        function _n() {
            return "undefined" != typeof window && window || "undefined" != typeof self && self;
        }
        pn = Sn, gn(Sn, "global", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("global", e);
        }), gn(Sn, "configure", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("configure", e);
        }), gn(Sn, "lastError", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("lastError", e);
        }), gn(Sn, "log", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("log", e);
        }), gn(Sn, "debug", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("debug", e);
        }), gn(Sn, "info", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("info", e);
        }), gn(Sn, "warn", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("warn", e);
        }), gn(Sn, "warning", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("warning", e);
        }), gn(Sn, "error", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("error", e);
        }), gn(Sn, "critical", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("critical", e);
        }), gn(Sn, "buildJsonPayload", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("buildJsonPayload", e);
        }), gn(Sn, "sendJsonPayload", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("sendJsonPayload", e);
        }), gn(Sn, "wrap", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("wrap", e);
        }), gn(Sn, "captureEvent", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("captureEvent", e);
        });
        var On = {
            environment: "unknown",
            version: Ue,
            scrubFields: Wr.scrubFields,
            logLevel: Fe,
            reportLevel: Je,
            uncaughtErrorLevel: Ve,
            endpoint: He,
            verbose: !1,
            enabled: !0,
            transmit: !0,
            sendConfig: !1,
            includeItemsInTelemetry: !0,
            captureIp: !0,
            inspectAnonymousErrors: !0,
            ignoreDuplicateErrors: !0,
            wrapGlobalEventHandlers: !1,
            replay: {
                enabled: !1,
                autoStart: !0,
                triggerDefaults: {
                    samplingRatio: 1,
                    preDuration: 300,
                    postDuration: 5
                },
                triggers: [
                    {
                        type: "occurrence",
                        level: [
                            "error",
                            "critical"
                        ]
                    }
                ],
                debug: {
                    logErrors: !0,
                    logEmits: !1
                },
                inlineStylesheet: !0,
                inlineImages: !1,
                collectFonts: !0,
                maskInputOptions: {
                    password: !0,
                    email: !1,
                    tel: !1,
                    text: !1,
                    color: !1,
                    date: !1,
                    "datetime-local": !1,
                    month: !1,
                    number: !1,
                    range: !1,
                    search: !1,
                    time: !1,
                    url: !1,
                    week: !1
                },
                maskAllInputs: !1,
                blockClass: "rb-block",
                maskTextClass: "rb-mask",
                ignoreClass: "rb-ignore",
                slimDOMOptions: {
                    script: !0,
                    comment: !0,
                    headFavicon: !0,
                    headWhitespace: !0,
                    headMetaDescKeywords: !0,
                    headMetaSocial: !0,
                    headMetaRobots: !0,
                    headMetaHttpEquiv: !0,
                    headMetaAuthorship: !0,
                    headMetaVerification: !0
                }
            },
            tracing: {
                enabled: !1,
                endpoint: "api.rollbar.com/api/1/session/"
            }
        }, xn = Sn;
        function En(t) {
            return "string" != typeof t && (t = String(t)), t.toLowerCase();
        }
        function jn(t) {
            this.map = {}, t instanceof jn ? t.forEach(function(t, e) {
                this.append(e, t);
            }, this) : Array.isArray(t) ? t.forEach(function(t) {
                this.append(t[0], t[1]);
            }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                this.append(e, t[e]);
            }, this);
        }
        jn.prototype.append = function(t, e) {
            t = En(t), e = function(t) {
                return "string" != typeof t && (t = String(t)), t;
            }(e);
            var r = this.map[t];
            this.map[t] = r ? r + ", " + e : e;
        }, jn.prototype.get = function(t) {
            return t = En(t), this.has(t) ? this.map[t] : null;
        }, jn.prototype.has = function(t) {
            return c(this.map, En(t));
        }, jn.prototype.forEach = function(t, e) {
            for(var r in this.map)c(this.map, r) && t.call(e, this.map[r], r, this);
        }, jn.prototype.entries = function() {
            var t = [];
            return this.forEach(function(e, r) {
                t.push([
                    r,
                    e
                ]);
            }), function(t) {
                return {
                    next: function() {
                        var e = t.shift();
                        return {
                            done: void 0 === e,
                            value: e
                        };
                    }
                };
            }(t);
        };
        var In = function(t) {
            return "undefined" == typeof Headers ? new jn(t) : new Headers(t);
        };
        var Tn = function(t, e, r, n, o) {
            var i = t[e];
            t[e] = r(i), n && n[o].push([
                t,
                e,
                i
            ]);
        };
        function Pn(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return An(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? An(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function An(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Rn(t) {
            return function(t) {
                for(var e, r, n = [], o = 0, i = t.length - 1; i >= 0; i--){
                    if (e = Cn(t[i]), r = o + 3 * n.length + e.length, i < t.length - 1 && r >= 83) {
                        n.unshift("...");
                        break;
                    }
                    n.unshift(e), o += e.length;
                }
                return n.join(" > ");
            }(function(t) {
                for(var e, r = [], n = 0; t && n < 5 && (e = Ln(t)) && "html" !== e.tagName; n++)r.unshift(e), t = t.parentNode;
                return r;
            }(t));
        }
        function Cn(t) {
            if (!t || !t.tagName) return "";
            var e = [
                t.tagName
            ];
            t.id && e.push("#" + t.id), t.classes && e.push("." + t.classes.join("."));
            var r, n = Pn(t.attributes);
            try {
                for(n.s(); !(r = n.n()).done;){
                    var o = r.value;
                    e.push("[" + o.key + '="' + o.value + '"]');
                }
            } catch (t) {
                n.e(t);
            } finally{
                n.f();
            }
            return e.join("");
        }
        function Ln(t) {
            if (!t || !t.tagName) return null;
            var e, r = {};
            r.tagName = t.tagName.toLowerCase(), t.id && (r.id = t.id), (e = t.className) && "string" == typeof e && (r.classes = e.split(/\s+/));
            r.attributes = [];
            for(var n = 0, o = [
                "type",
                "name",
                "title",
                "alt"
            ]; n < o.length; n++){
                var i = o[n], a = t.getAttribute(i);
                a && r.attributes.push({
                    key: i,
                    value: a
                });
            }
            return r;
        }
        function qn(t) {
            return qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, qn(t);
        }
        function Nn(t) {
            return function(t) {
                if (Array.isArray(t)) return Fn(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || Hn(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Dn(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Mn(n.key), n);
            }
        }
        function Mn(t) {
            var e = function(t, e) {
                if ("object" != qn(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != qn(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == qn(e) ? e : e + "";
        }
        function Un(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = Hn(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function Hn(t, e) {
            if (t) {
                if ("string" == typeof t) return Fn(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Fn(t, e) : void 0;
            }
        }
        function Fn(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        var Jn = {
            network: !0,
            networkResponseHeaders: !1,
            networkResponseBody: !1,
            networkRequestHeaders: !1,
            networkRequestBody: !1,
            networkErrorOnHttp5xx: !1,
            networkErrorOnHttp4xx: !1,
            networkErrorOnHttp0: !1,
            log: !0,
            dom: !0,
            navigation: !0,
            connectivity: !0,
            contentSecurityPolicy: !0,
            errorOnContentSecurityPolicy: !1
        };
        function Vn(t, e) {
            for(var r; t[e].length;)(r = t[e].shift())[0][r[1]] = r[2];
        }
        function Bn(t) {
            var e, r = [], n = Un(t);
            try {
                for(n.s(); !(e = n.n()).done;){
                    var o = e.value;
                    r.push(new RegExp(o, "i"));
                }
            } catch (t) {
                n.e(t);
            } finally{
                n.f();
            }
            return function(t) {
                var e = function(t) {
                    if (!t || !t.attributes) return null;
                    var e, r = Un(t.attributes);
                    try {
                        for(r.s(); !(e = r.n()).done;){
                            var n = e.value;
                            if ("name" === n.key) return n.value;
                        }
                    } catch (t) {
                        r.e(t);
                    } finally{
                        r.f();
                    }
                    return null;
                }(t);
                if (!e) return !1;
                for(var n = 0, o = r; n < o.length; n++){
                    if (o[n].test(e)) return !0;
                }
                return !1;
            };
        }
        var Wn = function() {
            return function(t, e, r) {
                return e && Dn(t.prototype, e), r && Dn(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(function t(e, r, n, o, i) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), function(t, e, r) {
                    (e = Mn(e)) in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r;
                }(this, "deinstrumentConnectivity", function() {
                    this.removeListeners("connectivity");
                }), this.options = e;
                var s = e.autoInstrument;
                !1 === e.enabled || !1 === s ? this.autoInstrument = {} : (a(s, "object") || (s = Jn), this.autoInstrument = R(Jn, s)), this.configureScrubbing(), this.telemeter = r, this.rollbar = n, this.diagnostic = n.client.notifier.diagnostic, this._window = o || {}, this._document = i || {}, this.replacements = {
                    network: [],
                    log: [],
                    navigation: [],
                    connectivity: []
                }, this.eventRemovers = {
                    dom: [],
                    connectivity: [],
                    contentsecuritypolicy: []
                }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
            }, [
                {
                    key: "configureScrubbing",
                    value: function() {
                        var t, e, r, n, o, i, a, s, u, l, c = this.options;
                        this.scrubTelemetryInputs = Boolean(null !== (t = c.scrubTelemetryInputs) && void 0 !== t ? t : null === (e = c.replay) || void 0 === e ? void 0 : e.maskAllInputs), this.telemetryScrubber = c.telemetryScrubber, this.defaultValueScrubber = Bn(c.scrubFields), this.maskInputFn = null === (r = c.replay) || void 0 === r ? void 0 : r.maskInputFn, this.maskInputOptions = (null === (n = c.replay) || void 0 === n ? void 0 : n.maskInputOptions) || {}, this.scrubClasses = [
                            null === (o = c.replay) || void 0 === o ? void 0 : o.blockClass,
                            null === (i = c.replay) || void 0 === i ? void 0 : i.ignoreClass,
                            null === (a = c.replay) || void 0 === a ? void 0 : a.maskTextClass
                        ].filter(Boolean), this.scrubSelectors = [
                            null === (s = c.replay) || void 0 === s ? void 0 : s.blockSelector,
                            null === (u = c.replay) || void 0 === u ? void 0 : u.ignoreSelector,
                            null === (l = c.replay) || void 0 === l ? void 0 : l.maskTextSelector
                        ].filter(Boolean);
                    }
                },
                {
                    key: "configure",
                    value: function(t) {
                        this.options = R(this.options, t);
                        var e = t.autoInstrument, r = R(this.autoInstrument);
                        !1 === t.enabled || !1 === e ? this.autoInstrument = {} : (a(e, "object") || (e = Jn), this.autoInstrument = R(Jn, e)), this.configureScrubbing(), this.instrument(r);
                    }
                },
                {
                    key: "instrument",
                    value: function(t) {
                        !this.autoInstrument.network || t && t.network ? !this.autoInstrument.network && t && t.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || t && t.log ? !this.autoInstrument.log && t && t.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || t && t.dom ? !this.autoInstrument.dom && t && t.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || t && t.navigation ? !this.autoInstrument.navigation && t && t.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || t && t.connectivity ? !this.autoInstrument.connectivity && t && t.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || t && t.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && t && t.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
                    }
                },
                {
                    key: "deinstrumentNetwork",
                    value: function() {
                        Vn(this.replacements, "network");
                    }
                },
                {
                    key: "instrumentNetwork",
                    value: function() {
                        var t = this;
                        function e(e, r) {
                            e in r && u(r[e]) && Tn(r, e, function(e) {
                                return t.rollbar.wrap(e);
                            });
                        }
                        if ("XMLHttpRequest" in this._window) {
                            var r = this._window.XMLHttpRequest.prototype;
                            Tn(r, "open", function(t) {
                                return function(e, r) {
                                    var n = $n(r);
                                    return (a(r, "string") || n) && (r = n ? r.toString() : r, this.__rollbar_xhr ? (this.__rollbar_xhr.method = e, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = P(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                        method: e,
                                        url: r,
                                        status_code: null,
                                        start_time_ms: P(),
                                        end_time_ms: null
                                    }), t.apply(this, arguments);
                                };
                            }, this.replacements, "network"), Tn(r, "setRequestHeader", function(e) {
                                return function(r, n) {
                                    return this.__rollbar_xhr || (this.__rollbar_xhr = {}), a(r, "string") && a(n, "string") && (t.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = n), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = n)), e.apply(this, arguments);
                                };
                            }, this.replacements, "network"), Tn(r, "send", function(r) {
                                return function(n) {
                                    var o, i, a = this, s = null === (o = t.rollbar) || void 0 === o ? void 0 : o.tracing;
                                    if (C(t.options, s, null === (i = a.__rollbar_xhr) || void 0 === i ? void 0 : i.url)) try {
                                        a.setRequestHeader("baggage", "rollbar.session.id=".concat(s.sessionId));
                                    } catch (t) {}
                                    function l() {
                                        if (a.__rollbar_xhr && (null === a.__rollbar_xhr.status_code && (a.__rollbar_xhr.status_code = 0, t.autoInstrument.networkRequestBody && (a.__rollbar_xhr.request = n), a.__rollbar_event = t.captureNetwork(a.__rollbar_xhr, "xhr", void 0)), a.readyState < 2 && (a.__rollbar_xhr.start_time_ms = P()), a.readyState > 3)) {
                                            var e = P();
                                            a.__rollbar_xhr.end_time_ms = e;
                                            var r = null;
                                            if (a.__rollbar_xhr.response_content_type = a.getResponseHeader("Content-Type"), t.autoInstrument.networkResponseHeaders) {
                                                var o = t.autoInstrument.networkResponseHeaders;
                                                r = {};
                                                try {
                                                    var i;
                                                    if (!0 === o) {
                                                        var s = a.getAllResponseHeaders();
                                                        if (s) {
                                                            var u, l, c, f = Un(s.trim().split(/[\r\n]+/));
                                                            try {
                                                                for(f.s(); !(c = f.n()).done;)i = (u = c.value.split(": ")).shift(), l = u.join(": "), r[i] = l;
                                                            } catch (t) {
                                                                f.e(t);
                                                            } finally{
                                                                f.f();
                                                            }
                                                        }
                                                    } else {
                                                        var p, d = Un(o);
                                                        try {
                                                            for(d.s(); !(p = d.n()).done;){
                                                                var h = p.value;
                                                                r[h] = a.getResponseHeader(h);
                                                            }
                                                        } catch (t) {
                                                            d.e(t);
                                                        } finally{
                                                            d.f();
                                                        }
                                                    }
                                                } catch (t) {}
                                            }
                                            var y = null;
                                            if (t.autoInstrument.networkResponseBody) try {
                                                y = a.responseText;
                                            } catch (t) {}
                                            var v = null;
                                            (y || r) && (v = {}, y && (t.isJsonContentType(a.__rollbar_xhr.response_content_type) ? v.body = t.scrubJson(y) : v.body = y), r && (v.headers = r)), v && (a.__rollbar_xhr.response = v);
                                            try {
                                                var m = a.status;
                                                m = 1223 === m ? 204 : m, a.__rollbar_xhr.status_code = m, t.addOtelNetworkResponse(a.__rollbar_event, e, m), a.__rollbar_event.level = t.telemeter.levelFromStatus(m), t.errorOnHttpStatus(a.__rollbar_xhr);
                                            } catch (t) {}
                                        }
                                    }
                                    return e("onload", a), e("onerror", a), e("onprogress", a), "onreadystatechange" in a && u(a.onreadystatechange) ? Tn(a, "onreadystatechange", function(e) {
                                        return t.rollbar.wrap(e, void 0, l);
                                    }) : a.onreadystatechange = l, a.__rollbar_xhr && t.trackHttpErrors() && (a.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                                };
                            }, this.replacements, "network");
                        }
                        "fetch" in this._window && Tn(this._window, "fetch", function(e) {
                            return function(r, n) {
                                var o, i, s = Array.prototype.slice.call(arguments), u = s[0], l = "GET", c = $n(u);
                                a(u, "string") || c ? i = c ? u.toString() : u : u && (i = u.url, u.method && (l = u.method)), s[1] && s[1].method && (l = s[1].method);
                                var f = null === (o = t.rollbar) || void 0 === o ? void 0 : o.tracing;
                                C(t.options, f, i) && L(s, {
                                    baggage: "rollbar.session.id=".concat(f.sessionId)
                                });
                                var p = {
                                    method: l,
                                    url: i,
                                    status_code: null,
                                    start_time_ms: P(),
                                    end_time_ms: null
                                };
                                if (s[1] && s[1].headers) {
                                    var d = In(s[1].headers);
                                    p.request_content_type = d.get("Content-Type"), t.autoInstrument.networkRequestHeaders && (p.request_headers = t.fetchHeaders(d, t.autoInstrument.networkRequestHeaders));
                                }
                                t.autoInstrument.networkRequestBody && (s[1] && s[1].body ? p.request = s[1].body : s[0] && !a(s[0], "string") && s[0].body && (p.request = s[0].body));
                                var h = t.captureNetwork(p, "fetch", void 0);
                                return t.trackHttpErrors() && (p.stack = (new Error).stack), e.apply(this, s).then(function(e) {
                                    var r = P();
                                    p.end_time_ms = r, p.status_code = e.status, t.addOtelNetworkResponse(h, r, e.status), p.response_content_type = e.headers.get("Content-Type");
                                    var n = null;
                                    t.autoInstrument.networkResponseHeaders && (n = t.fetchHeaders(e.headers, t.autoInstrument.networkResponseHeaders));
                                    var o = null;
                                    return t.autoInstrument.networkResponseBody && "function" == typeof e.text && (o = e.clone().text()), (n || o) && (p.response = {}, o && ("function" == typeof o.then ? o.then(function(e) {
                                        e && t.isJsonContentType(p.response_content_type) ? p.response.body = t.scrubJson(e) : p.response.body = e;
                                    }) : p.response.body = o), n && (p.response.headers = n)), t.errorOnHttpStatus(p), e;
                                });
                            };
                        }, this.replacements, "network");
                    }
                },
                {
                    key: "captureNetwork",
                    value: function(t, e, r) {
                        return t.request && this.isJsonContentType(t.request_content_type) && (t.request = this.scrubJson(t.request)), this.telemeter.captureNetwork(t, e, r);
                    }
                },
                {
                    key: "isJsonContentType",
                    value: function(t) {
                        return !!(t && a(t, "string") && t.toLowerCase().includes("json"));
                    }
                },
                {
                    key: "addOtelNetworkResponse",
                    value: function(t, e, r) {
                        t.otelAttributes && (t.otelAttributes["response.timeUnixNano"] = (1e6 * e).toString(), t.otelAttributes.statusCode = r);
                    }
                },
                {
                    key: "scrubJson",
                    value: function(t) {
                        return JSON.stringify(F(JSON.parse(t), this.options.scrubFields));
                    }
                },
                {
                    key: "fetchHeaders",
                    value: function(t, e) {
                        var r = {};
                        try {
                            if (!0 === e) {
                                if ("function" == typeof t.entries) for(var n = t.entries(), o = n.next(); !o.done;)r[o.value[0]] = o.value[1], o = n.next();
                            } else {
                                var i, a = Un(e);
                                try {
                                    for(a.s(); !(i = a.n()).done;){
                                        var s = i.value;
                                        r[s] = t.get(s);
                                    }
                                } catch (t) {
                                    a.e(t);
                                } finally{
                                    a.f();
                                }
                            }
                        } catch (t) {}
                        return r;
                    }
                },
                {
                    key: "trackHttpErrors",
                    value: function() {
                        return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
                    }
                },
                {
                    key: "errorOnHttpStatus",
                    value: function(t) {
                        var e = t.status_code;
                        if (e >= 500 && this.autoInstrument.networkErrorOnHttp5xx || e >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === e && this.autoInstrument.networkErrorOnHttp0) {
                            var r = new Error("HTTP request failed with Status " + e);
                            r.stack = t.stack, this.rollbar.error(r, {
                                skipFrames: 1
                            });
                        }
                    }
                },
                {
                    key: "deinstrumentConsole",
                    value: function() {
                        for(var t; this.replacements.log.length;)t = this.replacements.log.shift(), this._window.console[t[0]] = t[1];
                    }
                },
                {
                    key: "instrumentConsole",
                    value: function() {
                        var t;
                        if (null !== (t = this._window) && void 0 !== t && null !== (t = t.console) && void 0 !== t && t.log) {
                            var e = this, r = this._window.console;
                            try {
                                for(var n = 0, o = [
                                    "debug",
                                    "info",
                                    "warn",
                                    "error",
                                    "log"
                                ]; n < o.length; n++)i(o[n]);
                            } catch (t) {
                                this.diagnostic.instrumentConsole = {
                                    error: t.message
                                };
                            }
                        }
                        function i(t) {
                            var n = r[t], o = r, i = "warn" === t ? "warning" : t;
                            r[t] = function() {
                                var t = Array.prototype.slice.call(arguments), r = function(t) {
                                    var e, r, n, o = [];
                                    for(e = 0, r = t.length; e < r; ++e){
                                        switch(s(n = t[e])){
                                            case "object":
                                                (n = (n = b(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                                break;
                                            case "null":
                                                n = "null";
                                                break;
                                            case "undefined":
                                                n = "undefined";
                                                break;
                                            case "symbol":
                                                n = n.toString();
                                        }
                                        o.push(n);
                                    }
                                    return o.join(" ");
                                }(t);
                                e.telemeter.captureLog(r, i, null, P()), n && Function.prototype.apply.call(n, o, t);
                            }, e.replacements.log.push([
                                t,
                                n
                            ]);
                        }
                    }
                },
                {
                    key: "deinstrumentDom",
                    value: function() {
                        this.removeListeners("dom");
                    }
                },
                {
                    key: "instrumentDom",
                    value: function() {
                        var t = this;
                        this.addListener("dom", this._window, [
                            "click",
                            "dblclick",
                            "contextmenu"
                        ], function(e) {
                            return t.handleEvent("click", e);
                        }), this.addListener("dom", this._window, [
                            "dragstart",
                            "dragend",
                            "dragenter",
                            "dragleave",
                            "drop"
                        ], function(e) {
                            return t.handleEvent("dragdrop", e);
                        }), this.addListener("dom", this._window, [
                            "blur",
                            "focus"
                        ], function(e) {
                            return t.handleEvent("focus", e);
                        }), this.addListener("dom", this._window, [
                            "submit",
                            "invalid"
                        ], function(e) {
                            return t.handleEvent("form", e);
                        }), this.addListener("dom", this._window, [
                            "input",
                            "change"
                        ], function(e) {
                            return t.handleEvent("input", e);
                        }), this.addListener("dom", this._window, [
                            "resize"
                        ], function(e) {
                            return t.handleEvent("resize", e);
                        }), this.addListener("dom", this._document, [
                            "DOMContentLoaded"
                        ], function(e) {
                            return t.handleEvent("contentLoaded", e);
                        });
                    }
                },
                {
                    key: "handleEvent",
                    value: function(t, e) {
                        try {
                            return ({
                                click: this.handleClick,
                                dragdrop: this.handleDrag,
                                focus: this.handleFocus,
                                form: this.handleForm,
                                input: this.handleInput,
                                resize: this.handleResize,
                                contentLoaded: this.handleContentLoaded
                            })[t].call(this, e);
                        } catch (r) {
                            Ct.log("".concat(t, " handler error"), e, r, r.stack);
                        }
                    }
                },
                {
                    key: "handleContentLoaded",
                    value: function(t) {
                        this.rollbar.triggerReplay({
                            type: "navigation",
                            path: new URL(this._location.href).pathname
                        });
                    }
                },
                {
                    key: "handleClick",
                    value: function(t) {
                        var e, r = null === (e = t.target) || void 0 === e ? void 0 : e.tagName.toLowerCase();
                        [
                            "input",
                            "select",
                            "textarea"
                        ].includes(r) || this.telemeter.captureClick({
                            type: t.type,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleFocus",
                    value: function(t) {
                        var e, r = t.type, n = null !== (e = t.target) && void 0 !== e && e.window ? "window" : Rn(t.target);
                        this.telemeter.captureFocus({
                            type: r,
                            isSynthetic: !t.isTrusted,
                            element: n,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleForm",
                    value: function(t) {}
                },
                {
                    key: "handleResize",
                    value: function(t) {
                        var e = window.screen.width / window.innerWidth;
                        this.telemeter.captureResize({
                            type: t.type,
                            isSynthetic: !t.isTrusted,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            textZoomRatio: e,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleDrag",
                    value: function(t) {
                        var e, r, n, o, i, a, s = t.type;
                        if ("drop" === s) {
                            e = [], r = [];
                            var u, l = Un([].concat(Nn(t.dataTransfer.files), Nn(t.dataTransfer.items)));
                            try {
                                for(l.s(); !(u = l.n()).done;){
                                    var c = u.value;
                                    c.kind && c.type && (e.push(c.kind), r.push(c.type));
                                }
                            } catch (t) {
                                l.e(t);
                            } finally{
                                l.f();
                            }
                        }
                        [
                            "drop",
                            "dragstart"
                        ].includes(s) && (n = null === (i = t.dataTransfer) || void 0 === i ? void 0 : i.dropEffect, o = null === (a = t.dataTransfer) || void 0 === a ? void 0 : a.effectAllowed);
                        this.telemeter.captureDragDrop({
                            type: s,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            dropEffect: n,
                            effectAllowed: o,
                            kinds: JSON.stringify(e),
                            mediaTypes: JSON.stringify(r),
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "scrubInputValue",
                    value: function(t, e, r, n) {
                        var o = "******";
                        if ("password" === n) return o;
                        if (this.scrubTelemetryInputs) return o;
                        var i = Ln(e);
                        if (this.telemetryScrubber) {
                            if (this.telemetryScrubber(i)) return o;
                        } else if (this.defaultValueScrubber(i)) return o;
                        return function(t, e, r) {
                            try {
                                var n, o = Pn(e);
                                try {
                                    for(o.s(); !(n = o.n()).done;){
                                        var i = n.value;
                                        if ("string" == typeof i) {
                                            if (t.classList.contains(i)) return !0;
                                        } else {
                                            var a, s = Pn(t.classList);
                                            try {
                                                for(s.s(); !(a = s.n()).done;){
                                                    var u = a.value;
                                                    if (i.test(u)) return !0;
                                                }
                                            } catch (t) {
                                                s.e(t);
                                            } finally{
                                                s.f();
                                            }
                                        }
                                    }
                                } catch (t) {
                                    o.e(t);
                                } finally{
                                    o.f();
                                }
                                var l, c = Pn(r);
                                try {
                                    for(c.s(); !(l = c.n()).done;){
                                        var f = l.value;
                                        if (t.matches(f)) return !0;
                                    }
                                } catch (t) {
                                    c.e(t);
                                } finally{
                                    c.f();
                                }
                            } catch (t) {}
                            return !1;
                        }(e, this.scrubClasses, this.scrubSelectors) ? o : this.maskInputOptions[r.toLowerCase()] || this.maskInputOptions[n] ? this.maskInputFn ? this.maskInputFn(t, e) : o : t;
                    }
                },
                {
                    key: "handleInput",
                    value: function(t) {
                        var e, r, n, o, i = t.type, a = null === (e = t.target) || void 0 === e ? void 0 : e.tagName.toLowerCase(), s = null === (r = t.target) || void 0 === r ? void 0 : r.value, u = (null === (n = t.target) || void 0 === n || null === (n = n.attributes) || void 0 === n || null === (n = n.type) || void 0 === n ? void 0 : n.value) || (null === (o = t.target) || void 0 === o ? void 0 : o.type);
                        switch(void 0 !== s && (s = this.scrubInputValue(s, t.target, a, u)), i){
                            case "input":
                                if ([
                                    "radio",
                                    "checkbox"
                                ].includes(u)) return;
                                [
                                    "select",
                                    "textarea"
                                ].includes(a) && (u = a);
                                break;
                            case "change":
                                if (![
                                    "radio",
                                    "checkbox"
                                ].includes(u)) return;
                                var l;
                                if ("checkbox" === u) s = null === (l = t.target) || void 0 === l ? void 0 : l.checked;
                        }
                        this.telemeter.captureInput({
                            type: u,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            value: s,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "deinstrumentNavigation",
                    value: function() {
                        var t = this._window.chrome;
                        !(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState && Vn(this.replacements, "navigation");
                    }
                },
                {
                    key: "instrumentNavigation",
                    value: function() {
                        var t = this._window.chrome;
                        if (!(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState) {
                            var e = this;
                            Tn(this._window, "onpopstate", function(t) {
                                return function() {
                                    var r = e._location.href;
                                    e.handleUrlChange(e._lastHref, r), t && t.apply(this, arguments);
                                };
                            }, this.replacements, "navigation"), Tn(this._window.history, "pushState", function(t) {
                                return function() {
                                    var r = arguments.length > 2 ? arguments[2] : void 0;
                                    return r && e.handleUrlChange(e._lastHref, String(r)), t.apply(this, arguments);
                                };
                            }, this.replacements, "navigation");
                        }
                    }
                },
                {
                    key: "handleUrlChange",
                    value: function(t, e) {
                        var r = hn(this._location.href), n = hn(e), o = hn(t);
                        this._lastHref = e, r.protocol === n.protocol && r.host === n.host && (e = n.path + (n.hash || "")), r.protocol === o.protocol && r.host === o.host && (t = o.path + (o.hash || "")), this.telemeter.captureNavigation(t, e, null, P()), this.rollbar.triggerReplay({
                            type: "navigation",
                            path: e
                        });
                    }
                },
                {
                    key: "instrumentConnectivity",
                    value: function() {
                        var t = this;
                        this.addListener("connectivity", this._window, [
                            "online",
                            "offline"
                        ], function(e) {
                            return t.handleConnectivity(e);
                        });
                    }
                },
                {
                    key: "handleConnectivity",
                    value: function(t) {
                        var e = t.type;
                        this.telemeter.captureConnectivityChange({
                            type: e,
                            isSynthetic: !t.isTrusted,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleCspEvent",
                    value: function(t) {
                        var e = "Security Policy Violation: blockedURI: " + t.blockedURI + ", violatedDirective: " + t.violatedDirective + ", effectiveDirective: " + t.effectiveDirective + ", ";
                        t.sourceFile && (e += "location: " + t.sourceFile + ", line: " + t.lineNumber + ", col: " + t.columnNumber + ", "), e += "originalPolicy: " + t.originalPolicy, this.telemeter.captureLog(e, "error", null, P()), this.handleCspError(e);
                    }
                },
                {
                    key: "handleCspError",
                    value: function(t) {
                        this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(t);
                    }
                },
                {
                    key: "deinstrumentContentSecurityPolicy",
                    value: function() {
                        this.removeListeners("contentsecuritypolicy");
                    }
                },
                {
                    key: "instrumentContentSecurityPolicy",
                    value: function() {
                        if ("addEventListener" in this._document) {
                            var t = this.handleCspEvent.bind(this);
                            this.addListener("contentsecuritypolicy", this._document, [
                                "securitypolicyviolation"
                            ], t);
                        }
                    }
                },
                {
                    key: "addListener",
                    value: function(t, e, r, n) {
                        var o = this;
                        if (e.addEventListener) {
                            var i, a = Un(r);
                            try {
                                var s = function() {
                                    var r = i.value, a = {
                                        capture: !0,
                                        passive: !0
                                    };
                                    e.addEventListener(r, n, a, !0), o.eventRemovers[t].push(function() {
                                        e.removeEventListener(r, n, a);
                                    });
                                };
                                for(a.s(); !(i = a.n()).done;)s();
                            } catch (t) {
                                a.e(t);
                            } finally{
                                a.f();
                            }
                        }
                    }
                },
                {
                    key: "removeListeners",
                    value: function(t) {
                        for(; this.eventRemovers[t].length;)this.eventRemovers[t].shift()();
                    }
                }
            ]);
        }();
        function $n(t) {
            return "undefined" != typeof URL && t instanceof URL;
        }
        var Gn = Wn;
        function zn(t, e, r) {
            if (c(e, "addEventListener")) {
                for(var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                var o = function(e, r, o) {
                    n.call(this, e, t.wrap(r), o);
                };
                o._rollbarOldAdd = n, o.belongsToShim = r, e.addEventListener = o;
                for(var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;)i = i._rollbarOldRemove;
                var a = function(t, e, r) {
                    i.call(this, t, e && e._rollbar_wrapped || e, r);
                };
                a._rollbarOldRemove = i, a.belongsToShim = r, e.removeEventListener = a;
            }
        }
        var Xn = function(t, e, r) {
            if (t) {
                var n, o, i = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                for(n = 0; n < i.length; ++n)t[o = i[n]] && t[o].prototype && zn(e, t[o].prototype, r);
            }
        };
        xn.setComponents({
            telemeter: Y,
            instrumenter: Gn,
            wrapGlobals: Xn,
            scrub: F,
            truncation: we,
            tracing: se
        });
        var Zn = xn, Qn = "undefined" != typeof window && window._rollbarConfig, Kn = Qn && Qn.globalAlias || "Rollbar", Yn = "undefined" != typeof window && window[Kn] && "function" == typeof window[Kn].shimId && void 0 !== window[Kn].shimId();
        if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !Yn && Qn) {
            var to = new Zn(Qn);
            window[Kn] = to;
        } else "undefined" != typeof window ? (window.rollbar = Zn, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = Zn, self._rollbarDidLoad = !0);
        var eo = Zn;
        return e = e.default;
    }();
});

});

parcelRegister("brnsE", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $85446a31c46e5d8b$export$caec2af78bcc877f; });
$parcel$export(module.exports, "Button", function () { return $85446a31c46e5d8b$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "Carousel", function () { return $85446a31c46e5d8b$export$144901db2ea8e967; });
$parcel$export(module.exports, "Collapse", function () { return $85446a31c46e5d8b$export$78768a9af065a7b; });
$parcel$export(module.exports, "Dropdown", function () { return $85446a31c46e5d8b$export$931cbfb6bfb85fc; });
$parcel$export(module.exports, "Modal", function () { return $85446a31c46e5d8b$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "Offcanvas", function () { return $85446a31c46e5d8b$export$591ca0244c9dfcd4; });
$parcel$export(module.exports, "Tooltip", function () { return $85446a31c46e5d8b$export$28c660c63b792dea; });
$parcel$export(module.exports, "Popover", function () { return $85446a31c46e5d8b$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "ScrollSpy", function () { return $85446a31c46e5d8b$export$a6472a5298a374be; });
$parcel$export(module.exports, "Tab", function () { return $85446a31c46e5d8b$export$3e41faf802a29e71; });
$parcel$export(module.exports, "Toast", function () { return $85446a31c46e5d8b$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $e4h34 = parcelRequire("e4h34");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$elementMap = new Map();
const $85446a31c46e5d8b$var$Data = {
    set (element, key, instance) {
        if (!$85446a31c46e5d8b$var$elementMap.has(element)) $85446a31c46e5d8b$var$elementMap.set(element, new Map());
        const instanceMap = $85446a31c46e5d8b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($85446a31c46e5d8b$var$elementMap.has(element)) return $85446a31c46e5d8b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$85446a31c46e5d8b$var$elementMap.has(element)) return;
        const instanceMap = $85446a31c46e5d8b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $85446a31c46e5d8b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$MAX_UID = 1000000;
const $85446a31c46e5d8b$var$MILLISECONDS_MULTIPLIER = 1000;
const $85446a31c46e5d8b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $85446a31c46e5d8b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $85446a31c46e5d8b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $85446a31c46e5d8b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $85446a31c46e5d8b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $85446a31c46e5d8b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $85446a31c46e5d8b$var$MILLISECONDS_MULTIPLIER;
};
const $85446a31c46e5d8b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($85446a31c46e5d8b$var$TRANSITION_END));
};
const $85446a31c46e5d8b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $85446a31c46e5d8b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($85446a31c46e5d8b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($85446a31c46e5d8b$var$parseSelector(object));
    return null;
};
const $85446a31c46e5d8b$var$isVisible = (element)=>{
    if (!$85446a31c46e5d8b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $85446a31c46e5d8b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $85446a31c46e5d8b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $85446a31c46e5d8b$var$findShadowRoot(element.parentNode);
};
const $85446a31c46e5d8b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $85446a31c46e5d8b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $85446a31c46e5d8b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $85446a31c46e5d8b$var$DOMContentLoadedCallbacks = [];
const $85446a31c46e5d8b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$85446a31c46e5d8b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $85446a31c46e5d8b$var$DOMContentLoadedCallbacks)callback();
        });
        $85446a31c46e5d8b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $85446a31c46e5d8b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $85446a31c46e5d8b$var$defineJQueryPlugin = (plugin)=>{
    $85446a31c46e5d8b$var$onDOMContentLoaded(()=>{
        const $ = $85446a31c46e5d8b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $85446a31c46e5d8b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $85446a31c46e5d8b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $85446a31c46e5d8b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $85446a31c46e5d8b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($85446a31c46e5d8b$var$TRANSITION_END, handler);
        $85446a31c46e5d8b$var$execute(callback);
    };
    transitionElement.addEventListener($85446a31c46e5d8b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $85446a31c46e5d8b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $85446a31c46e5d8b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $85446a31c46e5d8b$var$stripNameRegex = /\..*/;
const $85446a31c46e5d8b$var$stripUidRegex = /::\d+$/;
const $85446a31c46e5d8b$var$eventRegistry = {}; // Events storage
let $85446a31c46e5d8b$var$uidEvent = 1;
const $85446a31c46e5d8b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $85446a31c46e5d8b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $85446a31c46e5d8b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$85446a31c46e5d8b$var$uidEvent++}` || element.uidEvent || $85446a31c46e5d8b$var$uidEvent++;
}
function $85446a31c46e5d8b$var$getElementEvents(element) {
    const uid = $85446a31c46e5d8b$var$makeEventUid(element);
    element.uidEvent = uid;
    $85446a31c46e5d8b$var$eventRegistry[uid] = $85446a31c46e5d8b$var$eventRegistry[uid] || {};
    return $85446a31c46e5d8b$var$eventRegistry[uid];
}
function $85446a31c46e5d8b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $85446a31c46e5d8b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $85446a31c46e5d8b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $85446a31c46e5d8b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $85446a31c46e5d8b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $85446a31c46e5d8b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $85446a31c46e5d8b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $85446a31c46e5d8b$var$getTypeEvent(originalTypeEvent);
    if (!$85446a31c46e5d8b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $85446a31c46e5d8b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $85446a31c46e5d8b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $85446a31c46e5d8b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $85446a31c46e5d8b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $85446a31c46e5d8b$var$makeEventUid(callable, originalTypeEvent.replace($85446a31c46e5d8b$var$namespaceRegex, ''));
    const fn = isDelegated ? $85446a31c46e5d8b$var$bootstrapDelegationHandler(element, handler, callable) : $85446a31c46e5d8b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $85446a31c46e5d8b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $85446a31c46e5d8b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $85446a31c46e5d8b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($85446a31c46e5d8b$var$stripNameRegex, '');
    return $85446a31c46e5d8b$var$customEvents[event] || event;
}
const $85446a31c46e5d8b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $85446a31c46e5d8b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $85446a31c46e5d8b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $85446a31c46e5d8b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$85446a31c46e5d8b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($85446a31c46e5d8b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $85446a31c46e5d8b$var$getjQuery();
        const typeEvent = $85446a31c46e5d8b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $85446a31c46e5d8b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $85446a31c46e5d8b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $85446a31c46e5d8b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $85446a31c46e5d8b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $85446a31c46e5d8b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $85446a31c46e5d8b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $85446a31c46e5d8b$var$normalizeData(element.getAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $85446a31c46e5d8b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $85446a31c46e5d8b$var$isElement(element) ? $85446a31c46e5d8b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$85446a31c46e5d8b$var$isElement(element) ? $85446a31c46e5d8b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $85446a31c46e5d8b$var$isElement(value) ? 'element' : $85446a31c46e5d8b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$BaseComponent extends $85446a31c46e5d8b$var$Config {
    constructor(element, config){
        super();
        element = $85446a31c46e5d8b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $85446a31c46e5d8b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $85446a31c46e5d8b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $85446a31c46e5d8b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $85446a31c46e5d8b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $85446a31c46e5d8b$var$Data.get($85446a31c46e5d8b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $85446a31c46e5d8b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$85446a31c46e5d8b$var$parseSelector(sel)).join(',') : null;
};
const $85446a31c46e5d8b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$85446a31c46e5d8b$var$isDisabled(el) && $85446a31c46e5d8b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        if (selector) return $85446a31c46e5d8b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        return selector ? $85446a31c46e5d8b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        return selector ? $85446a31c46e5d8b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $85446a31c46e5d8b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($85446a31c46e5d8b$var$isDisabled(this)) return;
        const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$f = 'alert';
const $85446a31c46e5d8b$var$DATA_KEY$a = 'bs.alert';
const $85446a31c46e5d8b$var$EVENT_KEY$b = `.${$85446a31c46e5d8b$var$DATA_KEY$a}`;
const $85446a31c46e5d8b$var$EVENT_CLOSE = `close${$85446a31c46e5d8b$var$EVENT_KEY$b}`;
const $85446a31c46e5d8b$var$EVENT_CLOSED = `closed${$85446a31c46e5d8b$var$EVENT_KEY$b}`;
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$5 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$caec2af78bcc877f extends $85446a31c46e5d8b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$e = 'button';
const $85446a31c46e5d8b$var$DATA_KEY$9 = 'bs.button';
const $85446a31c46e5d8b$var$EVENT_KEY$a = `.${$85446a31c46e5d8b$var$DATA_KEY$9}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$6 = '.data-api';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$6 = `click${$85446a31c46e5d8b$var$EVENT_KEY$a}${$85446a31c46e5d8b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$353f5b6fc5456de1 extends $85446a31c46e5d8b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$6, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $85446a31c46e5d8b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$d = 'swipe';
const $85446a31c46e5d8b$var$EVENT_KEY$9 = '.bs.swipe';
const $85446a31c46e5d8b$var$EVENT_TOUCHSTART = `touchstart${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_TOUCHMOVE = `touchmove${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_TOUCHEND = `touchend${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_POINTERDOWN = `pointerdown${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_POINTERUP = `pointerup${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$POINTER_TYPE_TOUCH = 'touch';
const $85446a31c46e5d8b$var$POINTER_TYPE_PEN = 'pen';
const $85446a31c46e5d8b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $85446a31c46e5d8b$var$SWIPE_THRESHOLD = 40;
const $85446a31c46e5d8b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $85446a31c46e5d8b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$Swipe extends $85446a31c46e5d8b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$85446a31c46e5d8b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$c;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$c;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$d;
    }
    // Public
    dispose() {
        $85446a31c46e5d8b$var$EventHandler.off(this._element, $85446a31c46e5d8b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $85446a31c46e5d8b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $85446a31c46e5d8b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $85446a31c46e5d8b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $85446a31c46e5d8b$var$POINTER_TYPE_PEN || event.pointerType === $85446a31c46e5d8b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$c = 'carousel';
const $85446a31c46e5d8b$var$DATA_KEY$8 = 'bs.carousel';
const $85446a31c46e5d8b$var$EVENT_KEY$8 = `.${$85446a31c46e5d8b$var$DATA_KEY$8}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$5 = '.data-api';
const $85446a31c46e5d8b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $85446a31c46e5d8b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $85446a31c46e5d8b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $85446a31c46e5d8b$var$ORDER_NEXT = 'next';
const $85446a31c46e5d8b$var$ORDER_PREV = 'prev';
const $85446a31c46e5d8b$var$DIRECTION_LEFT = 'left';
const $85446a31c46e5d8b$var$DIRECTION_RIGHT = 'right';
const $85446a31c46e5d8b$var$EVENT_SLIDE = `slide${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_SLID = `slid${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN$1 = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEENTER$1 = `mouseenter${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_DRAG_START = `dragstart${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$3 = `load${$85446a31c46e5d8b$var$EVENT_KEY$8}${$85446a31c46e5d8b$var$DATA_API_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$5 = `click${$85446a31c46e5d8b$var$EVENT_KEY$8}${$85446a31c46e5d8b$var$DATA_API_KEY$5}`;
const $85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $85446a31c46e5d8b$var$CLASS_NAME_SLIDE = 'slide';
const $85446a31c46e5d8b$var$CLASS_NAME_END = 'carousel-item-end';
const $85446a31c46e5d8b$var$CLASS_NAME_START = 'carousel-item-start';
const $85446a31c46e5d8b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $85446a31c46e5d8b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVE = '.active';
const $85446a31c46e5d8b$var$SELECTOR_ITEM = '.carousel-item';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVE_ITEM = $85446a31c46e5d8b$var$SELECTOR_ACTIVE + $85446a31c46e5d8b$var$SELECTOR_ITEM;
const $85446a31c46e5d8b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $85446a31c46e5d8b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $85446a31c46e5d8b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $85446a31c46e5d8b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $85446a31c46e5d8b$var$KEY_TO_DIRECTION = {
    [$85446a31c46e5d8b$var$ARROW_LEFT_KEY$1]: $85446a31c46e5d8b$var$DIRECTION_RIGHT,
    [$85446a31c46e5d8b$var$ARROW_RIGHT_KEY$1]: $85446a31c46e5d8b$var$DIRECTION_LEFT
};
const $85446a31c46e5d8b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $85446a31c46e5d8b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$144901db2ea8e967 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$b;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$b;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($85446a31c46e5d8b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $85446a31c46e5d8b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($85446a31c46e5d8b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $85446a31c46e5d8b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $85446a31c46e5d8b$var$ORDER_NEXT : $85446a31c46e5d8b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $85446a31c46e5d8b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_ITEM_IMG, this._element))$85446a31c46e5d8b$var$EventHandler.on(img, $85446a31c46e5d8b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $85446a31c46e5d8b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($85446a31c46e5d8b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($85446a31c46e5d8b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $85446a31c46e5d8b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $85446a31c46e5d8b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $85446a31c46e5d8b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $85446a31c46e5d8b$var$ORDER_NEXT;
        const nextElement = element || $85446a31c46e5d8b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $85446a31c46e5d8b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($85446a31c46e5d8b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $85446a31c46e5d8b$var$CLASS_NAME_START : $85446a31c46e5d8b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $85446a31c46e5d8b$var$CLASS_NAME_NEXT : $85446a31c46e5d8b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $85446a31c46e5d8b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($85446a31c46e5d8b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($85446a31c46e5d8b$var$isRTL()) return direction === $85446a31c46e5d8b$var$DIRECTION_LEFT ? $85446a31c46e5d8b$var$ORDER_PREV : $85446a31c46e5d8b$var$ORDER_NEXT;
        return direction === $85446a31c46e5d8b$var$DIRECTION_LEFT ? $85446a31c46e5d8b$var$ORDER_NEXT : $85446a31c46e5d8b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($85446a31c46e5d8b$var$isRTL()) return order === $85446a31c46e5d8b$var$ORDER_PREV ? $85446a31c46e5d8b$var$DIRECTION_LEFT : $85446a31c46e5d8b$var$DIRECTION_RIGHT;
        return order === $85446a31c46e5d8b$var$ORDER_PREV ? $85446a31c46e5d8b$var$DIRECTION_RIGHT : $85446a31c46e5d8b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$5, $85446a31c46e5d8b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($85446a31c46e5d8b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$b = 'collapse';
const $85446a31c46e5d8b$var$DATA_KEY$7 = 'bs.collapse';
const $85446a31c46e5d8b$var$EVENT_KEY$7 = `.${$85446a31c46e5d8b$var$DATA_KEY$7}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$4 = '.data-api';
const $85446a31c46e5d8b$var$EVENT_SHOW$6 = `show${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$6 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$6 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$6 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$4 = `click${$85446a31c46e5d8b$var$EVENT_KEY$7}${$85446a31c46e5d8b$var$DATA_API_KEY$4}`;
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $85446a31c46e5d8b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE} .${$85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE}`;
const $85446a31c46e5d8b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $85446a31c46e5d8b$var$WIDTH = 'width';
const $85446a31c46e5d8b$var$HEIGHT = 'height';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $85446a31c46e5d8b$var$Default$a = {
    parent: null,
    toggle: true
};
const $85446a31c46e5d8b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$78768a9af065a7b extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $85446a31c46e5d8b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $85446a31c46e5d8b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$a;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$a;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($85446a31c46e5d8b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $85446a31c46e5d8b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_HORIZONTAL) ? $85446a31c46e5d8b$var$WIDTH : $85446a31c46e5d8b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $85446a31c46e5d8b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$4, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.getMultipleElementsFromSelector(this))$85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$a = 'dropdown';
const $85446a31c46e5d8b$var$DATA_KEY$6 = 'bs.dropdown';
const $85446a31c46e5d8b$var$EVENT_KEY$6 = `.${$85446a31c46e5d8b$var$DATA_KEY$6}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$3 = '.data-api';
const $85446a31c46e5d8b$var$ESCAPE_KEY$2 = 'Escape';
const $85446a31c46e5d8b$var$TAB_KEY$1 = 'Tab';
const $85446a31c46e5d8b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $85446a31c46e5d8b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $85446a31c46e5d8b$var$EVENT_HIDE$5 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$5 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$5 = `show${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$5 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3 = `click${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_KEYUP_DATA_API = `keyup${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$6 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPUP = 'dropup';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPEND = 'dropend';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3}.${$85446a31c46e5d8b$var$CLASS_NAME_SHOW$6}`;
const $85446a31c46e5d8b$var$SELECTOR_MENU = '.dropdown-menu';
const $85446a31c46e5d8b$var$SELECTOR_NAVBAR = '.navbar';
const $85446a31c46e5d8b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $85446a31c46e5d8b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $85446a31c46e5d8b$var$PLACEMENT_TOP = $85446a31c46e5d8b$var$isRTL() ? 'top-end' : 'top-start';
const $85446a31c46e5d8b$var$PLACEMENT_TOPEND = $85446a31c46e5d8b$var$isRTL() ? 'top-start' : 'top-end';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOM = $85446a31c46e5d8b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOMEND = $85446a31c46e5d8b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $85446a31c46e5d8b$var$PLACEMENT_RIGHT = $85446a31c46e5d8b$var$isRTL() ? 'left-start' : 'right-start';
const $85446a31c46e5d8b$var$PLACEMENT_LEFT = $85446a31c46e5d8b$var$isRTL() ? 'right-start' : 'left-start';
const $85446a31c46e5d8b$var$PLACEMENT_TOPCENTER = 'top';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $85446a31c46e5d8b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $85446a31c46e5d8b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$931cbfb6bfb85fc extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $85446a31c46e5d8b$var$SelectorEngine.next(this._element, $85446a31c46e5d8b$var$SELECTOR_MENU)[0] || $85446a31c46e5d8b$var$SelectorEngine.prev(this._element, $85446a31c46e5d8b$var$SELECTOR_MENU)[0] || $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$9;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$9;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($85446a31c46e5d8b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($85446a31c46e5d8b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.on(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($85446a31c46e5d8b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.off(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $85446a31c46e5d8b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$85446a31c46e5d8b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$85446a31c46e5d8b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $e4h34 === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($85446a31c46e5d8b$var$isElement(this._config.reference)) referenceElement = $85446a31c46e5d8b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $e4h34.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPEND)) return $85446a31c46e5d8b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPSTART)) return $85446a31c46e5d8b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPUP_CENTER)) return $85446a31c46e5d8b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_CENTER)) return $85446a31c46e5d8b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPUP)) return isEnd ? $85446a31c46e5d8b$var$PLACEMENT_TOPEND : $85446a31c46e5d8b$var$PLACEMENT_TOP;
        return isEnd ? $85446a31c46e5d8b$var$PLACEMENT_BOTTOMEND : $85446a31c46e5d8b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($85446a31c46e5d8b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $85446a31c46e5d8b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$85446a31c46e5d8b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$85446a31c46e5d8b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $85446a31c46e5d8b$var$getNextActiveElement(items, target, key === $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $85446a31c46e5d8b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $85446a31c46e5d8b$var$TAB_KEY$1) return;
        const openToggles = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $85446a31c46e5d8b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $85446a31c46e5d8b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $85446a31c46e5d8b$var$ARROW_UP_KEY$1,
            $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3) ? this : $85446a31c46e5d8b$var$SelectorEngine.prev(this, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3)[0] || $85446a31c46e5d8b$var$SelectorEngine.next(this, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3)[0] || $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, $85446a31c46e5d8b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API, $85446a31c46e5d8b$var$SELECTOR_MENU, $85446a31c46e5d8b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3, $85446a31c46e5d8b$export$931cbfb6bfb85fc.clearMenus);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYUP_DATA_API, $85446a31c46e5d8b$export$931cbfb6bfb85fc.clearMenus);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$9 = 'backdrop';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$4 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$5 = 'show';
const $85446a31c46e5d8b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$85446a31c46e5d8b$var$NAME$9}`;
const $85446a31c46e5d8b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $85446a31c46e5d8b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$Backdrop extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$8;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$8;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $85446a31c46e5d8b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $85446a31c46e5d8b$var$reflow(element);
        element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $85446a31c46e5d8b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $85446a31c46e5d8b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $85446a31c46e5d8b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $85446a31c46e5d8b$var$EventHandler.off(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $85446a31c46e5d8b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $85446a31c46e5d8b$var$EventHandler.on(element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN, ()=>{
            $85446a31c46e5d8b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $85446a31c46e5d8b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$8 = 'focustrap';
const $85446a31c46e5d8b$var$DATA_KEY$5 = 'bs.focustrap';
const $85446a31c46e5d8b$var$EVENT_KEY$5 = `.${$85446a31c46e5d8b$var$DATA_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSIN$2 = `focusin${$85446a31c46e5d8b$var$EVENT_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$85446a31c46e5d8b$var$EVENT_KEY$5}`;
const $85446a31c46e5d8b$var$TAB_KEY = 'Tab';
const $85446a31c46e5d8b$var$TAB_NAV_FORWARD = 'forward';
const $85446a31c46e5d8b$var$TAB_NAV_BACKWARD = 'backward';
const $85446a31c46e5d8b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $85446a31c46e5d8b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$FocusTrap extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$7;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$7;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $85446a31c46e5d8b$var$EventHandler.off(document, $85446a31c46e5d8b$var$EVENT_KEY$5); // guard against infinite focus loop
        $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $85446a31c46e5d8b$var$EventHandler.off(document, $85446a31c46e5d8b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $85446a31c46e5d8b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $85446a31c46e5d8b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $85446a31c46e5d8b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $85446a31c46e5d8b$var$TAB_NAV_BACKWARD : $85446a31c46e5d8b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $85446a31c46e5d8b$var$PROPERTY_PADDING = 'padding-right';
const $85446a31c46e5d8b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $85446a31c46e5d8b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT, $85446a31c46e5d8b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT, $85446a31c46e5d8b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $85446a31c46e5d8b$var$PROPERTY_PADDING);
        this._resetElementAttributes($85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT, $85446a31c46e5d8b$var$PROPERTY_PADDING);
        this._resetElementAttributes($85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT, $85446a31c46e5d8b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $85446a31c46e5d8b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $85446a31c46e5d8b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $85446a31c46e5d8b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($85446a31c46e5d8b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $85446a31c46e5d8b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$7 = 'modal';
const $85446a31c46e5d8b$var$DATA_KEY$4 = 'bs.modal';
const $85446a31c46e5d8b$var$EVENT_KEY$4 = `.${$85446a31c46e5d8b$var$DATA_KEY$4}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$2 = '.data-api';
const $85446a31c46e5d8b$var$ESCAPE_KEY$1 = 'Escape';
const $85446a31c46e5d8b$var$EVENT_HIDE$4 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$4 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$4 = `show${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$4 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_RESIZE$1 = `resize${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DISMISS = `click.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$2 = `click${$85446a31c46e5d8b$var$EVENT_KEY$4}${$85446a31c46e5d8b$var$DATA_API_KEY$2}`;
const $85446a31c46e5d8b$var$CLASS_NAME_OPEN = 'modal-open';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$3 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$4 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_STATIC = 'modal-static';
const $85446a31c46e5d8b$var$OPEN_SELECTOR$1 = '.modal.show';
const $85446a31c46e5d8b$var$SELECTOR_DIALOG = '.modal-dialog';
const $85446a31c46e5d8b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $85446a31c46e5d8b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $85446a31c46e5d8b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$2b77a92f1a5ad772 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $85446a31c46e5d8b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$6;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$6;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($85446a31c46e5d8b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $85446a31c46e5d8b$var$EventHandler.off(window, $85446a31c46e5d8b$var$EVENT_KEY$4);
        $85446a31c46e5d8b$var$EventHandler.off(this._dialog, $85446a31c46e5d8b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $85446a31c46e5d8b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $85446a31c46e5d8b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $85446a31c46e5d8b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $85446a31c46e5d8b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $85446a31c46e5d8b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$2, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_HIDDEN$4, ()=>{
            if ($85446a31c46e5d8b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $85446a31c46e5d8b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $85446a31c46e5d8b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$6 = 'offcanvas';
const $85446a31c46e5d8b$var$DATA_KEY$3 = 'bs.offcanvas';
const $85446a31c46e5d8b$var$EVENT_KEY$3 = `.${$85446a31c46e5d8b$var$DATA_KEY$3}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$1 = '.data-api';
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$2 = `load${$85446a31c46e5d8b$var$EVENT_KEY$3}${$85446a31c46e5d8b$var$DATA_API_KEY$1}`;
const $85446a31c46e5d8b$var$ESCAPE_KEY = 'Escape';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$3 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $85446a31c46e5d8b$var$CLASS_NAME_HIDING = 'hiding';
const $85446a31c46e5d8b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $85446a31c46e5d8b$var$OPEN_SELECTOR = '.offcanvas.show';
const $85446a31c46e5d8b$var$EVENT_SHOW$3 = `show${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$3 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$3 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$3 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_RESIZE = `resize${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$1 = `click${$85446a31c46e5d8b$var$EVENT_KEY$3}${$85446a31c46e5d8b$var$DATA_API_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $85446a31c46e5d8b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $85446a31c46e5d8b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$591ca0244c9dfcd4 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$5;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$5;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $85446a31c46e5d8b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$3, $85446a31c46e5d8b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $85446a31c46e5d8b$var$ScrollBarHelper().reset();
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $85446a31c46e5d8b$var$Backdrop({
            className: $85446a31c46e5d8b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $85446a31c46e5d8b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $85446a31c46e5d8b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$1, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($85446a31c46e5d8b$var$isDisabled(this)) return;
    $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($85446a31c46e5d8b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $85446a31c46e5d8b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$OPEN_SELECTOR))$85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_RESIZE, ()=>{
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $85446a31c46e5d8b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $85446a31c46e5d8b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $85446a31c46e5d8b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $85446a31c46e5d8b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $85446a31c46e5d8b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $85446a31c46e5d8b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($85446a31c46e5d8b$var$uriAttributes.has(attributeName)) return Boolean($85446a31c46e5d8b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $85446a31c46e5d8b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$85446a31c46e5d8b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$5 = 'TemplateFactory';
const $85446a31c46e5d8b$var$Default$4 = {
    allowList: $85446a31c46e5d8b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $85446a31c46e5d8b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $85446a31c46e5d8b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$TemplateFactory extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$4;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$4;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $85446a31c46e5d8b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $85446a31c46e5d8b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($85446a31c46e5d8b$var$isElement(content)) {
            this._putElementInTemplate($85446a31c46e5d8b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $85446a31c46e5d8b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $85446a31c46e5d8b$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$4 = 'tooltip';
const $85446a31c46e5d8b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$2 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_MODAL = 'modal';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$2 = 'show';
const $85446a31c46e5d8b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $85446a31c46e5d8b$var$SELECTOR_MODAL = `.${$85446a31c46e5d8b$var$CLASS_NAME_MODAL}`;
const $85446a31c46e5d8b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $85446a31c46e5d8b$var$TRIGGER_HOVER = 'hover';
const $85446a31c46e5d8b$var$TRIGGER_FOCUS = 'focus';
const $85446a31c46e5d8b$var$TRIGGER_CLICK = 'click';
const $85446a31c46e5d8b$var$TRIGGER_MANUAL = 'manual';
const $85446a31c46e5d8b$var$EVENT_HIDE$2 = 'hide';
const $85446a31c46e5d8b$var$EVENT_HIDDEN$2 = 'hidden';
const $85446a31c46e5d8b$var$EVENT_SHOW$2 = 'show';
const $85446a31c46e5d8b$var$EVENT_SHOWN$2 = 'shown';
const $85446a31c46e5d8b$var$EVENT_INSERTED = 'inserted';
const $85446a31c46e5d8b$var$EVENT_CLICK$1 = 'click';
const $85446a31c46e5d8b$var$EVENT_FOCUSIN$1 = 'focusin';
const $85446a31c46e5d8b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $85446a31c46e5d8b$var$EVENT_MOUSEENTER = 'mouseenter';
const $85446a31c46e5d8b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $85446a31c46e5d8b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $85446a31c46e5d8b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $85446a31c46e5d8b$var$isRTL() ? 'right' : 'left'
};
const $85446a31c46e5d8b$var$Default$3 = {
    allowList: $85446a31c46e5d8b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $85446a31c46e5d8b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$28c660c63b792dea extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        if (typeof $e4h34 === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$3;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$3;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $85446a31c46e5d8b$var$EventHandler.off(this._element.closest($85446a31c46e5d8b$var$SELECTOR_MODAL), $85446a31c46e5d8b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_SHOW$2));
        const shadowRoot = $85446a31c46e5d8b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.on(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        const complete = ()=>{
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.off(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_FADE$2, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $85446a31c46e5d8b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $85446a31c46e5d8b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$85446a31c46e5d8b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $85446a31c46e5d8b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $85446a31c46e5d8b$var$AttachmentMap[placement.toUpperCase()];
        return $e4h34.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $85446a31c46e5d8b$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$85446a31c46e5d8b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $85446a31c46e5d8b$var$EventHandler.on(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $85446a31c46e5d8b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $85446a31c46e5d8b$var$TRIGGER_HOVER ? this.constructor.eventName($85446a31c46e5d8b$var$EVENT_MOUSEENTER) : this.constructor.eventName($85446a31c46e5d8b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $85446a31c46e5d8b$var$TRIGGER_HOVER ? this.constructor.eventName($85446a31c46e5d8b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($85446a31c46e5d8b$var$EVENT_FOCUSOUT$1);
                $85446a31c46e5d8b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $85446a31c46e5d8b$var$TRIGGER_FOCUS : $85446a31c46e5d8b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $85446a31c46e5d8b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $85446a31c46e5d8b$var$TRIGGER_FOCUS : $85446a31c46e5d8b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $85446a31c46e5d8b$var$EventHandler.on(this._element.closest($85446a31c46e5d8b$var$SELECTOR_MODAL), $85446a31c46e5d8b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $85446a31c46e5d8b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($85446a31c46e5d8b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $85446a31c46e5d8b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$3 = 'popover';
const $85446a31c46e5d8b$var$SELECTOR_TITLE = '.popover-header';
const $85446a31c46e5d8b$var$SELECTOR_CONTENT = '.popover-body';
const $85446a31c46e5d8b$var$Default$2 = {
    ...$85446a31c46e5d8b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $85446a31c46e5d8b$var$DefaultType$2 = {
    ...$85446a31c46e5d8b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$5b6b19405a83ff9d extends $85446a31c46e5d8b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$2;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$2;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$85446a31c46e5d8b$var$SELECTOR_TITLE]: this._getTitle(),
            [$85446a31c46e5d8b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$2 = 'scrollspy';
const $85446a31c46e5d8b$var$DATA_KEY$2 = 'bs.scrollspy';
const $85446a31c46e5d8b$var$EVENT_KEY$2 = `.${$85446a31c46e5d8b$var$DATA_KEY$2}`;
const $85446a31c46e5d8b$var$DATA_API_KEY = '.data-api';
const $85446a31c46e5d8b$var$EVENT_ACTIVATE = `activate${$85446a31c46e5d8b$var$EVENT_KEY$2}`;
const $85446a31c46e5d8b$var$EVENT_CLICK = `click${$85446a31c46e5d8b$var$EVENT_KEY$2}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$1 = `load${$85446a31c46e5d8b$var$EVENT_KEY$2}${$85446a31c46e5d8b$var$DATA_API_KEY}`;
const $85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $85446a31c46e5d8b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS = '[href]';
const $85446a31c46e5d8b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $85446a31c46e5d8b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $85446a31c46e5d8b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $85446a31c46e5d8b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $85446a31c46e5d8b$var$SELECTOR_LINK_ITEMS = `${$85446a31c46e5d8b$var$SELECTOR_NAV_LINKS}, ${$85446a31c46e5d8b$var$SELECTOR_NAV_ITEMS} > ${$85446a31c46e5d8b$var$SELECTOR_NAV_LINKS}, ${$85446a31c46e5d8b$var$SELECTOR_LIST_ITEMS}`;
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN = '.dropdown';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $85446a31c46e5d8b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $85446a31c46e5d8b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$a6472a5298a374be extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$1;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$1;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $85446a31c46e5d8b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $85446a31c46e5d8b$var$EventHandler.off(this._config.target, $85446a31c46e5d8b$var$EVENT_CLICK);
        $85446a31c46e5d8b$var$EventHandler.on(this._config.target, $85446a31c46e5d8b$var$EVENT_CLICK, $85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $85446a31c46e5d8b$var$isDisabled(anchor)) continue;
            const observableSection = $85446a31c46e5d8b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($85446a31c46e5d8b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($85446a31c46e5d8b$var$SELECTOR_DROPDOWN)).classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $85446a31c46e5d8b$var$SelectorEngine.parents(target, $85446a31c46e5d8b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $85446a31c46e5d8b$var$SelectorEngine.prev(listGroup, $85446a31c46e5d8b$var$SELECTOR_LINK_ITEMS))item.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $85446a31c46e5d8b$var$SelectorEngine.find(`${$85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS}.${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_SPY))$85446a31c46e5d8b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$1 = 'tab';
const $85446a31c46e5d8b$var$DATA_KEY$1 = 'bs.tab';
const $85446a31c46e5d8b$var$EVENT_KEY$1 = `.${$85446a31c46e5d8b$var$DATA_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$1 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$1 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$1 = `show${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$1 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API = `click${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API = `load${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $85446a31c46e5d8b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $85446a31c46e5d8b$var$ARROW_UP_KEY = 'ArrowUp';
const $85446a31c46e5d8b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $85446a31c46e5d8b$var$HOME_KEY = 'Home';
const $85446a31c46e5d8b$var$END_KEY = 'End';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE = 'active';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$1 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$1 = 'show';
const $85446a31c46e5d8b$var$CLASS_DROPDOWN = 'dropdown';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $85446a31c46e5d8b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $85446a31c46e5d8b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $85446a31c46e5d8b$var$SELECTOR_INNER = `.nav-link${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $85446a31c46e5d8b$var$SELECTOR_INNER_ELEM = `${$85446a31c46e5d8b$var$SELECTOR_INNER}, ${$85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$3e41faf802a29e71 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($85446a31c46e5d8b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $85446a31c46e5d8b$var$EventHandler.trigger(active, $85446a31c46e5d8b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(innerElem, $85446a31c46e5d8b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        this._activate($85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $85446a31c46e5d8b$var$EventHandler.trigger(element, $85446a31c46e5d8b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $85446a31c46e5d8b$var$EventHandler.trigger(element, $85446a31c46e5d8b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $85446a31c46e5d8b$var$ARROW_LEFT_KEY,
            $85446a31c46e5d8b$var$ARROW_RIGHT_KEY,
            $85446a31c46e5d8b$var$ARROW_UP_KEY,
            $85446a31c46e5d8b$var$ARROW_DOWN_KEY,
            $85446a31c46e5d8b$var$HOME_KEY,
            $85446a31c46e5d8b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$85446a31c46e5d8b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $85446a31c46e5d8b$var$HOME_KEY,
            $85446a31c46e5d8b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $85446a31c46e5d8b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $85446a31c46e5d8b$var$ARROW_RIGHT_KEY,
                $85446a31c46e5d8b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $85446a31c46e5d8b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($85446a31c46e5d8b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $85446a31c46e5d8b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE, $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        toggle($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_MENU, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM) ? elem : $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($85446a31c46e5d8b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($85446a31c46e5d8b$var$isDisabled(this)) return;
    $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME = 'toast';
const $85446a31c46e5d8b$var$DATA_KEY = 'bs.toast';
const $85446a31c46e5d8b$var$EVENT_KEY = `.${$85446a31c46e5d8b$var$DATA_KEY}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEOVER = `mouseover${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEOUT = `mouseout${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSIN = `focusin${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSOUT = `focusout${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_HIDE = `hide${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN = `hidden${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_SHOW = `show${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN = `shown${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$CLASS_NAME_FADE = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOWING = 'showing';
const $85446a31c46e5d8b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $85446a31c46e5d8b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$8d8dc7d5f743331b extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_HIDE); // @deprecated
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW, $85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING, $85446a31c46e5d8b$var$CLASS_NAME_SHOW);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$8d8dc7d5f743331b);

});
parcelRegister("e4h34", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("G6QZI")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("tsn8K")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("G6QZI")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("2DJ76")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("apoHu")).createPopper; });

var $btpzK = parcelRequire("btpzK");

var $tRXom = parcelRequire("tRXom");

var $G6QZI = parcelRequire("G6QZI");
var $tsn8K = parcelRequire("tsn8K");

var $2DJ76 = parcelRequire("2DJ76");

var $apoHu = parcelRequire("apoHu");
$parcel$exportWildcard(module.exports, $btpzK);
$parcel$exportWildcard(module.exports, $tRXom);

});
parcelRegister("btpzK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $85a63deb9e4efdbe$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $85a63deb9e4efdbe$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $85a63deb9e4efdbe$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $85a63deb9e4efdbe$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $85a63deb9e4efdbe$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $85a63deb9e4efdbe$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $85a63deb9e4efdbe$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $85a63deb9e4efdbe$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $85a63deb9e4efdbe$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $85a63deb9e4efdbe$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $85a63deb9e4efdbe$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $85a63deb9e4efdbe$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $85a63deb9e4efdbe$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $85a63deb9e4efdbe$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $85a63deb9e4efdbe$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $85a63deb9e4efdbe$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $85a63deb9e4efdbe$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $85a63deb9e4efdbe$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $85a63deb9e4efdbe$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $85a63deb9e4efdbe$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $85a63deb9e4efdbe$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $85a63deb9e4efdbe$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $85a63deb9e4efdbe$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $85a63deb9e4efdbe$export$d087d3878fdf71d5; });
var $85a63deb9e4efdbe$export$1e95b668f3b82d = 'top';
var $85a63deb9e4efdbe$export$40e543e69a8b3fbb = 'bottom';
var $85a63deb9e4efdbe$export$79ffe56a765070d2 = 'right';
var $85a63deb9e4efdbe$export$eabcd2c8791e7bf4 = 'left';
var $85a63deb9e4efdbe$export$dfb5619354ba860 = 'auto';
var $85a63deb9e4efdbe$export$aec2ce47c367b8c3 = [
    $85a63deb9e4efdbe$export$1e95b668f3b82d,
    $85a63deb9e4efdbe$export$40e543e69a8b3fbb,
    $85a63deb9e4efdbe$export$79ffe56a765070d2,
    $85a63deb9e4efdbe$export$eabcd2c8791e7bf4
];
var $85a63deb9e4efdbe$export$b3571188c770cc5a = 'start';
var $85a63deb9e4efdbe$export$bd5df0f255a350f8 = 'end';
var $85a63deb9e4efdbe$export$390fd549c5303b4d = 'clippingParents';
var $85a63deb9e4efdbe$export$d7b7311ec04a3e8f = 'viewport';
var $85a63deb9e4efdbe$export$ae5ab1c730825774 = 'popper';
var $85a63deb9e4efdbe$export$ca50aac9f3ba507f = 'reference';
var $85a63deb9e4efdbe$export$368f9a87e87fa4e1 = /*#__PURE__*/ $85a63deb9e4efdbe$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $85a63deb9e4efdbe$export$b3571188c770cc5a,
        placement + "-" + $85a63deb9e4efdbe$export$bd5df0f255a350f8
    ]);
}, []);
var $85a63deb9e4efdbe$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($85a63deb9e4efdbe$export$aec2ce47c367b8c3, [
    $85a63deb9e4efdbe$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $85a63deb9e4efdbe$export$b3571188c770cc5a,
        placement + "-" + $85a63deb9e4efdbe$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $85a63deb9e4efdbe$export$421679a7c3d56e = 'beforeRead';
var $85a63deb9e4efdbe$export$aafa59e2e03f2942 = 'read';
var $85a63deb9e4efdbe$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $85a63deb9e4efdbe$export$c65e99957a05207c = 'beforeMain';
var $85a63deb9e4efdbe$export$f22da7240b7add18 = 'main';
var $85a63deb9e4efdbe$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $85a63deb9e4efdbe$export$8d4d2d70e7d46032 = 'beforeWrite';
var $85a63deb9e4efdbe$export$68d8715fc104d294 = 'write';
var $85a63deb9e4efdbe$export$70a6e5159acce2e6 = 'afterWrite';
var $85a63deb9e4efdbe$export$d087d3878fdf71d5 = [
    $85a63deb9e4efdbe$export$421679a7c3d56e,
    $85a63deb9e4efdbe$export$aafa59e2e03f2942,
    $85a63deb9e4efdbe$export$6964f6c886723980,
    $85a63deb9e4efdbe$export$c65e99957a05207c,
    $85a63deb9e4efdbe$export$f22da7240b7add18,
    $85a63deb9e4efdbe$export$bab79516f2d662fe,
    $85a63deb9e4efdbe$export$8d4d2d70e7d46032,
    $85a63deb9e4efdbe$export$68d8715fc104d294,
    $85a63deb9e4efdbe$export$70a6e5159acce2e6
];

});

parcelRegister("tRXom", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("8OgMA")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("2UESB")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("eFHzI")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("5sIsH")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("92JYe")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("kK0ry")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("7fD8B")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("l20wA")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("f6dYH")).default; });

var $8OgMA = parcelRequire("8OgMA");

var $2UESB = parcelRequire("2UESB");

var $eFHzI = parcelRequire("eFHzI");

var $5sIsH = parcelRequire("5sIsH");

var $92JYe = parcelRequire("92JYe");

var $kK0ry = parcelRequire("kK0ry");

var $7fD8B = parcelRequire("7fD8B");

var $l20wA = parcelRequire("l20wA");

var $f6dYH = parcelRequire("f6dYH");

});
parcelRegister("8OgMA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a002f13cf27b52$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");
// and applies them to the HTMLElements such as popper and arrow
function $66a002f13cf27b52$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $cDkqb.isHTMLElement)(element) || !(0, $lGz8v.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $66a002f13cf27b52$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $cDkqb.isHTMLElement)(element) || !(0, $lGz8v.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $66a002f13cf27b52$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $66a002f13cf27b52$var$applyStyles,
    effect: $66a002f13cf27b52$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("lGz8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc98c68302746ce9$export$2e2bcd8739ae039; });
function $fc98c68302746ce9$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cDkqb", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $9328f7d20c5ad8f3$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $9328f7d20c5ad8f3$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $9328f7d20c5ad8f3$export$af51f0f06c0f328a; });

var $hJIkn = parcelRequire("hJIkn");
function $9328f7d20c5ad8f3$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $hJIkn.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $9328f7d20c5ad8f3$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $hJIkn.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $9328f7d20c5ad8f3$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $hJIkn.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("hJIkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce99062bd8258a78$export$2e2bcd8739ae039; });
function $ce99062bd8258a78$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("2UESB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21f0859458a5faea$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $eh08t = parcelRequire("eh08t");

var $hqckA = parcelRequire("hqckA");

var $fUgdz = parcelRequire("fUgdz");

var $2stza = parcelRequire("2stza");

var $jDprH = parcelRequire("jDprH");

var $2N6Uq = parcelRequire("2N6Uq");

var $2JV7t = parcelRequire("2JV7t");

var $btpzK = parcelRequire("btpzK");
var $21f0859458a5faea$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2N6Uq.default)(typeof padding !== 'number' ? padding : (0, $2JV7t.default)(padding, (0, $btpzK.basePlacements)));
};
function $21f0859458a5faea$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1jvge.default)(state.placement);
    var axis = (0, $2stza.default)(basePlacement);
    var isVertical = [
        (0, $btpzK.left),
        (0, $btpzK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $21f0859458a5faea$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eh08t.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $btpzK.top) : (0, $btpzK.left);
    var maxProp = axis === 'y' ? (0, $btpzK.bottom) : (0, $btpzK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $fUgdz.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jDprH.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $21f0859458a5faea$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $hqckA.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $21f0859458a5faea$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $21f0859458a5faea$var$arrow,
    effect: $21f0859458a5faea$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("1jvge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f4fd086065911bf$export$2e2bcd8739ae039; });

function $0f4fd086065911bf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("eh08t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a642c22a9feff6be$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");
function $a642c22a9feff6be$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $hYSQh.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("hYSQh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d17294c9f412a67d$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");

var $gU5NM = parcelRequire("gU5NM");

var $hJIkn = parcelRequire("hJIkn");

var $du7FU = parcelRequire("du7FU");
function $d17294c9f412a67d$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $cDkqb.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $gU5NM.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $gU5NM.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $cDkqb.isElement)(element) ? (0, $hJIkn.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $du7FU.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gU5NM", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $c4e6606afccced1c$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $c4e6606afccced1c$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $c4e6606afccced1c$export$2077e0241d6afd3c; });
var $c4e6606afccced1c$export$8960430cfd85939f = Math.max;
var $c4e6606afccced1c$export$96ec731ed4dcb222 = Math.min;
var $c4e6606afccced1c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("du7FU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d1407c52a7c8cb0$export$2e2bcd8739ae039; });

var $1xPOh = parcelRequire("1xPOh");
function $9d1407c52a7c8cb0$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1xPOh.default)());
}

});
parcelRegister("1xPOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12010fe8db335be8$export$2e2bcd8739ae039; });
function $12010fe8db335be8$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("hqckA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caee6e13dc008677$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");
function $caee6e13dc008677$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $cDkqb.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fUgdz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b948aa8250b50114$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");

var $lGz8v = parcelRequire("lGz8v");

var $gpf62 = parcelRequire("gpf62");

var $cDkqb = parcelRequire("cDkqb");

var $52pTN = parcelRequire("52pTN");

var $fkUg2 = parcelRequire("fkUg2");

var $1xPOh = parcelRequire("1xPOh");
function $b948aa8250b50114$var$getTrueOffsetParent(element) {
    if (!(0, $cDkqb.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gpf62.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b948aa8250b50114$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1xPOh.default)());
    var isIE = /Trident/i.test((0, $1xPOh.default)());
    if (isIE && (0, $cDkqb.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gpf62.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $fkUg2.default)(element);
    if ((0, $cDkqb.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $cDkqb.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $lGz8v.default)(currentNode)) < 0){
        var css = (0, $gpf62.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b948aa8250b50114$export$2e2bcd8739ae039(element) {
    var window = (0, $hJIkn.default)(element);
    var offsetParent = $b948aa8250b50114$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $52pTN.default)(offsetParent) && (0, $gpf62.default)(offsetParent).position === 'static')offsetParent = $b948aa8250b50114$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $lGz8v.default)(offsetParent) === 'html' || (0, $lGz8v.default)(offsetParent) === 'body' && (0, $gpf62.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $b948aa8250b50114$var$getContainingBlock(element) || window;
}

});
parcelRegister("gpf62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1ab0f752e36e07$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
function $bf1ab0f752e36e07$export$2e2bcd8739ae039(element) {
    return (0, $hJIkn.default)(element).getComputedStyle(element);
}

});

parcelRegister("52pTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab13aa4ac540f64$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");
function $3ab13aa4ac540f64$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $lGz8v.default)(element)) >= 0;
}

});

parcelRegister("fkUg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a45ce1c70eb460$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");

var $bxA65 = parcelRequire("bxA65");

var $cDkqb = parcelRequire("cDkqb");
function $b2a45ce1c70eb460$export$2e2bcd8739ae039(element) {
    if ((0, $lGz8v.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $cDkqb.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $bxA65.default)(element) // fallback
    );
}

});
parcelRegister("bxA65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866ec6ec64076066$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");
function $866ec6ec64076066$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $cDkqb.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("2stza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca5218822eae965$export$2e2bcd8739ae039; });
function $1ca5218822eae965$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("jDprH", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $e4b565d5ccfd9dbb$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $e4b565d5ccfd9dbb$export$86c8af6d3ef0b4a; });

var $gU5NM = parcelRequire("gU5NM");
function $e4b565d5ccfd9dbb$export$f28d906d67a997f3(min, value, max) {
    return (0, $gU5NM.max)(min, (0, $gU5NM.min)(value, max));
}
function $e4b565d5ccfd9dbb$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e4b565d5ccfd9dbb$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("2N6Uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2085845f5d837ecd$export$2e2bcd8739ae039; });

var $4tl7s = parcelRequire("4tl7s");
function $2085845f5d837ecd$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4tl7s.default)(), paddingObject);
}

});
parcelRegister("4tl7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $341a40bb836fecd9$export$2e2bcd8739ae039; });
function $341a40bb836fecd9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("2JV7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fec177f66b842d3$export$2e2bcd8739ae039; });
function $1fec177f66b842d3$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("eFHzI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae6b221a248dd7d$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $fUgdz = parcelRequire("fUgdz");

var $hJIkn = parcelRequire("hJIkn");

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $1jvge = parcelRequire("1jvge");

var $82wN7 = parcelRequire("82wN7");

var $gU5NM = parcelRequire("gU5NM");
var $aae6b221a248dd7d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $aae6b221a248dd7d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $gU5NM.round)(x * dpr) / dpr || 0,
        y: (0, $gU5NM.round)(y * dpr) / dpr || 0
    };
}
function $aae6b221a248dd7d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $btpzK.left);
    var sideY = (0, $btpzK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $fUgdz.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $hJIkn.default)(popper)) {
            offsetParent = (0, $bxA65.default)(popper);
            if ((0, $gpf62.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $btpzK.top) || (placement === (0, $btpzK.left) || placement === (0, $btpzK.right)) && variation === (0, $btpzK.end)) {
            sideY = (0, $btpzK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $btpzK.left) || (placement === (0, $btpzK.top) || placement === (0, $btpzK.bottom)) && variation === (0, $btpzK.end)) {
            sideX = (0, $btpzK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $aae6b221a248dd7d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $aae6b221a248dd7d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $hJIkn.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $aae6b221a248dd7d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1jvge.default)(state.placement),
        variation: (0, $82wN7.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $aae6b221a248dd7d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $aae6b221a248dd7d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $aae6b221a248dd7d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $aae6b221a248dd7d$var$computeStyles,
    data: {}
};

});
parcelRegister("82wN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da7f24416186fa1$export$2e2bcd8739ae039; });
function $5da7f24416186fa1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("5sIsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fa20e7894537a26$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
var $3fa20e7894537a26$var$passive = {
    passive: true
};
function $3fa20e7894537a26$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $hJIkn.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3fa20e7894537a26$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3fa20e7894537a26$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3fa20e7894537a26$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3fa20e7894537a26$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3fa20e7894537a26$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3fa20e7894537a26$var$effect,
    data: {}
};

});

parcelRegister("92JYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6957f5bef1e521b8$export$2e2bcd8739ae039; });

var $93sVP = parcelRequire("93sVP");

var $1jvge = parcelRequire("1jvge");

var $9etaQ = parcelRequire("9etaQ");

var $tsn8K = parcelRequire("tsn8K");

var $gTz3Q = parcelRequire("gTz3Q");

var $btpzK = parcelRequire("btpzK");

var $82wN7 = parcelRequire("82wN7");
function $6957f5bef1e521b8$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1jvge.default)(placement) === (0, $btpzK.auto)) return [];
    var oppositePlacement = (0, $93sVP.default)(placement);
    return [
        (0, $9etaQ.default)(placement),
        oppositePlacement,
        (0, $9etaQ.default)(oppositePlacement)
    ];
}
function $6957f5bef1e521b8$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1jvge.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $93sVP.default)(preferredPlacement)
    ] : $6957f5bef1e521b8$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1jvge.default)(placement) === (0, $btpzK.auto) ? (0, $gTz3Q.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1jvge.default)(placement);
        var isStartVariation = (0, $82wN7.default)(placement) === (0, $btpzK.start);
        var isVertical = [
            (0, $btpzK.top),
            (0, $btpzK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $tsn8K.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $btpzK.right) : (0, $btpzK.left) : isStartVariation ? (0, $btpzK.bottom) : (0, $btpzK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $93sVP.default)(mainVariationSide);
        var altVariationSide = (0, $93sVP.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6957f5bef1e521b8$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6957f5bef1e521b8$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("93sVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $697ad6146bc295d1$export$2e2bcd8739ae039; });
var $697ad6146bc295d1$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $697ad6146bc295d1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $697ad6146bc295d1$var$hash[matched];
    });
}

});

parcelRegister("9etaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b8c0d30b13c9805$export$2e2bcd8739ae039; });
var $6b8c0d30b13c9805$var$hash = {
    start: 'end',
    end: 'start'
};
function $6b8c0d30b13c9805$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $6b8c0d30b13c9805$var$hash[matched];
    });
}

});

parcelRegister("tsn8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0588b7ae84e87da8$export$2e2bcd8739ae039; });

var $jOlXH = parcelRequire("jOlXH");

var $bxA65 = parcelRequire("bxA65");

var $hYSQh = parcelRequire("hYSQh");

var $bwM7o = parcelRequire("bwM7o");

var $kMDXr = parcelRequire("kMDXr");

var $btpzK = parcelRequire("btpzK");

var $cDkqb = parcelRequire("cDkqb");

var $2N6Uq = parcelRequire("2N6Uq");

var $2JV7t = parcelRequire("2JV7t");
function $0588b7ae84e87da8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $btpzK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $btpzK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $btpzK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2N6Uq.default)(typeof padding !== 'number' ? padding : (0, $2JV7t.default)(padding, (0, $btpzK.basePlacements)));
    var altContext = elementContext === (0, $btpzK.popper) ? (0, $btpzK.reference) : (0, $btpzK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jOlXH.default)((0, $cDkqb.isElement)(element) ? element : element.contextElement || (0, $bxA65.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $hYSQh.default)(state.elements.reference);
    var popperOffsets = (0, $bwM7o.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $kMDXr.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $btpzK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $btpzK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $btpzK.right),
                (0, $btpzK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $btpzK.top),
                (0, $btpzK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jOlXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c3b903c25d9466$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $d5Zvt = parcelRequire("d5Zvt");

var $4dqBB = parcelRequire("4dqBB");

var $aaQJm = parcelRequire("aaQJm");

var $fUgdz = parcelRequire("fUgdz");

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $cDkqb = parcelRequire("cDkqb");

var $hYSQh = parcelRequire("hYSQh");

var $fkUg2 = parcelRequire("fkUg2");

var $hqckA = parcelRequire("hqckA");

var $lGz8v = parcelRequire("lGz8v");

var $kMDXr = parcelRequire("kMDXr");

var $gU5NM = parcelRequire("gU5NM");
function $e6c3b903c25d9466$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $hYSQh.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e6c3b903c25d9466$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $btpzK.viewport) ? (0, $kMDXr.default)((0, $d5Zvt.default)(element, strategy)) : (0, $cDkqb.isElement)(clippingParent) ? $e6c3b903c25d9466$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $kMDXr.default)((0, $4dqBB.default)((0, $bxA65.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e6c3b903c25d9466$var$getClippingParents(element) {
    var clippingParents = (0, $aaQJm.default)((0, $fkUg2.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gpf62.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $cDkqb.isHTMLElement)(element) ? (0, $fUgdz.default)(element) : element;
    if (!(0, $cDkqb.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $cDkqb.isElement)(clippingParent) && (0, $hqckA.default)(clippingParent, clipperElement) && (0, $lGz8v.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e6c3b903c25d9466$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $e6c3b903c25d9466$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e6c3b903c25d9466$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $gU5NM.max)(rect.top, accRect.top);
        accRect.right = (0, $gU5NM.min)(rect.right, accRect.right);
        accRect.bottom = (0, $gU5NM.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $gU5NM.max)(rect.left, accRect.left);
        return accRect;
    }, $e6c3b903c25d9466$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("d5Zvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988b73ed58caab5d$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");

var $bxA65 = parcelRequire("bxA65");

var $gjBXX = parcelRequire("gjBXX");

var $du7FU = parcelRequire("du7FU");
function $988b73ed58caab5d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $hJIkn.default)(element);
    var html = (0, $bxA65.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $du7FU.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gjBXX.default)(element),
        y: y
    };
}

});
parcelRegister("gjBXX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be0bdef070959ca4$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");

var $bxA65 = parcelRequire("bxA65");

var $2DsKR = parcelRequire("2DsKR");
function $be0bdef070959ca4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $hYSQh.default)((0, $bxA65.default)(element)).left + (0, $2DsKR.default)(element).scrollLeft;
}

});
parcelRegister("2DsKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb58767658348c0$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
function $1eb58767658348c0$export$2e2bcd8739ae039(node) {
    var win = (0, $hJIkn.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("4dqBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311d039fe68628bd$export$2e2bcd8739ae039; });

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $gjBXX = parcelRequire("gjBXX");

var $2DsKR = parcelRequire("2DsKR");

var $gU5NM = parcelRequire("gU5NM");
function $311d039fe68628bd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $bxA65.default)(element);
    var winScroll = (0, $2DsKR.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $gU5NM.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $gU5NM.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gjBXX.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gpf62.default)(body || html).direction === 'rtl') x += (0, $gU5NM.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("aaQJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7683bdc51586781b$export$2e2bcd8739ae039; });

var $ba8u4 = parcelRequire("ba8u4");

var $fkUg2 = parcelRequire("fkUg2");

var $hJIkn = parcelRequire("hJIkn");

var $8Sm8F = parcelRequire("8Sm8F");
function $7683bdc51586781b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ba8u4.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $hJIkn.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8Sm8F.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($7683bdc51586781b$export$2e2bcd8739ae039((0, $fkUg2.default)(target)));
}

});
parcelRegister("ba8u4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8207359ded02b362$export$2e2bcd8739ae039; });

var $fkUg2 = parcelRequire("fkUg2");

var $8Sm8F = parcelRequire("8Sm8F");

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");
function $8207359ded02b362$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $lGz8v.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $cDkqb.isHTMLElement)(node) && (0, $8Sm8F.default)(node)) return node;
    return $8207359ded02b362$export$2e2bcd8739ae039((0, $fkUg2.default)(node));
}

});
parcelRegister("8Sm8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67648a3348ea7dd4$export$2e2bcd8739ae039; });

var $gpf62 = parcelRequire("gpf62");
function $67648a3348ea7dd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gpf62.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("kMDXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f217491887b081a5$export$2e2bcd8739ae039; });
function $f217491887b081a5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("bwM7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8648022167d83b20$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $82wN7 = parcelRequire("82wN7");

var $2stza = parcelRequire("2stza");

var $btpzK = parcelRequire("btpzK");
function $8648022167d83b20$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1jvge.default)(placement) : null;
    var variation = placement ? (0, $82wN7.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $btpzK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $btpzK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $btpzK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $btpzK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2stza.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $btpzK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $btpzK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gTz3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ccfacb1f27f0b3$export$2e2bcd8739ae039; });

var $82wN7 = parcelRequire("82wN7");

var $btpzK = parcelRequire("btpzK");

var $tsn8K = parcelRequire("tsn8K");

var $1jvge = parcelRequire("1jvge");
function $c4ccfacb1f27f0b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $btpzK.placements) : _options$allowedAutoP;
    var variation = (0, $82wN7.default)(placement);
    var placements = variation ? flipVariations ? (0, $btpzK.variationPlacements) : (0, $btpzK.variationPlacements).filter(function(placement) {
        return (0, $82wN7.default)(placement) === variation;
    }) : (0, $btpzK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $tsn8K.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1jvge.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("kK0ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f198729a69f80132$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $tsn8K = parcelRequire("tsn8K");
function $f198729a69f80132$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f198729a69f80132$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $btpzK.top),
        (0, $btpzK.right),
        (0, $btpzK.bottom),
        (0, $btpzK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f198729a69f80132$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $tsn8K.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $tsn8K.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f198729a69f80132$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f198729a69f80132$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f198729a69f80132$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f198729a69f80132$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f198729a69f80132$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $f198729a69f80132$var$hide
};

});

parcelRegister("7fD8B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54784b0cc81f9588$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $btpzK = parcelRequire("btpzK");
function $54784b0cc81f9588$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1jvge.default)(placement);
    var invertDistance = [
        (0, $btpzK.left),
        (0, $btpzK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $btpzK.left),
        (0, $btpzK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $54784b0cc81f9588$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $btpzK.placements).reduce(function(acc, placement) {
        acc[placement] = $54784b0cc81f9588$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $54784b0cc81f9588$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $54784b0cc81f9588$var$offset
};

});

parcelRegister("l20wA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4fa310b7050c0ce$export$2e2bcd8739ae039; });

var $bwM7o = parcelRequire("bwM7o");
function $f4fa310b7050c0ce$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $bwM7o.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f4fa310b7050c0ce$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f4fa310b7050c0ce$var$popperOffsets,
    data: {}
};

});

parcelRegister("f6dYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe242486c969c43$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $1jvge = parcelRequire("1jvge");

var $2stza = parcelRequire("2stza");

var $fhIRi = parcelRequire("fhIRi");

var $jDprH = parcelRequire("jDprH");

var $eh08t = parcelRequire("eh08t");

var $fUgdz = parcelRequire("fUgdz");

var $tsn8K = parcelRequire("tsn8K");

var $82wN7 = parcelRequire("82wN7");

var $4tl7s = parcelRequire("4tl7s");

var $gU5NM = parcelRequire("gU5NM");
function $afe242486c969c43$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $tsn8K.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1jvge.default)(state.placement);
    var variation = (0, $82wN7.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2stza.default)(basePlacement);
    var altAxis = (0, $fhIRi.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $btpzK.top) : (0, $btpzK.left);
        var altSide = mainAxis === 'y' ? (0, $btpzK.bottom) : (0, $btpzK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $btpzK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $btpzK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eh08t.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $4tl7s.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jDprH.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $fUgdz.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jDprH.within)(tether ? (0, $gU5NM.min)(min, tetherMin) : min, offset, tether ? (0, $gU5NM.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $btpzK.top) : (0, $btpzK.left);
        var _altSide = mainAxis === 'x' ? (0, $btpzK.bottom) : (0, $btpzK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $btpzK.top),
            (0, $btpzK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jDprH.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jDprH.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $afe242486c969c43$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $afe242486c969c43$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("fhIRi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20b3d8ab81ac378$export$2e2bcd8739ae039; });
function $b20b3d8ab81ac378$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("G6QZI", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $07e93d5ebba64980$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $07e93d5ebba64980$export$8f7491d57c8f97a9; });

var $gdOna = parcelRequire("gdOna");

var $eh08t = parcelRequire("eh08t");

var $aaQJm = parcelRequire("aaQJm");

var $fUgdz = parcelRequire("fUgdz");

var $9qBJp = parcelRequire("9qBJp");

var $bdwJx = parcelRequire("bdwJx");

var $kROea = parcelRequire("kROea");

var $tsn8K = parcelRequire("tsn8K");

var $cDkqb = parcelRequire("cDkqb");
var $07e93d5ebba64980$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $07e93d5ebba64980$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $07e93d5ebba64980$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $07e93d5ebba64980$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $07e93d5ebba64980$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $cDkqb.isElement)(reference) ? (0, $aaQJm.default)(reference) : reference.contextElement ? (0, $aaQJm.default)(reference.contextElement) : [],
                    popper: (0, $aaQJm.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9qBJp.default)((0, $kROea.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$07e93d5ebba64980$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gdOna.default)(reference, (0, $fUgdz.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $eh08t.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bdwJx.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$07e93d5ebba64980$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $07e93d5ebba64980$export$8f7491d57c8f97a9 = /*#__PURE__*/ $07e93d5ebba64980$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gdOna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcf4ef388a823bc9$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");

var $e7pSV = parcelRequire("e7pSV");

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");

var $gjBXX = parcelRequire("gjBXX");

var $bxA65 = parcelRequire("bxA65");

var $8Sm8F = parcelRequire("8Sm8F");

var $gU5NM = parcelRequire("gU5NM");
function $bcf4ef388a823bc9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $gU5NM.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $gU5NM.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcf4ef388a823bc9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $cDkqb.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $cDkqb.isHTMLElement)(offsetParent) && $bcf4ef388a823bc9$var$isElementScaled(offsetParent);
    var documentElement = (0, $bxA65.default)(offsetParent);
    var rect = (0, $hYSQh.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lGz8v.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8Sm8F.default)(documentElement)) scroll = (0, $e7pSV.default)(offsetParent);
        if ((0, $cDkqb.isHTMLElement)(offsetParent)) {
            offsets = (0, $hYSQh.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gjBXX.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("e7pSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a475cc5521e41d7d$export$2e2bcd8739ae039; });

var $2DsKR = parcelRequire("2DsKR");

var $hJIkn = parcelRequire("hJIkn");

var $cDkqb = parcelRequire("cDkqb");

var $9xxW5 = parcelRequire("9xxW5");
function $a475cc5521e41d7d$export$2e2bcd8739ae039(node) {
    if (node === (0, $hJIkn.default)(node) || !(0, $cDkqb.isHTMLElement)(node)) return (0, $2DsKR.default)(node);
    else return (0, $9xxW5.default)(node);
}

});
parcelRegister("9xxW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f2185148431c44f$export$2e2bcd8739ae039; });
function $6f2185148431c44f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("9qBJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dd3cf6958dfec1c$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");
function $6dd3cf6958dfec1c$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6dd3cf6958dfec1c$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6dd3cf6958dfec1c$var$order(modifiers); // order based on phase
    return (0, $btpzK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("bdwJx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82aa4cc99a13f2fb$export$2e2bcd8739ae039; });
function $82aa4cc99a13f2fb$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kROea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f30fb806ca61d5ef$export$2e2bcd8739ae039; });
function $f30fb806ca61d5ef$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("2DJ76", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $1ec237e15b54606b$export$8f7491d57c8f97a9; });

var $G6QZI = parcelRequire("G6QZI");

var $5sIsH = parcelRequire("5sIsH");

var $l20wA = parcelRequire("l20wA");

var $eFHzI = parcelRequire("eFHzI");

var $8OgMA = parcelRequire("8OgMA");

var $7fD8B = parcelRequire("7fD8B");

var $92JYe = parcelRequire("92JYe");

var $f6dYH = parcelRequire("f6dYH");

var $2UESB = parcelRequire("2UESB");

var $kK0ry = parcelRequire("kK0ry");


var $1ec237e15b54606b$export$d34966752335dd47 = [
    (0, $5sIsH.default),
    (0, $l20wA.default),
    (0, $eFHzI.default),
    (0, $8OgMA.default),
    (0, $7fD8B.default),
    (0, $92JYe.default),
    (0, $f6dYH.default),
    (0, $2UESB.default),
    (0, $kK0ry.default)
];
var $1ec237e15b54606b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $G6QZI.popperGenerator)({
    defaultModifiers: $1ec237e15b54606b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("apoHu", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $793f6628a41ce76a$export$8f7491d57c8f97a9; });

var $G6QZI = parcelRequire("G6QZI");

var $5sIsH = parcelRequire("5sIsH");

var $l20wA = parcelRequire("l20wA");

var $eFHzI = parcelRequire("eFHzI");

var $8OgMA = parcelRequire("8OgMA");
var $793f6628a41ce76a$export$d34966752335dd47 = [
    (0, $5sIsH.default),
    (0, $l20wA.default),
    (0, $eFHzI.default),
    (0, $8OgMA.default)
];
var $793f6628a41ce76a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $G6QZI.popperGenerator)({
    defaultModifiers: $793f6628a41ce76a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});




// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
// const channels = require.context('.', true, /_channel\.js$/)
var $6ab1598260440e8f$exports = {};
var $8fa03aeabc0c0ee2$exports = {};

var $9Cb2l = parcelRequire("9Cb2l");
document.addEventListener('DOMContentLoaded', ()=>{
    const advisor = document.querySelector('#advisor-id');
    if (!advisor) return;
    let advisor_id = advisor.getAttribute('data-advisor-id');
    if (advisor_id) (0, $9Cb2l.default).subscriptions.create({
        channel: "AdvisorChannel",
        advisor_id: advisor_id
    }, {
        connected () {
            console.log('connected to advisor channel');
        },
        disconnected () {
            console.log('disconnected from advisor channel');
        },
        received (data) {
            var studentDiv = document.querySelector("[data-student-id='" + data.student_id + "'].student");
            if (data.student_id && studentDiv) studentDiv.innerHTML = data.html_data;
        }
    });
});



var $oT77L = parcelRequire("oT77L");

var $716RA = parcelRequire("716RA");
$6ab1598260440e8f$exports = {
    "advisor": $8fa03aeabc0c0ee2$exports,
    "repeater": $oT77L,
    "stream": $716RA
};




/*!
 * Ahoy.js v0.4.4
 * Simple, powerful JavaScript analytics
 * https://github.com/ankane/ahoy.js
 * MIT License
 */ // https://www.quirksmode.org/js/cookies.html
var $522b52bd1bdce178$var$Cookies = {
    set: function(name, value, ttl, domain) {
        var expires = "";
        var cookieDomain = "";
        if (ttl) {
            var date = new Date();
            date.setTime(date.getTime() + ttl * 60000);
            expires = "; expires=" + date.toGMTString();
        }
        if (domain) cookieDomain = "; domain=" + domain;
        document.cookie = name + "=" + escape(value) + expires + cookieDomain + "; path=/; samesite=lax";
    },
    get: function(name) {
        var i, c;
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(i = 0; i < ca.length; i++){
            c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return unescape(c.substring(nameEQ.length, c.length));
        }
        return null;
    }
};
var $522b52bd1bdce178$var$config = {
    urlPrefix: "",
    visitsUrl: "/ahoy/visits",
    eventsUrl: "/ahoy/events",
    page: null,
    platform: "Web",
    useBeacon: true,
    startOnReady: true,
    trackVisits: true,
    cookies: true,
    cookieDomain: null,
    headers: {},
    visitParams: {},
    withCredentials: false,
    visitDuration: 240,
    visitorDuration: 1051200 // default 2 years
};
var $522b52bd1bdce178$export$2e2bcd8739ae039 = window.ahoy || window.Ahoy || {};
$522b52bd1bdce178$export$2e2bcd8739ae039.configure = function(options) {
    for(var key in options)if (Object.prototype.hasOwnProperty.call(options, key)) $522b52bd1bdce178$var$config[key] = options[key];
};
// legacy
$522b52bd1bdce178$export$2e2bcd8739ae039.configure($522b52bd1bdce178$export$2e2bcd8739ae039);
var $522b52bd1bdce178$var$$ = window.jQuery || window.Zepto || window.$;
var $522b52bd1bdce178$var$visitId, $522b52bd1bdce178$var$visitorId, $522b52bd1bdce178$var$track;
var $522b52bd1bdce178$var$isReady = false;
var $522b52bd1bdce178$var$queue = [];
var $522b52bd1bdce178$var$canStringify = typeof JSON !== "undefined" && typeof JSON.stringify !== "undefined";
var $522b52bd1bdce178$var$eventQueue = [];
function $522b52bd1bdce178$var$visitsUrl() {
    return $522b52bd1bdce178$var$config.urlPrefix + $522b52bd1bdce178$var$config.visitsUrl;
}
function $522b52bd1bdce178$var$eventsUrl() {
    return $522b52bd1bdce178$var$config.urlPrefix + $522b52bd1bdce178$var$config.eventsUrl;
}
function $522b52bd1bdce178$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $522b52bd1bdce178$var$canTrackNow() {
    return ($522b52bd1bdce178$var$config.useBeacon || $522b52bd1bdce178$var$config.trackNow) && $522b52bd1bdce178$var$isEmpty($522b52bd1bdce178$var$config.headers) && $522b52bd1bdce178$var$canStringify && typeof window.navigator.sendBeacon !== "undefined" && !$522b52bd1bdce178$var$config.withCredentials;
}
function $522b52bd1bdce178$var$serialize(object) {
    var data = new FormData();
    for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) data.append(key, object[key]);
    return data;
}
// cookies
function $522b52bd1bdce178$var$setCookie(name, value, ttl) {
    $522b52bd1bdce178$var$Cookies.set(name, value, ttl, $522b52bd1bdce178$var$config.cookieDomain || $522b52bd1bdce178$var$config.domain);
}
function $522b52bd1bdce178$var$getCookie(name) {
    return $522b52bd1bdce178$var$Cookies.get(name);
}
function $522b52bd1bdce178$var$destroyCookie(name) {
    $522b52bd1bdce178$var$Cookies.set(name, "", -1);
}
function $522b52bd1bdce178$var$log(message) {
    if ($522b52bd1bdce178$var$getCookie("ahoy_debug")) window.console.log(message);
}
function $522b52bd1bdce178$var$setReady() {
    var callback;
    while(callback = $522b52bd1bdce178$var$queue.shift())callback();
    $522b52bd1bdce178$var$isReady = true;
}
$522b52bd1bdce178$export$2e2bcd8739ae039.ready = function(callback) {
    if ($522b52bd1bdce178$var$isReady) callback();
    else $522b52bd1bdce178$var$queue.push(callback);
};
function $522b52bd1bdce178$var$matchesSelector(element, selector) {
    var matches = element.matches || element.matchesSelector || element.mozMatchesSelector || element.msMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;
    if (matches) {
        if (matches.apply(element, [
            selector
        ])) return element;
        else if (element.parentElement) return $522b52bd1bdce178$var$matchesSelector(element.parentElement, selector);
        return null;
    } else {
        $522b52bd1bdce178$var$log("Unable to match");
        return null;
    }
}
function $522b52bd1bdce178$var$onEvent(eventName, selector, callback) {
    document.addEventListener(eventName, function(e) {
        var matchedElement = $522b52bd1bdce178$var$matchesSelector(e.target, selector);
        if (matchedElement) {
            var skip = $522b52bd1bdce178$var$getClosest(matchedElement, "data-ahoy-skip");
            if (skip !== null && skip !== "false") return;
            callback.call(matchedElement, e);
        }
    });
}
// http://beeker.io/jquery-document-ready-equivalent-vanilla-javascript
function $522b52bd1bdce178$var$documentReady(callback) {
    if (document.readyState === "interactive" || document.readyState === "complete") setTimeout(callback, 0);
    else document.addEventListener("DOMContentLoaded", callback);
}
// https://stackoverflow.com/a/2117523/1177228
function $522b52bd1bdce178$var$generateId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $522b52bd1bdce178$var$saveEventQueue() {
    if ($522b52bd1bdce178$var$config.cookies && $522b52bd1bdce178$var$canStringify) $522b52bd1bdce178$var$setCookie("ahoy_events", JSON.stringify($522b52bd1bdce178$var$eventQueue), 1);
}
// from rails-ujs
function $522b52bd1bdce178$var$csrfToken() {
    var meta = document.querySelector("meta[name=csrf-token]");
    return meta && meta.content;
}
function $522b52bd1bdce178$var$csrfParam() {
    var meta = document.querySelector("meta[name=csrf-param]");
    return meta && meta.content;
}
function $522b52bd1bdce178$var$CSRFProtection(xhr) {
    var token = $522b52bd1bdce178$var$csrfToken();
    if (token) xhr.setRequestHeader("X-CSRF-Token", token);
}
function $522b52bd1bdce178$var$sendRequest(url, data, success) {
    if ($522b52bd1bdce178$var$canStringify) {
        if ($522b52bd1bdce178$var$$ && $522b52bd1bdce178$var$$.ajax) $522b52bd1bdce178$var$$.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            beforeSend: $522b52bd1bdce178$var$CSRFProtection,
            success: success,
            headers: $522b52bd1bdce178$var$config.headers,
            xhrFields: {
                withCredentials: $522b52bd1bdce178$var$config.withCredentials
            }
        });
        else {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.withCredentials = $522b52bd1bdce178$var$config.withCredentials;
            xhr.setRequestHeader("Content-Type", "application/json");
            for(var header in $522b52bd1bdce178$var$config.headers)if (Object.prototype.hasOwnProperty.call($522b52bd1bdce178$var$config.headers, header)) xhr.setRequestHeader(header, $522b52bd1bdce178$var$config.headers[header]);
            xhr.onload = function() {
                if (xhr.status === 200) success();
            };
            $522b52bd1bdce178$var$CSRFProtection(xhr);
            xhr.send(JSON.stringify(data));
        }
    }
}
function $522b52bd1bdce178$var$eventData(event) {
    var data = {
        events: [
            event
        ]
    };
    if ($522b52bd1bdce178$var$config.cookies) {
        data.visit_token = event.visit_token;
        data.visitor_token = event.visitor_token;
    }
    delete event.visit_token;
    delete event.visitor_token;
    return data;
}
function $522b52bd1bdce178$var$trackEvent(event) {
    $522b52bd1bdce178$export$2e2bcd8739ae039.ready(function() {
        $522b52bd1bdce178$var$sendRequest($522b52bd1bdce178$var$eventsUrl(), $522b52bd1bdce178$var$eventData(event), function() {
            // remove from queue
            for(var i = 0; i < $522b52bd1bdce178$var$eventQueue.length; i++)if ($522b52bd1bdce178$var$eventQueue[i].id === event.id) {
                $522b52bd1bdce178$var$eventQueue.splice(i, 1);
                break;
            }
            $522b52bd1bdce178$var$saveEventQueue();
        });
    });
}
function $522b52bd1bdce178$var$trackEventNow(event) {
    $522b52bd1bdce178$export$2e2bcd8739ae039.ready(function() {
        var data = $522b52bd1bdce178$var$eventData(event);
        var param = $522b52bd1bdce178$var$csrfParam();
        var token = $522b52bd1bdce178$var$csrfToken();
        if (param && token) data[param] = token;
        // stringify so we keep the type
        data.events_json = JSON.stringify(data.events);
        delete data.events;
        window.navigator.sendBeacon($522b52bd1bdce178$var$eventsUrl(), $522b52bd1bdce178$var$serialize(data));
    });
}
function $522b52bd1bdce178$var$page() {
    return $522b52bd1bdce178$var$config.page || window.location.pathname;
}
function $522b52bd1bdce178$var$presence(str) {
    return str && str.length > 0 ? str : null;
}
function $522b52bd1bdce178$var$cleanObject(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (obj[key] === null) delete obj[key];
        }
    }
    return obj;
}
function $522b52bd1bdce178$var$eventProperties() {
    return $522b52bd1bdce178$var$cleanObject({
        tag: this.tagName.toLowerCase(),
        id: $522b52bd1bdce178$var$presence(this.id),
        "class": $522b52bd1bdce178$var$presence(this.className),
        page: $522b52bd1bdce178$var$page(),
        section: $522b52bd1bdce178$var$getClosest(this, "data-section")
    });
}
function $522b52bd1bdce178$var$getClosest(element, attribute) {
    for(; element && element !== document; element = element.parentNode){
        if (element.hasAttribute(attribute)) return element.getAttribute(attribute);
    }
    return null;
}
function $522b52bd1bdce178$var$createVisit() {
    $522b52bd1bdce178$var$isReady = false;
    $522b52bd1bdce178$var$visitId = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitId();
    $522b52bd1bdce178$var$visitorId = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitorId();
    $522b52bd1bdce178$var$track = $522b52bd1bdce178$var$getCookie("ahoy_track");
    if ($522b52bd1bdce178$var$config.cookies === false || $522b52bd1bdce178$var$config.trackVisits === false) {
        $522b52bd1bdce178$var$log("Visit tracking disabled");
        $522b52bd1bdce178$var$setReady();
    } else if ($522b52bd1bdce178$var$visitId && $522b52bd1bdce178$var$visitorId && !$522b52bd1bdce178$var$track) {
        // TODO keep visit alive?
        $522b52bd1bdce178$var$log("Active visit");
        $522b52bd1bdce178$var$setReady();
    } else {
        if (!$522b52bd1bdce178$var$visitId) {
            $522b52bd1bdce178$var$visitId = $522b52bd1bdce178$var$generateId();
            $522b52bd1bdce178$var$setCookie("ahoy_visit", $522b52bd1bdce178$var$visitId, $522b52bd1bdce178$var$config.visitDuration);
        }
        // make sure cookies are enabled
        if ($522b52bd1bdce178$var$getCookie("ahoy_visit")) {
            $522b52bd1bdce178$var$log("Visit started");
            if (!$522b52bd1bdce178$var$visitorId) {
                $522b52bd1bdce178$var$visitorId = $522b52bd1bdce178$var$generateId();
                $522b52bd1bdce178$var$setCookie("ahoy_visitor", $522b52bd1bdce178$var$visitorId, $522b52bd1bdce178$var$config.visitorDuration);
            }
            var data = {
                visit_token: $522b52bd1bdce178$var$visitId,
                visitor_token: $522b52bd1bdce178$var$visitorId,
                platform: $522b52bd1bdce178$var$config.platform,
                landing_page: window.location.href,
                screen_width: window.screen.width,
                screen_height: window.screen.height,
                js: true
            };
            // referrer
            if (document.referrer.length > 0) data.referrer = document.referrer;
            for(var key in $522b52bd1bdce178$var$config.visitParams)if (Object.prototype.hasOwnProperty.call($522b52bd1bdce178$var$config.visitParams, key)) data[key] = $522b52bd1bdce178$var$config.visitParams[key];
            $522b52bd1bdce178$var$log(data);
            $522b52bd1bdce178$var$sendRequest($522b52bd1bdce178$var$visitsUrl(), data, function() {
                // wait until successful to destroy
                $522b52bd1bdce178$var$destroyCookie("ahoy_track");
                $522b52bd1bdce178$var$setReady();
            });
        } else {
            $522b52bd1bdce178$var$log("Cookies disabled");
            $522b52bd1bdce178$var$setReady();
        }
    }
}
$522b52bd1bdce178$export$2e2bcd8739ae039.getVisitId = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitToken = function() {
    return $522b52bd1bdce178$var$getCookie("ahoy_visit");
};
$522b52bd1bdce178$export$2e2bcd8739ae039.getVisitorId = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitorToken = function() {
    return $522b52bd1bdce178$var$getCookie("ahoy_visitor");
};
$522b52bd1bdce178$export$2e2bcd8739ae039.reset = function() {
    $522b52bd1bdce178$var$destroyCookie("ahoy_visit");
    $522b52bd1bdce178$var$destroyCookie("ahoy_visitor");
    $522b52bd1bdce178$var$destroyCookie("ahoy_events");
    $522b52bd1bdce178$var$destroyCookie("ahoy_track");
    return true;
};
$522b52bd1bdce178$export$2e2bcd8739ae039.debug = function(enabled) {
    if (enabled === false) $522b52bd1bdce178$var$destroyCookie("ahoy_debug");
    else $522b52bd1bdce178$var$setCookie("ahoy_debug", "t", 525600); // 1 year
    return true;
};
$522b52bd1bdce178$export$2e2bcd8739ae039.track = function(name, properties) {
    // generate unique id
    var event = {
        name: name,
        properties: properties || {},
        time: new Date().getTime() / 1000.0,
        id: $522b52bd1bdce178$var$generateId(),
        js: true
    };
    $522b52bd1bdce178$export$2e2bcd8739ae039.ready(function() {
        if ($522b52bd1bdce178$var$config.cookies && !$522b52bd1bdce178$export$2e2bcd8739ae039.getVisitId()) $522b52bd1bdce178$var$createVisit();
        $522b52bd1bdce178$export$2e2bcd8739ae039.ready(function() {
            $522b52bd1bdce178$var$log(event);
            event.visit_token = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitId();
            event.visitor_token = $522b52bd1bdce178$export$2e2bcd8739ae039.getVisitorId();
            if ($522b52bd1bdce178$var$canTrackNow()) $522b52bd1bdce178$var$trackEventNow(event);
            else {
                $522b52bd1bdce178$var$eventQueue.push(event);
                $522b52bd1bdce178$var$saveEventQueue();
                // wait in case navigating to reduce duplicate events
                setTimeout(function() {
                    $522b52bd1bdce178$var$trackEvent(event);
                }, 1000);
            }
        });
    });
    return true;
};
$522b52bd1bdce178$export$2e2bcd8739ae039.trackView = function(additionalProperties) {
    var properties = {
        url: window.location.href,
        title: document.title,
        page: $522b52bd1bdce178$var$page()
    };
    if (additionalProperties) {
        for(var propName in additionalProperties)if (Object.prototype.hasOwnProperty.call(additionalProperties, propName)) properties[propName] = additionalProperties[propName];
    }
    $522b52bd1bdce178$export$2e2bcd8739ae039.track("$view", properties);
};
$522b52bd1bdce178$export$2e2bcd8739ae039.trackClicks = function(selector) {
    if (selector === undefined) throw new Error("Missing selector");
    $522b52bd1bdce178$var$onEvent("click", selector, function(e) {
        var properties = $522b52bd1bdce178$var$eventProperties.call(this, e);
        properties.text = properties.tag === "input" ? this.value : (this.textContent || this.innerText || this.innerHTML).replace(/[\s\r\n]+/g, " ").trim();
        properties.href = this.href;
        $522b52bd1bdce178$export$2e2bcd8739ae039.track("$click", properties);
    });
};
$522b52bd1bdce178$export$2e2bcd8739ae039.trackSubmits = function(selector) {
    if (selector === undefined) throw new Error("Missing selector");
    $522b52bd1bdce178$var$onEvent("submit", selector, function(e) {
        var properties = $522b52bd1bdce178$var$eventProperties.call(this, e);
        $522b52bd1bdce178$export$2e2bcd8739ae039.track("$submit", properties);
    });
};
$522b52bd1bdce178$export$2e2bcd8739ae039.trackChanges = function(selector) {
    $522b52bd1bdce178$var$log("trackChanges is deprecated and will be removed in 0.5.0");
    if (selector === undefined) throw new Error("Missing selector");
    $522b52bd1bdce178$var$onEvent("change", selector, function(e) {
        var properties = $522b52bd1bdce178$var$eventProperties.call(this, e);
        $522b52bd1bdce178$export$2e2bcd8739ae039.track("$change", properties);
    });
};
// push events from queue
try {
    $522b52bd1bdce178$var$eventQueue = JSON.parse($522b52bd1bdce178$var$getCookie("ahoy_events") || "[]");
} catch (e) {
// do nothing
}
for(var $522b52bd1bdce178$var$i = 0; $522b52bd1bdce178$var$i < $522b52bd1bdce178$var$eventQueue.length; $522b52bd1bdce178$var$i++)$522b52bd1bdce178$var$trackEvent($522b52bd1bdce178$var$eventQueue[$522b52bd1bdce178$var$i]);
$522b52bd1bdce178$export$2e2bcd8739ae039.start = function() {
    $522b52bd1bdce178$var$createVisit();
    $522b52bd1bdce178$export$2e2bcd8739ae039.start = function() {};
};
$522b52bd1bdce178$var$documentReady(function() {
    if ($522b52bd1bdce178$var$config.startOnReady) $522b52bd1bdce178$export$2e2bcd8739ae039.start();
});


parcelRequire("6p2TQ");
parcelRequire("brnsE");
if (window.location.pathname.includes("/play") || window.location.hostname.includes("play.socialcipher.com")) {
    (0, $522b52bd1bdce178$export$2e2bcd8739ae039).configure({
        cookies: false
    });
    window.ahoy = (0, $522b52bd1bdce178$export$2e2bcd8739ae039);
    window.ICE_SERVERS = JSON.parse(document.querySelector("meta[name='ice-servers']").getAttribute("content"));
    const dataUrl = document.querySelector("meta[name='data-url']").getAttribute("content");
    const frameworkUrl = document.querySelector("meta[name='framework-url']").getAttribute("content");
    const codeUrl = document.querySelector("meta[name='code-url']").getAttribute("content");
    window.onbeforeunload = function() {
        return "";
    };
    const handleError = (message)=>{
        document.querySelector("#error-message").classList.remove("d-none");
        throw message;
    };
    window.getStudentCode = function() {
        return window.GLOBAL_STUDENT_CODE || "0";
    };
    window.fullScreen = function() {
        if (window.unity) window.unity.SetFullscreen(true);
    };
    function startUnity() {
        console.log("startUnity");
        var startTime = new Date().getTime();
        (0, $522b52bd1bdce178$export$2e2bcd8739ae039).track("Started Download", {
            start_time: startTime
        });
        var progress_bar = document.querySelector(".progress-bar");
        document.querySelector(".load-container").style.display = "";
        const unityContainer = document.querySelector("#unity-canvas");
        const config = {
            companyName: "SocialCipher",
            productName: "Ava",
            productVersion: "6.0.0",
            // dataUrl: "#{cloud_front_file_url(@game.data)}",
            dataUrl: dataUrl,
            // frameworkUrl: "#{cloud_front_file_url(@game.framework)}",
            frameworkUrl: frameworkUrl,
            // codeUrl: "#{cloud_front_file_url(@game.code)}"
            codeUrl: codeUrl
        };
        setTimeout(()=>{
            createUnityInstance(unityContainer, config, (progress)=>{
                var pct = progress * 100 | 0;
                progress_bar.style.width = pct + "%";
                progress_bar.textContent = pct + "%";
            }).then((unityInstance)=>{
                window.unity = unityInstance;
                document.querySelector(".load-container").style.display = "none";
                var endTime = new Date().getTime();
                (0, $522b52bd1bdce178$export$2e2bcd8739ae039).track("Completed Download", {
                    recorded_local_duration: endTime - startTime,
                    end_time: endTime
                });
            }).catch(handleError);
        }, 1000);
    }
    document.addEventListener("DOMContentLoaded", ()=>{
        try {
            // fullscreen button
            document.querySelector(".fullscreen").addEventListener("click", fullScreen);
            // Student play links can supply a play code directly.
            const params = new URLSearchParams(window.location.search);
            window.GLOBAL_STUDENT_CODE = params.get("sso") ? params.get("student_code") : null;
            startUnity();
        } catch (error) {
            console.error(error);
            startUnity();
        }
    });
}

})();
//# sourceMappingURL=game.js.map
